import { Quiz } from '@/types/quiz';

export const quizAll: Quiz[] = [
  {
    quizId: '1',
    question: 'サイコーは第十一回児童生徒美術展でどのような成績を修めた？',
    options: [
      { optionId: '0', text: '準特選' },
      { optionId: '1', text: '優秀特選' },
      { optionId: '2', text: '特選' },
      { optionId: '3', text: '金賞' },
      { optionId: '4', text: '特別賞' },
    ],
  },
  {
    quizId: '2',
    question:
      '冒頭、小学生時代のサイコー部屋で『超ヒーロー伝説』の隣に並べられていたマンガは？',
    options: [
      { optionId: '0', text: 'キントレマン' },
      { optionId: '1', text: 'SRUME DUNK' },
      { optionId: '2', text: '聖・ラマン' },
      { optionId: '3', text: '巨人の月' },
      { optionId: '4', text: 'るろうの剣士' },
    ],
  },
  {
    quizId: '3',
    question:
      'サイコーのモノローグより問題です。\n『最近読んだ偉そうな哲学者？思想家？の本に\n「人生における最大のイベント 最高の生き甲斐は○○である」\nとあった』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '恋愛' },
      { optionId: '1', text: '情熱' },
      { optionId: '2', text: '夢' },
      { optionId: '3', text: '誕生' },
      { optionId: '4', text: '発明' },
    ],
  },
  {
    quizId: '4',
    question:
      'サイコーとシュージンが組むきっかけになった、サイコ―の学校への忘れものは？',
    options: [
      { optionId: '0', text: '数学のノート' },
      { optionId: '1', text: '国語のノート' },
      { optionId: '2', text: '手帳' },
      { optionId: '3', text: '数学の教科書' },
      { optionId: '4', text: '国語の教科書' },
    ],
  },
  {
    quizId: '5',
    question:
      'コンビを組む前、サイコーもそうとうマンガ好きだと、シュージンが感じた台詞は？',
    options: [
      { optionId: '0', text: '「だが断る」' },
      { optionId: '1', text: '「俺はサイコ― 諦めの悪い男」' },
      { optionId: '2', text: '「人から言われてやった練習は努力とは言わない」' },
      { optionId: '3', text: '「お前にゃ無理だ 高木」' },
      { optionId: '4', text: '「これでいいのだ！」' },
    ],
  },
  {
    quizId: '6',
    question:
      'サイコーの台詞より問題です。\n「マンガ家なんてなれねーよ なれるのは本当に才能を持って生まれたごく一部の天才\nあとはただの○○」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '博打打ち' },
      { optionId: '1', text: 'ニート' },
      { optionId: '2', text: 'マンガ家ごっこ' },
      { optionId: '3', text: '夢見人' },
      { optionId: '4', text: '強運' },
    ],
  },
  {
    quizId: '7',
    question: 'サイコーはマンガ家を目指して一生食えるのは何％と言っていた？',
    options: [
      { optionId: '0', text: '0.00001' },
      { optionId: '1', text: '0.0001' },
      { optionId: '2', text: '0.001' },
      { optionId: '3', text: '0.01' },
      { optionId: '4', text: '0.000001' },
    ],
  },
  {
    quizId: '8',
    question: '川口たろうの代表作は？',
    options: [
      { optionId: '0', text: '超ヒーロー伝説' },
      { optionId: '1', text: 'とっても！ ハッピーマン' },
      { optionId: '2', text: 'ラッキーレンジャーズ' },
      { optionId: '3', text: 'レジェンドバトル スーパーヒーローズ' },
      { optionId: '4', text: 'かけだしヒーロー物語' },
    ],
  },
  {
    quizId: '9',
    question:
      '真城最高に\n「おじさんは何でマンガ家になったの？」\nと聞かれ、川口たろうはどのような理由を答えた？',
    options: [
      { optionId: '0', text: '女にモテたかったから' },
      { optionId: '1', text: '何でだろうな？' },
      { optionId: '2', text: 'マンガが好きだったから' },
      { optionId: '3', text: '絵が上手かったから' },
      { optionId: '4', text: '一番になりたかったから' },
    ],
  },
  {
    quizId: '10',
    question: '真城信弘が中学卒業時に春野美雪から貰った手紙の内容は？',
    options: [
      { optionId: '0', text: 'お互いこれからも頑張りましょーみたいな事' },
      { optionId: '1', text: 'これからどうします？ みたいな事' },
      { optionId: '2', text: '文通しませんか？ みたいな事' },
      { optionId: '3', text: 'それぞれの道を歩みましょーみたいな事' },
      { optionId: '4', text: '将来の夢みたいな事' },
    ],
  },
  {
    quizId: '11',
    question: '川口たろうが月刊誌で初連載したのはいつ？',
    options: [
      { optionId: '0', text: '大学4年の時' },
      { optionId: '1', text: '高校3年の時' },
      { optionId: '2', text: '大学2年の時' },
      { optionId: '3', text: '25歳の時' },
      { optionId: '4', text: '26歳の時' },
    ],
  },
  {
    quizId: '12',
    question: '川口たろうが月刊誌で初連載した作品タイトルは？',
    options: [
      { optionId: '0', text: 'ハッピーレンジャー' },
      { optionId: '1', text: '超ヒーロー伝説' },
      { optionId: '2', text: 'とっても！ ハッピーマン' },
      { optionId: '3', text: 'レジェンドバトル スーパーヒーローズ' },
      { optionId: '4', text: 'かけだしヒーロー物語' },
    ],
  },
  {
    quizId: '13',
    question: '真城信弘が死んだのは真城最高がどのくらいのとき？',
    options: [
      { optionId: '0', text: '小6' },
      { optionId: '1', text: '小4' },
      { optionId: '2', text: '小5' },
      { optionId: '3', text: '中1' },
      { optionId: '4', text: '中2' },
    ],
  },
  {
    quizId: '14',
    question: '真城信弘の死因は？',
    options: [
      { optionId: '0', text: '過労死' },
      { optionId: '1', text: '自殺' },
      { optionId: '2', text: '交通事故' },
      { optionId: '3', text: '脳梗塞' },
      { optionId: '4', text: '肺がん' },
    ],
  },
  {
    quizId: '15',
    question:
      '『超ヒーロー伝説』のアニメ化以降、川口たろうが発表した連載作品数は？',
    options: [
      { optionId: '0', text: '2作品' },
      { optionId: '1', text: '0作品' },
      { optionId: '2', text: '1作品' },
      { optionId: '3', text: '3作品' },
      { optionId: '4', text: '4作品' },
    ],
  },
  {
    quizId: '16',
    question: 'サイコーの当初の志望高校は？',
    options: [
      { optionId: '0', text: '南高' },
      { optionId: '1', text: '北高' },
      { optionId: '2', text: '西高' },
      { optionId: '3', text: '東高' },
      { optionId: '4', text: '中高' },
    ],
  },
  {
    quizId: '17',
    question: 'シュージンはサイコーの携帯番号をどのように入手した？',
    options: [
      { optionId: '0', text: '鈴木に聞いた' },
      { optionId: '1', text: 'サイコ―に聞いた' },
      { optionId: '2', text: 'こっそり携帯電話を覗いた' },
      { optionId: '3', text: '携帯電話を奪った' },
      { optionId: '4', text: '亜豆美保から聞いた' },
    ],
  },
  {
    quizId: '18',
    question:
      'マンガ家を目指すことを亜豆に告白に行ったとき、サイコーとシュージンはとこで待ち合わせた？',
    options: [
      { optionId: '0', text: '西町のローソン' },
      { optionId: '1', text: '東町のファミマ' },
      { optionId: '2', text: '南町のセブンイレブン' },
      { optionId: '3', text: '南町のローソン' },
      { optionId: '4', text: '西町のファミマ' },
    ],
  },
  {
    quizId: '19',
    question: '亜豆に告白した後、真城最高が本屋で買ったものは？',
    options: [
      { optionId: '0', text: 'マンガの王者 初級編' },
      { optionId: '1', text: 'マンガの基礎' },
      { optionId: '2', text: 'マンガの達人 初心者編' },
      { optionId: '3', text: '週刊マンガの描き方' },
      { optionId: '4', text: '弟子入りシリーズ マンガ家編' },
    ],
  },
  {
    quizId: '20',
    question: '中学生時代、高木秋人のことを仲のいい奴は何と呼ぶ？',
    options: [
      { optionId: '0', text: 'シュート' },
      { optionId: '1', text: 'アキ' },
      { optionId: '2', text: 'シュージン' },
      { optionId: '3', text: 'アッキー' },
      { optionId: '4', text: 'タカアキ' },
    ],
  },
  {
    quizId: '21',
    question: '川口たろうの本名は？',
    options: [
      { optionId: '0', text: '真城信弘' },
      { optionId: '1', text: '真城昌弘' },
      { optionId: '2', text: '真城二三男' },
      { optionId: '3', text: '真城拓海' },
      { optionId: '4', text: '真城博' },
    ],
  },
  {
    quizId: '22',
    question:
      '中学三年時、シュージンは頭の良さでクラスで何番以内に入っていると思うと言っていた？',
    options: [
      { optionId: '0', text: '3番以内' },
      { optionId: '1', text: '1番以内' },
      { optionId: '2', text: '2番以内' },
      { optionId: '3', text: '4番以内' },
      { optionId: '4', text: '5番以内' },
    ],
  },
  {
    quizId: '23',
    question: '次の内、シュージンが嫌いだと言っていた偉人は？',
    options: [
      { optionId: '0', text: '福沢諭吉' },
      { optionId: '1', text: '夏目漱石' },
      { optionId: '2', text: '聖徳太子' },
      { optionId: '3', text: 'トーマス・エジソン' },
      { optionId: '4', text: '徳川綱吉' },
    ],
  },
  {
    quizId: '24',
    question:
      '亜城木夢叶の仕事場の鍵についているキーホルダーは何のキャラクター？',
    options: [
      { optionId: '0', text: '超ヒーロー伝説' },
      { optionId: '1', text: 'DRAGON BALL' },
      { optionId: '2', text: 'ONE PIECE' },
      { optionId: '3', text: 'DEATH NOTE' },
      { optionId: '4', text: 'まじかる☆タルるートくん' },
    ],
  },
  {
    quizId: '25',
    question: '真城家の最寄り駅は？',
    options: [
      { optionId: '0', text: '北谷草' },
      { optionId: '1', text: '南谷草' },
      { optionId: '2', text: '西谷草' },
      { optionId: '3', text: '東谷草' },
      { optionId: '4', text: '谷草' },
    ],
  },
  {
    quizId: '26',
    question: '亜城木夢叶の仕事場がある場所は？',
    options: [
      { optionId: '0', text: '谷草' },
      { optionId: '1', text: '北谷草' },
      { optionId: '2', text: '南谷草' },
      { optionId: '3', text: '西谷草' },
      { optionId: '4', text: '東谷草' },
    ],
  },
  {
    quizId: '27',
    question: '亜城木夢叶の仕事場はマンションの何階？',
    options: [
      { optionId: '0', text: '9階' },
      { optionId: '1', text: '3階' },
      { optionId: '2', text: '5階' },
      { optionId: '3', text: '7階' },
      { optionId: '4', text: '13階' },
    ],
  },
  {
    quizId: '28',
    question: '川口たろうの言う、マンガの一番の資料は？',
    options: [
      { optionId: '0', text: 'マンガ' },
      { optionId: '1', text: '経験' },
      { optionId: '2', text: '編集' },
      { optionId: '3', text: '日常生活' },
      { optionId: '4', text: '青春' },
    ],
  },
  {
    quizId: '29',
    question: '川口たろうがマンガを描く際によく使っていたペンは？',
    options: [
      { optionId: '0', text: 'カブラペン' },
      { optionId: '1', text: 'Gペン' },
      { optionId: '2', text: '丸ペン' },
      { optionId: '3', text: 'スクールペン' },
      { optionId: '4', text: '羽根ペン' },
    ],
  },
  {
    quizId: '30',
    question: 'サイコーの一番好きなマンガは？',
    options: [
      { optionId: '0', text: 'あしたのジョー' },
      { optionId: '1', text: 'DRAGON BALL' },
      { optionId: '2', text: 'ＲＯＯＫＩＥＳ' },
      { optionId: '3', text: 'ブラック・ジャック' },
      { optionId: '4', text: '巨人の星' },
    ],
  },
  {
    quizId: '31',
    question:
      'マンガ家を目指し始めた頃、シュージンは人気マンガにある共通点を見つけたと言っていますが、その共通点とは？',
    options: [
      { optionId: '0', text: '刀' },
      { optionId: '1', text: '非日常' },
      { optionId: '2', text: '特殊能力' },
      { optionId: '3', text: '予定調和' },
      { optionId: '4', text: 'バトル' },
    ],
  },
  {
    quizId: '32',
    question: 'シュージンが一番好きなマンガは？',
    options: [
      { optionId: '0', text: 'DRAGON BALL' },
      { optionId: '1', text: 'あしたのジョー' },
      { optionId: '2', text: 'ＲＯＯＫＩＥＳ' },
      { optionId: '3', text: 'ブラック・ジャック' },
      { optionId: '4', text: '巨人の星' },
    ],
  },
  {
    quizId: '33',
    question: '亜豆美保の母親の結婚前のフルネームは？',
    options: [
      { optionId: '0', text: '春野美雪' },
      { optionId: '1', text: '榎本美里' },
      { optionId: '2', text: '秋月美紀' },
      { optionId: '3', text: '柊美奈' },
      { optionId: '4', text: '伊調美波' },
    ],
  },
  {
    quizId: '34',
    question: '超ヒーロー伝説の連載が始まったのはいつ？',
    options: [
      { optionId: '0', text: '平成7年20号' },
      { optionId: '1', text: '平成5年15号' },
      { optionId: '2', text: '平成6年37号' },
      { optionId: '3', text: '平成6年5号' },
      { optionId: '4', text: '平成7年13号' },
    ],
  },
  {
    quizId: '35',
    question: '真城信弘の通っていた中学校は？',
    options: [
      { optionId: '0', text: '谷草市立明陽中学校' },
      { optionId: '1', text: '谷草市立日下部中学校' },
      { optionId: '2', text: '谷草市立美竹中学校' },
      { optionId: '3', text: '谷草市立双島中学校' },
      { optionId: '4', text: '谷草市立橋塚中学校' },
    ],
  },
  {
    quizId: '36',
    question: '中学3年時、亜豆美保が水曜の5時から7時に習っていたのは？',
    options: [
      { optionId: '0', text: 'ダンス' },
      { optionId: '1', text: 'ボイストレーニング' },
      { optionId: '2', text: '演技' },
      { optionId: '3', text: '舞踊' },
      { optionId: '4', text: 'ペン字' },
    ],
  },
  {
    quizId: '37',
    question:
      'サイコーとシュージンが二人で初めて仕事場へ行ったとき、何時まで仕事場にいた？',
    options: [
      { optionId: '0', text: '深夜2時過ぎ' },
      { optionId: '1', text: '夜11時まで' },
      { optionId: '2', text: '深夜4時まで' },
      { optionId: '3', text: '朝7時まで' },
      { optionId: '4', text: '朝9時まで' },
    ],
  },
  {
    quizId: '38',
    question: '亜豆美保の母親の髪型は？',
    options: [
      { optionId: '0', text: '縦ロール' },
      { optionId: '1', text: '三つ編み' },
      { optionId: '2', text: 'ゆるふわウェーブ' },
      { optionId: '3', text: '編み込み' },
      { optionId: '4', text: 'ロングストレート' },
    ],
  },
  {
    quizId: '39',
    question: '真城の父親は中学のとき何部の主将を務めていた？',
    options: [
      { optionId: '0', text: '柔道部' },
      { optionId: '1', text: '野球部' },
      { optionId: '2', text: '剣道部' },
      { optionId: '3', text: 'サッカー部' },
      { optionId: '4', text: '卓球部' },
    ],
  },
  {
    quizId: '40',
    question:
      '亜豆の母親が超ヒーロー伝説を読んでちょっと泣いたのは、どのヒーローの話？',
    options: [
      { optionId: '0', text: '漢の浪マン' },
      { optionId: '1', text: '男のロ・マン' },
      { optionId: '2', text: '男の浪マン' },
      { optionId: '3', text: '漢のロ・マン' },
      { optionId: '4', text: 'オトコ鈍マン' },
    ],
  },
  {
    quizId: '41',
    question:
      '仕事場にある本の中で、サイコーがシュージンにまず読むように勧めた本は？',
    options: [
      { optionId: '0', text: '男の条件' },
      { optionId: '1', text: '巨人の星' },
      { optionId: '2', text: '父の魂' },
      { optionId: '3', text: 'あらし!三匹' },
      { optionId: '4', text: 'ROOKIES' },
    ],
  },
  {
    quizId: '42',
    question: '川口たろう流、マンガ家の三大条件は？',
    options: [
      { optionId: '0', text: 'うぬぼれ、努力、運' },
      { optionId: '1', text: '友情、努力、ひらめき' },
      { optionId: '2', text: 'ひらめき、努力、恋' },
      { optionId: '3', text: 'うぬぼれ、努力、恋' },
      { optionId: '4', text: 'わずかな才能、大きな努力、最大限のやる気' },
    ],
  },
  {
    quizId: '43',
    question: '新妻エイジが15歳のときに、手塚賞準入選した作品は？',
    options: [
      { optionId: '0', text: 'Large bander' },
      { optionId: '1', text: 'Haitenpepoo' },
      { optionId: '2', text: 'YELLOW HIT' },
      { optionId: '3', text: 'CROW' },
      { optionId: '4', text: 'Chain gold' },
    ],
  },
  {
    quizId: '44',
    question: '新妻エイジの出身地は？',
    options: [
      { optionId: '0', text: '青森' },
      { optionId: '1', text: '高知' },
      { optionId: '2', text: '東京' },
      { optionId: '3', text: '広島' },
      { optionId: '4', text: '熊本' },
    ],
  },
  {
    quizId: '45',
    question:
      'サイコーとシュージンが、出版社見学がてらにダメ原稿で応募しようとしていた雑誌は？',
    options: [
      { optionId: '0', text: '少年スリー' },
      { optionId: '1', text: '少年ウィーク' },
      { optionId: '2', text: '月刊ハッスル' },
      { optionId: '3', text: '少年キック' },
      { optionId: '4', text: 'マーガレット' },
    ],
  },
  {
    quizId: '46',
    question: '亜豆美保の4つ下の妹の名前は？',
    options: [
      { optionId: '0', text: '亜豆美奈' },
      { optionId: '1', text: '亜豆美春' },
      { optionId: '2', text: '亜豆美紀' },
      { optionId: '3', text: '亜豆美雪' },
      { optionId: '4', text: '亜豆美里' },
    ],
  },
  {
    quizId: '47',
    question: '真城最高は亜豆美保を初めて見たのはいつと言っていた？',
    options: [
      { optionId: '0', text: '小6の水泳大会' },
      { optionId: '1', text: '小4の市民祭' },
      { optionId: '2', text: '小5の林間学校' },
      { optionId: '3', text: '中1の入学式' },
      { optionId: '4', text: '中2の自然教室' },
    ],
  },
  {
    quizId: '48',
    question: 'サイコーとシュージンが初めて持ち込みした作品タイトルは？',
    options: [
      { optionId: '0', text: 'ふたつの地球' },
      { optionId: '1', text: '一億分の' },
      { optionId: '2', text: '探偵TRAP' },
      { optionId: '3', text: 'うさぎとカメラ' },
      { optionId: '4', text: '見えない教室' },
    ],
  },
  {
    quizId: '49',
    question: '初めての持ち込みする前、シュージンが考えていたスポ根マンガは？',
    options: [
      { optionId: '0', text: 'グラサンピッチャー' },
      { optionId: '1', text: 'スリーストライク' },
      { optionId: '2', text: '瀬尾一本投げ' },
      { optionId: '3', text: '先読みキーパー' },
      { optionId: '4', text: 'ハットトリック' },
    ],
  },
  {
    quizId: '50',
    question: '亜豆美保の中学三年時の出席番号は？',
    options: [
      { optionId: '0', text: '3番' },
      { optionId: '1', text: '1番' },
      { optionId: '2', text: '2番' },
      { optionId: '3', text: '4番' },
      { optionId: '4', text: '5番' },
    ],
  },
  {
    quizId: '51',
    question:
      '中学3年の1学期中間ではクラスで19番だったサイコーは、シュージンに勉強を教えてもらい期末ではどこまで順位が上がった？',
    options: [
      { optionId: '0', text: '6番' },
      { optionId: '1', text: '9番' },
      { optionId: '2', text: '13番' },
      { optionId: '3', text: '15番' },
      { optionId: '4', text: '18番' },
    ],
  },
  {
    quizId: '52',
    question:
      '中学3年の夏休み、マンガを描いていたサイコーの一日の睡眠時間はどのくらい？',
    options: [
      { optionId: '0', text: '4時間' },
      { optionId: '1', text: '3時間' },
      { optionId: '2', text: '5時間' },
      { optionId: '3', text: '6時間' },
      { optionId: '4', text: '7時間' },
    ],
  },
  {
    quizId: '53',
    question: '『ふたつの地球』が完成した日は？',
    options: [
      { optionId: '0', text: '39688' },
      { optionId: '1', text: '39805' },
      { optionId: '2', text: '39876' },
      { optionId: '3', text: '40053' },
      { optionId: '4', text: '40170' },
    ],
  },
  {
    quizId: '54',
    question: '『バクマン。』2巻の表紙でシュージンが持っている本は？',
    options: [
      { optionId: '0', text: 'BLEACH、ONE PIECE、NARUTO' },
      { optionId: '1', text: 'DRAGON BALL、ONE PIECE、NARUTO' },
      { optionId: '2', text: 'DRAGON BALL、ONE PIECE、HUNTER×HUNTER' },
      { optionId: '3', text: 'DRAGON BALL、BLEACH、ONE PIECE' },
      { optionId: '4', text: 'ヒカルの碁、DEATH NOTE、ONE PIECE' },
    ],
  },
  {
    quizId: '55',
    question: '2巻作者コメントより問題です。\n大場つぐみは誰派？',
    options: [
      { optionId: '0', text: '岩瀬さん派' },
      { optionId: '1', text: '見吉派' },
      { optionId: '2', text: '亜豆美保派' },
      { optionId: '3', text: '真城の母派' },
      { optionId: '4', text: '亜豆美奈派' },
    ],
  },
  {
    quizId: '56',
    question: '真城信弘の享年は？',
    options: [
      { optionId: '0', text: '39歳' },
      { optionId: '1', text: '33歳' },
      { optionId: '2', text: '35歳' },
      { optionId: '3', text: '37歳' },
      { optionId: '4', text: '41歳' },
    ],
  },
  {
    quizId: '57',
    question:
      'シュージンの父親は、シュージンが小学生の時にリストラにあうまで、どこに勤めていた？',
    options: [
      { optionId: '0', text: '大手銀行' },
      { optionId: '1', text: '大手出版社' },
      { optionId: '2', text: '大手弁護士事務所' },
      { optionId: '3', text: '大手学習塾' },
      { optionId: '4', text: '大手病院' },
    ],
  },
  {
    quizId: '58',
    question: 'シュージンの母親の職業は？',
    options: [
      { optionId: '0', text: '高校の教師' },
      { optionId: '1', text: '小学校の教師' },
      { optionId: '2', text: '中学校の教師' },
      { optionId: '3', text: '保育士' },
      { optionId: '4', text: '塾講師' },
    ],
  },
  {
    quizId: '59',
    question: '小学生時、シュージンは母親から何と呼ばれていた？',
    options: [
      { optionId: '0', text: 'あっちゃん' },
      { optionId: '1', text: 'あきくん' },
      { optionId: '2', text: 'アキ' },
      { optionId: '3', text: '秋人さん' },
      { optionId: '4', text: '秋人' },
    ],
  },
  {
    quizId: '60',
    question: 'シュージンが母親に対し、耐えられなくなりキレたのはいつ？',
    options: [
      { optionId: '0', text: '小5' },
      { optionId: '1', text: '小4' },
      { optionId: '2', text: '小6' },
      { optionId: '3', text: '中1' },
      { optionId: '4', text: '中2' },
    ],
  },
  {
    quizId: '61',
    question: 'サイコーとシュージンの集英社への初持ち込みで通された席は？',
    options: [
      { optionId: '0', text: '3番' },
      { optionId: '1', text: '1番' },
      { optionId: '2', text: '2番' },
      { optionId: '3', text: '4番' },
      { optionId: '4', text: '5番' },
    ],
  },
  {
    quizId: '62',
    question: '集英社への初持ち込みでサイコーが誉められた部分は？',
    options: [
      { optionId: '0', text: 'デッサン力' },
      { optionId: '1', text: '演出方法' },
      { optionId: '2', text: '明暗の付け方' },
      { optionId: '3', text: '構図' },
      { optionId: '4', text: 'コマ割り' },
    ],
  },
  {
    quizId: '63',
    question:
      '中学三年夏休み明けに席が隣同士になった真城と亜豆。二人が考えていたことは？',
    options: [
      { optionId: '0', text: '授業中とかお腹が鳴ったらどうしよう' },
      { optionId: '1', text: '顔赤くなってないかな？' },
      { optionId: '2', text: 'これから大丈夫かな？' },
      { optionId: '3', text: 'どう思われてるんだろう？' },
      { optionId: '4', text: '次の席替えいつだろう？' },
    ],
  },
  {
    quizId: '64',
    question: '亜豆の好きな季節は？',
    options: [
      { optionId: '0', text: '秋' },
      { optionId: '1', text: '春' },
      { optionId: '2', text: '夏' },
      { optionId: '3', text: '冬' },
      { optionId: '4', text: '全て' },
    ],
  },
  {
    quizId: '65',
    question:
      '新妻エイジの手塚準入賞作である『Large bander』、読者アンケートでの順位は？',
    options: [
      { optionId: '0', text: '2位' },
      { optionId: '1', text: '1位' },
      { optionId: '2', text: '3位' },
      { optionId: '3', text: '4位' },
      { optionId: '4', text: '5位' },
    ],
  },
  {
    quizId: '66',
    question:
      '授業中に一方通行的交換日記で真城から『どうしても夢が叶ってから？』と聞かれ泣いてしまった亜豆は、教師に泣いた理由を何と言った？',
    options: [
      { optionId: '0', text: '昨日 飼ってるペットが死んじゃって' },
      { optionId: '1', text: '目にゴミが入ってしまって' },
      { optionId: '2', text: '昨日 眠れなくって' },
      { optionId: '3', text: '祖母が患ってしまったのを思い出して' },
      { optionId: '4', text: 'ちょっと悲しいことがあっただけです' },
    ],
  },
  {
    quizId: '67',
    question: '中学時代の亜豆のメールアドレスは？',
    options: [
      { optionId: '0', text: 'mihomiho-azuazu1999@' },
      { optionId: '1', text: 'azu-miho.seven@' },
      { optionId: '2', text: 'say.u.hero@' },
      { optionId: '3', text: 'fairy-ring-feather@' },
      { optionId: '4', text: 'seiyu.dance.voice@' },
    ],
  },
  {
    quizId: '68',
    question:
      '亜豆のメールアドレスを知った翌日、真城が一方通行的交換日記に書いた\n『席替えをしたらメールはするかも\nいつも一緒に居るのは僕がマンガ家になったら』\nに続くのは？',
    options: [
      { optionId: '0', text: 'もしその時亜豆さんが声優になっていなくても！' },
      { optionId: '1', text: 'その時は亜豆さんも夢を叶えている！' },
      { optionId: '2', text: 'そしてアニメになったら！' },
      { optionId: '3', text: 'だから待っててください' },
      { optionId: '4', text: 'だからお互い夢を忘れないで励みましょう！' },
    ],
  },
  {
    quizId: '69',
    question:
      '次の内、手塚賞応募の為にシュージンが考えた原案の中にあった作品は？',
    options: [
      { optionId: '0', text: 'うさぎとカメラ' },
      { optionId: '1', text: '赤鬼くんと青鬼さんと' },
      { optionId: '2', text: 'Pink boy' },
      { optionId: '3', text: '不思議なランプ' },
      { optionId: '4', text: '切り売り グラム童話' },
    ],
  },
  {
    quizId: '70',
    question:
      '『一億分の』の設定では、人間が脳と身体に機械を埋め込まれるのは何歳の時？',
    options: [
      { optionId: '0', text: '15歳' },
      { optionId: '1', text: '0歳' },
      { optionId: '2', text: '3歳' },
      { optionId: '3', text: '6歳' },
      { optionId: '4', text: '10歳' },
    ],
  },
  {
    quizId: '71',
    question:
      '『一億分の』を仕上げるために、サイコーが学校をズル休みした日数は？',
    options: [
      { optionId: '0', text: '4日' },
      { optionId: '1', text: '0日' },
      { optionId: '2', text: '2日' },
      { optionId: '3', text: '6日' },
      { optionId: '4', text: '8日' },
    ],
  },
  {
    quizId: '72',
    question: '中学3年2学期中間試験で一位を取ったのは？',
    options: [
      { optionId: '0', text: '神保星次' },
      { optionId: '1', text: '岩瀬愛子' },
      { optionId: '2', text: '高木秋人' },
      { optionId: '3', text: '相田好示' },
      { optionId: '4', text: '三上誠' },
    ],
  },
  {
    quizId: '73',
    question: '石沢を殴った件で、シュージンが学校から受けた処分は？',
    options: [
      { optionId: '0', text: '1週間の自宅謹慎' },
      { optionId: '1', text: '厳重注意' },
      { optionId: '2', text: '3日間の停学' },
      { optionId: '3', text: '当日の出席停止' },
      { optionId: '4', text: '3日間の指導室での学校謹慎' },
    ],
  },
  {
    quizId: '74',
    question: '学生時代の高木が住んでいたアパートの部屋番号は？',
    options: [
      { optionId: '0', text: '102' },
      { optionId: '1', text: '101' },
      { optionId: '2', text: '201' },
      { optionId: '3', text: '202' },
      { optionId: '4', text: '203' },
    ],
  },
  {
    quizId: '75',
    question: '『一億分の』を応募した時の手塚賞を審査したマンガ家でないのは？',
    options: [
      { optionId: '0', text: '久保先生' },
      { optionId: '1', text: '稲垣先生' },
      { optionId: '2', text: '尾田先生' },
      { optionId: '3', text: '鳥山先生' },
      { optionId: '4', text: '岸本先生' },
    ],
  },
  {
    quizId: '76',
    question:
      '自分はキャラだけ描いて、他の仕上げをアシスタントがこなしてくれたら、一人で描くよりもどのくらい時間の短縮できるとサイコーは言っていた？',
    options: [
      { optionId: '0', text: '5分の1' },
      { optionId: '1', text: '2分の1' },
      { optionId: '2', text: '3分の1' },
      { optionId: '3', text: '4分の1' },
      { optionId: '4', text: '10分の1' },
    ],
  },
  {
    quizId: '77',
    question: '川口たろうが集英社に最後に持ち込んだのはいつ？',
    options: [
      { optionId: '0', text: '亡くなる5日前' },
      { optionId: '1', text: '亡くなる前日' },
      { optionId: '2', text: '亡くなる3日前' },
      { optionId: '3', text: '亡くなる8日前' },
      { optionId: '4', text: '亡くなる10日前' },
    ],
  },
  {
    quizId: '78',
    question:
      '『一億分の』で手塚賞の最終候補に残った頃のサイコー、シュージンと新妻エイジの一番の差を佐々木編集長は何と言った？',
    options: [
      { optionId: '0', text: 'マンガをどれだけ愛しているか' },
      { optionId: '1', text: '画力' },
      { optionId: '2', text: 'マンガにどれだけ時間をかけられるか' },
      { optionId: '3', text: 'センス' },
      { optionId: '4', text: 'マンガをどれだけ理解しているか' },
    ],
  },
  {
    quizId: '79',
    question: '新妻エイジは何歳の時からペンを握りマンガを描いている？',
    options: [
      { optionId: '0', text: '6歳' },
      { optionId: '1', text: '4歳' },
      { optionId: '2', text: '8歳' },
      { optionId: '3', text: '10歳' },
      { optionId: '4', text: '12歳' },
    ],
  },
  {
    quizId: '80',
    question: '次の内、赤マルジャンプに載った亜城木夢叶の作品は？',
    options: [
      { optionId: '0', text: 'この世は金と知恵' },
      { optionId: '1', text: 'TEN' },
      { optionId: '2', text: '俺2人' },
      { optionId: '3', text: 'ふたつの地球' },
      { optionId: '4', text: '1億分の' },
    ],
  },
  {
    quizId: '81',
    question: '上京した新妻エイジに用意したマンションの部屋番号は？',
    options: [
      { optionId: '0', text: '701' },
      { optionId: '1', text: '401' },
      { optionId: '2', text: '405' },
      { optionId: '3', text: '705' },
      { optionId: '4', text: '805' },
    ],
  },
  {
    quizId: '82',
    question:
      '新妻エイジがジャンプで賞を獲った際の賞金の内、親にあげた残りで購入したものは？',
    options: [
      { optionId: '0', text: 'オーディオ' },
      { optionId: '1', text: 'ペン軸' },
      { optionId: '2', text: 'スケッチブック' },
      { optionId: '3', text: 'ONE PIECE' },
      { optionId: '4', text: 'DRAGON BALL' },
    ],
  },
  {
    quizId: '83',
    question:
      '『この世は金と知恵』を作る際、サイコーは自分の脳をどうでもいい奴にならいくらで売ると言っている？',
    options: [
      { optionId: '0', text: '1000万くらい' },
      { optionId: '1', text: '200万くらい' },
      { optionId: '2', text: '500万くらい' },
      { optionId: '3', text: '5000万くらい' },
      { optionId: '4', text: '1億くらい' },
    ],
  },
  {
    quizId: '84',
    question: '模試の結果、サイコーが谷草北高に受かる確率は？',
    options: [
      { optionId: '0', text: '0.8' },
      { optionId: '1', text: '0.65' },
      { optionId: '2', text: '0.7' },
      { optionId: '3', text: '0.75' },
      { optionId: '4', text: '0.85' },
    ],
  },
  {
    quizId: '85',
    question: '『この世は金と知恵』の主人公は？',
    options: [
      { optionId: '0', text: 'ミスト' },
      { optionId: '1', text: 'フレイ' },
      { optionId: '2', text: 'キド' },
      { optionId: '3', text: 'ロキ' },
      { optionId: '4', text: 'ハルト' },
    ],
  },
  {
    quizId: '86',
    question: '中学3年のバレンタインデーで、真城が亜豆から貰ったものは？',
    options: [
      { optionId: '0', text: 'ペンシルチョコレート' },
      { optionId: '1', text: 'ハート型の手作りチョコレート' },
      { optionId: '2', text: '手作り生チョコレート' },
      { optionId: '3', text: 'チロルチョコ' },
      { optionId: '4', text: 'レザーの手袋' },
    ],
  },
  {
    quizId: '87',
    question:
      '赤マルジャンプに作品が載ることが決まり、サイコー、シュージンが服部におごってもらった食事は？',
    options: [
      { optionId: '0', text: '焼き肉' },
      { optionId: '1', text: 'ラーメン' },
      { optionId: '2', text: '寿司' },
      { optionId: '3', text: 'ピザ' },
      { optionId: '4', text: 'フレンチフルコース' },
    ],
  },
  {
    quizId: '88',
    question:
      '高校進学にあたり、亜豆が引っ越すことを高木が見吉から聞いた場所は？',
    options: [
      { optionId: '0', text: 'もみじ山公園' },
      { optionId: '1', text: 'かえで川公園' },
      { optionId: '2', text: 'さくら山公園' },
      { optionId: '3', text: 'つつじ谷公園' },
      { optionId: '4', text: 'つばき谷公園' },
    ],
  },
  {
    quizId: '89',
    question: 'シュージンの使っているヘッドホンは？',
    options: [
      { optionId: '0', text: 'SONY MDR-XD100' },
      { optionId: '1', text: 'audio-technica ATH-ESW9' },
      { optionId: '2', text: 'DENON AH-D5000' },
      { optionId: '3', text: 'ゼンハイザー HD25-1:2' },
      { optionId: '4', text: 'ULTRASONE PROline750' },
    ],
  },
  {
    quizId: '90',
    question: '亜豆美保から真城最高への初メール、その日時は？',
    options: [
      { optionId: '0', text: '39899.3756944444' },
      { optionId: '1', text: '39886.4326388889' },
      { optionId: '2', text: '40214.4125' },
      { optionId: '3', text: '40271.4743055556' },
      { optionId: '4', text: '39867.4916666667' },
    ],
  },
  {
    quizId: '91',
    question: '次の内、谷草北高の1年1組でなかったのは？',
    options: [
      { optionId: '0', text: '見吉香耶' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '高木秋人' },
      { optionId: '3', text: '鈴木元' },
      { optionId: '4', text: '斎藤裕美' },
    ],
  },
  {
    quizId: '92',
    question: 'サイコー、シュージンのペンネームを考えるときに出て来た案は？',
    options: [
      { optionId: '0', text: '真木最人' },
      { optionId: '1', text: '高城秀子' },
      { optionId: '2', text: '真木秀子' },
      { optionId: '3', text: '高城最人' },
      { optionId: '4', text: '高木真高' },
    ],
  },
  {
    quizId: '93',
    question:
      'ジャンプのアンケート結果、「本ちゃん」では何枚のハガキから結果を出す？',
    options: [
      { optionId: '0', text: '1000枚' },
      { optionId: '1', text: '100枚' },
      { optionId: '2', text: '5000枚' },
      { optionId: '3', text: '10000枚' },
      { optionId: '4', text: 'すべてのハガキ' },
    ],
  },
  {
    quizId: '94',
    question:
      'ジャンプのアンケート結果、「速報」では何枚のハガキから結果を出す？',
    options: [
      { optionId: '0', text: '100枚' },
      { optionId: '1', text: '50枚' },
      { optionId: '2', text: '1000枚' },
      { optionId: '3', text: '5000枚' },
      { optionId: '4', text: '10000枚' },
    ],
  },
  {
    quizId: '95',
    question: '『この世は金と知恵』のアンケート順位、本ちゃんの結果は？',
    options: [
      { optionId: '0', text: '3位' },
      { optionId: '1', text: '1位' },
      { optionId: '2', text: '2位' },
      { optionId: '3', text: '4位' },
      { optionId: '4', text: '5位' },
    ],
  },
  {
    quizId: '96',
    question:
      'サイコーが『この世は金と知恵』の連載用のネームを投げ捨てた場所は？',
    options: [
      { optionId: '0', text: '荒川' },
      { optionId: '1', text: '多摩川' },
      { optionId: '2', text: '利根川' },
      { optionId: '3', text: '鶴見川' },
      { optionId: '4', text: '目黒川' },
    ],
  },
  {
    quizId: '97',
    question: 'バトルものを描くために、高木が見吉と戦って得た考えは？',
    options: [
      { optionId: '0', text: '戦うって怖い' },
      { optionId: '1', text: '実力差がありすぎると逃げられない' },
      { optionId: '2', text: '精神論は意味がない' },
      { optionId: '3', text: '経験がすべて' },
      { optionId: '4', text: '殴られるとすごく痛い' },
    ],
  },
  {
    quizId: '98',
    question: '見吉が空手で全国大会へ行ったのはいつ？',
    options: [
      { optionId: '0', text: '中2' },
      { optionId: '1', text: '小5' },
      { optionId: '2', text: '小6' },
      { optionId: '3', text: '中1' },
      { optionId: '4', text: '中3' },
    ],
  },
  {
    quizId: '99',
    question:
      '「あたし みんなみたいに取り柄ない…\n何にもない……」\nと言った見吉に、高木は何と言った？',
    options: [
      { optionId: '0', text: '見吉胸大きいじゃん' },
      { optionId: '1', text: '見吉優しいじゃん' },
      { optionId: '2', text: '見吉可愛いじゃん' },
      { optionId: '3', text: '見吉強いじゃん' },
      { optionId: '4', text: '見吉バカだもんな' },
    ],
  },
  {
    quizId: '100',
    question: '新妻エイジの『CROW』の連載が始まったのは？',
    options: [
      { optionId: '0', text: '2009年33号' },
      { optionId: '1', text: '2009年5号' },
      { optionId: '2', text: '2009年18号' },
      { optionId: '3', text: '2009年26号' },
      { optionId: '4', text: '2009年41号' },
    ],
  },
  {
    quizId: '101',
    question:
      '「机の上はいじらないで さわらないで\n感覚狂う センス狂う」\nと新妻エイジが言ったのは、雄二郎が机に何を置いた時？',
    options: [
      { optionId: '0', text: '携帯電話' },
      { optionId: '1', text: 'ジャンプ' },
      { optionId: '2', text: 'おにぎり' },
      { optionId: '3', text: 'イヤホン' },
      { optionId: '4', text: 'スケッチブック' },
    ],
  },
  {
    quizId: '102',
    question: '新妻エイジの『CROW』と同時期に始まるのは誰の作品？',
    options: [
      { optionId: '0', text: '高野先生' },
      { optionId: '1', text: '新井先生' },
      { optionId: '2', text: '折原先生' },
      { optionId: '3', text: '棒利先生' },
      { optionId: '4', text: '木村先生' },
    ],
  },
  {
    quizId: '103',
    question: '中井の初登場時の年齢は？',
    options: [
      { optionId: '0', text: '33歳' },
      { optionId: '1', text: '27歳' },
      { optionId: '2', text: '31歳' },
      { optionId: '3', text: '35歳' },
      { optionId: '4', text: '40歳' },
    ],
  },
  {
    quizId: '104',
    question: '新妻エイジの初連載は、当初は『CROW』ではなく何の予定だった？',
    options: [
      { optionId: '0', text: 'YELLOW HIT' },
      { optionId: '1', text: 'Large bander' },
      { optionId: '2', text: 'Haitenpepoo' },
      { optionId: '3', text: 'Dogamiberon' },
      { optionId: '4', text: 'U-400' },
    ],
  },
  {
    quizId: '105',
    question:
      '王道のファンタジーバトルマンガを描こうとしている亜城木夢叶に向けて服部が言った、マニュアル化したアドバイスになかったものは？',
    options: [
      {
        optionId: '0',
        text: '特徴のあるキャラクターで 特に主人公にはギャップがあると好ましい',
      },
      { optionId: '1', text: '読者が自然に入り込める世界観である' },
      {
        optionId: '2',
        text: 'なぜ戦ってるのかはっきりしていて その戦う理由に共感できる',
      },
      { optionId: '3', text: 'できれば可愛いヒロインがいるといい' },
      { optionId: '4', text: '敵キャラが主人公と同等かそれ以上に魅力的である' },
    ],
  },
  {
    quizId: '106',
    question:
      '新妻エイジが亜城木夢叶に始めて会ったとき、サイコーの何を見て高く評価していた？',
    options: [
      { optionId: '0', text: '目' },
      { optionId: '1', text: '絵' },
      { optionId: '2', text: '指' },
      { optionId: '3', text: '顔つき' },
      { optionId: '4', text: '熱意' },
    ],
  },
  {
    quizId: '107',
    question: '『聖ビジュアル女学院高等部』のアニメ制作会社は？',
    options: [
      { optionId: '0', text: 'マクドハウス' },
      { optionId: '1', text: 'A.C.STAFF' },
      { optionId: '2', text: 'GOMZO' },
      { optionId: '3', text: 'スタジオ92' },
      { optionId: '4', text: 'ANNスタジオ' },
    ],
  },
  {
    quizId: '108',
    question:
      '『聖ビジュアル女学院高等部』の生徒役オーディションで12番と36番の合格を見た目で決めたのは？',
    options: [
      { optionId: '0', text: '二宮さん' },
      { optionId: '1', text: '大野さん' },
      { optionId: '2', text: '櫻井さん' },
      { optionId: '3', text: '松本さん' },
      { optionId: '4', text: '相葉さん' },
    ],
  },
  {
    quizId: '109',
    question: '亜豆美保が声優デビューした作品は？',
    options: [
      { optionId: '0', text: '聖ビジュアル女学院高等部' },
      { optionId: '1', text: 'おてんば忍者隊' },
      { optionId: '2', text: 'フラッシュ' },
      { optionId: '3', text: 'ミナニルク' },
      { optionId: '4', text: 'ガンバルくん' },
    ],
  },
  {
    quizId: '110',
    question: '亜豆美保が声優デビューした役は？',
    options: [
      { optionId: '0', text: '早乙女寺レイカ' },
      { optionId: '1', text: '伊集二院エリナ' },
      { optionId: '2', text: '白鳥飛アヤ' },
      { optionId: '3', text: '弥河ミサエ' },
      { optionId: '4', text: '阿久賀津カナ' },
    ],
  },
  {
    quizId: '111',
    question: '『聖ビジュアル女学院高等部』を連載している雑誌は？',
    options: [
      { optionId: '0', text: 'ヤングスリー' },
      { optionId: '1', text: '少年スリー' },
      { optionId: '2', text: '少年ウィーク' },
      { optionId: '3', text: 'キャラキラコミック' },
      { optionId: '4', text: 'ジャンプSQ' },
    ],
  },
  {
    quizId: '112',
    question:
      '「俺ってMかな？」\nと言ったサイコーに返したシュージンの台詞\n「Mってより○○だな…」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'N' },
      { optionId: '1', text: 'S' },
      { optionId: '2', text: 'L' },
      { optionId: '3', text: 'W' },
      { optionId: '4', text: 'MM' },
    ],
  },
  {
    quizId: '113',
    question: '亜城木夢叶の『エンジェルデイズ』、仮タイトルは何だった？',
    options: [
      { optionId: '0', text: '私の天使（エンジェル）' },
      { optionId: '1', text: '天使の日常' },
      { optionId: '2', text: '天使のお仕事' },
      { optionId: '3', text: '不思議天使（エンジェル）' },
      { optionId: '4', text: '天使（エンジェル）&悪魔（デビル）' },
    ],
  },
  {
    quizId: '114',
    question:
      '金未来杯に応募するもエントリーされなかった、亜城木夢叶の作品は？',
    options: [
      { optionId: '0', text: 'エンジェルデイズ' },
      { optionId: '1', text: 'この世は金と知恵' },
      { optionId: '2', text: '1億分の' },
      { optionId: '3', text: '俺2人' },
      { optionId: '4', text: 'Future Watch-未来時計-' },
    ],
  },
  {
    quizId: '115',
    question: '最初に新妻エイジのアシスタントに入った二人は？',
    options: [
      { optionId: '0', text: '中井、下山' },
      { optionId: '1', text: '中井、福田' },
      { optionId: '2', text: '福田、森山' },
      { optionId: '3', text: '中井、森山' },
      { optionId: '4', text: '福田、小河' },
    ],
  },
  {
    quizId: '116',
    question:
      '亜豆美保の声優デビュー作品『聖ビジュアル女学院高等部』、初登場話でのセリフ数は？',
    options: [
      { optionId: '0', text: '4回' },
      { optionId: '1', text: '1回' },
      { optionId: '2', text: '2回' },
      { optionId: '3', text: '3回' },
      { optionId: '4', text: '5回' },
    ],
  },
  {
    quizId: '117',
    question: '『聖ビジュアル女学院高等部』で伊集二院エリナのCVは？',
    options: [
      { optionId: '0', text: '大月奈々観' },
      { optionId: '1', text: '何多良幹羅' },
      { optionId: '2', text: '田中美菅' },
      { optionId: '3', text: '亜豆美保' },
      { optionId: '4', text: '北見リリカ' },
    ],
  },
  {
    quizId: '118',
    question: '亜豆美保が初めて載ったであろう声優誌は？',
    options: [
      { optionId: '0', text: '声優&アニメMAX' },
      { optionId: '1', text: '声優アニメージュ' },
      { optionId: '2', text: '声優パラダイス' },
      { optionId: '3', text: '声優FANモア' },
      { optionId: '4', text: '声優Cafetería' },
    ],
  },
  {
    quizId: '119',
    question: '高校1年時、見吉が持った夢は？',
    options: [
      { optionId: '0', text: '作家' },
      { optionId: '1', text: '空手家' },
      { optionId: '2', text: '女優' },
      { optionId: '3', text: 'タレント' },
      { optionId: '4', text: 'パティシエール' },
    ],
  },
  {
    quizId: '120',
    question:
      '高木が高校1年の夏休み、マンガの気分転換に見吉をデートに誘った時、まず何をした？',
    options: [
      { optionId: '0', text: 'ボーリング' },
      { optionId: '1', text: '映画鑑賞' },
      { optionId: '2', text: 'カラオケ' },
      { optionId: '3', text: 'ウィンドウショッピング' },
      { optionId: '4', text: 'ゲーセン' },
    ],
  },
  {
    quizId: '121',
    question:
      'サイコ―が新妻エイジのアシスタントに入った時に聞いた中井の説明によると、新妻エイジは一度寝るとどのくらい起きない？',
    options: [
      { optionId: '0', text: '20時間くらい' },
      { optionId: '1', text: '8時間くらい' },
      { optionId: '2', text: '10時間くらい' },
      { optionId: '3', text: '12時間くらい' },
      { optionId: '4', text: '15時間くらい' },
    ],
  },
  {
    quizId: '122',
    question:
      '真城が新妻エイジのアシスタントに入った時、新妻エイジはベタ指示をどんな記号で記入していた？',
    options: [
      { optionId: '0', text: '×' },
      { optionId: '1', text: '○' },
      { optionId: '2', text: '◎' },
      { optionId: '3', text: '△' },
      { optionId: '4', text: '◇' },
    ],
  },
  {
    quizId: '123',
    question:
      '真城が新妻エイジのアシスタントに入った時、新妻エイジはトーン指示を何色で記入していた？',
    options: [
      { optionId: '0', text: '青' },
      { optionId: '1', text: '赤' },
      { optionId: '2', text: '黄' },
      { optionId: '3', text: '緑' },
      { optionId: '4', text: '紫' },
    ],
  },
  {
    quizId: '124',
    question:
      'サイコー、新妻エイジ、福田真太が協力し描き直したのは『CROW』の何話？',
    options: [
      { optionId: '0', text: '5話' },
      { optionId: '1', text: '4話' },
      { optionId: '2', text: '6話' },
      { optionId: '3', text: '7話' },
      { optionId: '4', text: '8話' },
    ],
  },
  {
    quizId: '125',
    question: '新妻エイジが『先生』を付けて呼ぶのはどんな人？',
    options: [
      { optionId: '0', text: 'デビューした人' },
      { optionId: '1', text: '尊敬している人' },
      { optionId: '2', text: 'スゴいと思う人' },
      { optionId: '3', text: 'マンガを描いている人' },
      { optionId: '4', text: '年上の人' },
    ],
  },
  {
    quizId: '126',
    question: '福田真太の出身は？',
    options: [
      { optionId: '0', text: '広島' },
      { optionId: '1', text: '高知' },
      { optionId: '2', text: '東京' },
      { optionId: '3', text: '青森' },
      { optionId: '4', text: '熊本' },
    ],
  },
  {
    quizId: '127',
    question:
      '新妻エイジの下でアシスタントをしていた頃、福田真太がしていたバイトは？',
    options: [
      { optionId: '0', text: '早朝のコンビニ' },
      { optionId: '1', text: '新聞配達' },
      { optionId: '2', text: 'ピザの配達' },
      { optionId: '3', text: 'ファミレスのキッチン' },
      { optionId: '4', text: 'ゲーセン' },
    ],
  },
  {
    quizId: '128',
    question:
      '新妻エイジのアシスタントをしていた時、福田真太がジャンプの中で1番好きだと言っていた作品は？',
    options: [
      { optionId: '0', text: 'To LOVEる' },
      { optionId: '1', text: 'SKET DANCE' },
      { optionId: '2', text: 'HUNTER×HUNTER' },
      { optionId: '3', text: 'ピューと吹く!ジャガー' },
      { optionId: '4', text: 'こちら葛飾区亀有公園前派出所' },
    ],
  },
  {
    quizId: '129',
    question: '赤マルに載った、福田の作品は？',
    options: [
      { optionId: '0', text: 'やる気なヤンキー' },
      { optionId: '1', text: '短気なヤンキー' },
      { optionId: '2', text: 'やんちゃなヤンキー' },
      { optionId: '3', text: 'ナイトでヤンキー' },
      { optionId: '4', text: '今日からヤンキー' },
    ],
  },
  {
    quizId: '130',
    question: '新妻エイジがスズメのマンガを描いたのはいつのこと？',
    options: [
      { optionId: '0', text: '4年生の時' },
      { optionId: '1', text: '年長組の時' },
      { optionId: '2', text: '1年生の時' },
      { optionId: '3', text: '2年生の時' },
      { optionId: '4', text: '3年生の時' },
    ],
  },
  {
    quizId: '131',
    question: '見吉が投稿した携帯小説のタイトルは？',
    options: [
      { optionId: '0', text: '逢わない恋' },
      { optionId: '1', text: '掛け違えたボタン' },
      { optionId: '2', text: 'ミスマッチフレンド' },
      { optionId: '3', text: '二人だけの約束' },
      { optionId: '4', text: '恋愛の準備' },
    ],
  },
  {
    quizId: '132',
    question: '『この世は金と知恵』が赤マルジャンプに掲載された時の煽り文は？',
    options: [
      { optionId: '0', text: '頭と金でこの世を生きぬけ！' },
      { optionId: '1', text: '世界は金と知恵で回っている！' },
      { optionId: '2', text: '世界の真理を括目せよ！' },
      { optionId: '3', text: '所詮この世は金と知恵!?' },
      { optionId: '4', text: '賢い子には稼がせよ！' },
    ],
  },
  {
    quizId: '133',
    question: '次の内、サイコ―が小学生の頃に描いていたマンガは？',
    options: [
      { optionId: '0', text: '自信過剰ヒーロー ジシンマンマン' },
      { optionId: '1', text: 'ホット戦士 ホッカイロン' },
      { optionId: '2', text: 'インチキ ナンバー1' },
      { optionId: '3', text: '太陽戦隊 サンレンジャー' },
      { optionId: '4', text: 'ボーヤーカンちゃん' },
    ],
  },
  {
    quizId: '134',
    question:
      '高校1年の夏休み明け、亜城木夢叶がコンビ解消した時、サイコーはシュージンのネームを1本いくらで清書してやると言った？',
    options: [
      { optionId: '0', text: '100円' },
      { optionId: '1', text: '10円' },
      { optionId: '2', text: '50円' },
      { optionId: '3', text: '500円' },
      { optionId: '4', text: '1000円' },
    ],
  },
  {
    quizId: '135',
    question: '高校1年の2学期始業式の日、見吉の履いていたパンツの柄は？',
    options: [
      { optionId: '0', text: '花柄' },
      { optionId: '1', text: '水玉' },
      { optionId: '2', text: '縞々' },
      { optionId: '3', text: 'くまさん' },
      { optionId: '4', text: 'うさぎさん' },
    ],
  },
  {
    quizId: '136',
    question:
      '亜城木夢叶が解散していた時、シュージンが書いてきた推理ものの原案5本の中にあったものは？',
    options: [
      { optionId: '0', text: '透明探偵スケルトン(仮題)' },
      { optionId: '1', text: 'トリック探偵クリアクリーン(仮題)' },
      { optionId: '2', text: '霊能探偵キンタくん(仮題)' },
      { optionId: '3', text: '川越署魔術課(仮題)' },
      { optionId: '4', text: '未来ノート(仮題)' },
    ],
  },
  {
    quizId: '137',
    question:
      '推理もののネームを作り始めたシュージンの下へ、服部は小説とDVDをどのくらい送った？',
    options: [
      { optionId: '0', text: 'ダンボール6箱' },
      { optionId: '1', text: 'ダンボール2箱' },
      { optionId: '2', text: 'ダンボール3箱' },
      { optionId: '3', text: 'ダンボール4箱' },
      { optionId: '4', text: 'ダンボール5箱' },
    ],
  },
  {
    quizId: '138',
    question: '高校1年の10月、見吉の変更した新たな夢は？',
    options: [
      { optionId: '0', text: '高木と真城の成功' },
      { optionId: '1', text: '真城と亜豆の結婚' },
      { optionId: '2', text: '高木との結婚' },
      { optionId: '3', text: 'ハリウッド女優' },
      { optionId: '4', text: '編集' },
    ],
  },
  {
    quizId: '139',
    question: '亜豆美保の誕生日は？',
    options: [
      { optionId: '0', text: '44870' },
      { optionId: '1', text: '44617' },
      { optionId: '2', text: '44710' },
      { optionId: '3', text: '44780' },
      { optionId: '4', text: '44822' },
    ],
  },
  {
    quizId: '140',
    question:
      '服部に内緒で亜城木夢叶が再結成し、半年近くかけて作った『疑探偵TRAP(仮)』のネーム本数は？',
    options: [
      { optionId: '0', text: '8本' },
      { optionId: '1', text: '1本' },
      { optionId: '2', text: '3本' },
      { optionId: '3', text: '5本' },
      { optionId: '4', text: '10本' },
    ],
  },
  {
    quizId: '141',
    question: '蒼樹紅がジャンプでの連載以前に連載していた雑誌は？',
    options: [
      { optionId: '0', text: 'マーガレット' },
      { optionId: '1', text: 'りぼん' },
      { optionId: '2', text: 'YOU' },
      { optionId: '3', text: 'Cookie' },
      { optionId: '4', text: 'office YOU' },
    ],
  },
  {
    quizId: '142',
    question: '金未来杯で掲載されていない作品は？',
    options: [
      { optionId: '0', text: 'ラッコ11号' },
      { optionId: '1', text: 'KIYOSHI騎士' },
      { optionId: '2', text: '疑探偵TRAP' },
      { optionId: '3', text: 'hideout door' },
      { optionId: '4', text: 'カラフジカル' },
    ],
  },
  {
    quizId: '143',
    question: '『カラフジカル』は、どのような作品？',
    options: [
      {
        optionId: '0',
        text: '目で見た物の色を変え 歌声で人の心を変え世界を変える',
      },
      { optionId: '1', text: '目で見て世界を捉え 歌声で世界の真実を変える' },
      { optionId: '2', text: '目で見た人の心を捉え 歌声で人の心を変える' },
      { optionId: '3', text: '五感をすべて使い 世界を創り変える' },
      { optionId: '4', text: '目で見た物の形を見て 歌声で世界を直す' },
    ],
  },
  {
    quizId: '144',
    question:
      'シュージンは『hideout door』のネームを見て、何を彷彿させる出来だと考えた？',
    options: [
      { optionId: '0', text: 'ハリーポッター' },
      { optionId: '1', text: '指輪物語' },
      { optionId: '2', text: 'ヘンゼルとグレーテル' },
      { optionId: '3', text: 'プーさん' },
      { optionId: '4', text: '不思議の国のアリス' },
    ],
  },
  {
    quizId: '145',
    question:
      'シュージンは『KIYOSHI騎士』の読切ネームを見て、現代版の何と感じた？',
    options: [
      { optionId: '0', text: '男塾' },
      { optionId: '1', text: '男一匹ガキ大将' },
      { optionId: '2', text: '湘南爆走族' },
      { optionId: '3', text: 'ろくでなしBLUES' },
      { optionId: '4', text: 'BE-BOP-HIGHSCHOOL' },
    ],
  },
  {
    quizId: '146',
    question:
      '福田は金未来杯で掲載する『KIYOSHI騎士』を描く際、編集部に表現を和らげろと言われ何回描き直した？',
    options: [
      { optionId: '0', text: '6回' },
      { optionId: '1', text: '2回' },
      { optionId: '2', text: '4回' },
      { optionId: '3', text: '8回' },
      { optionId: '4', text: '10回' },
    ],
  },
  {
    quizId: '147',
    question:
      '当初、ネームの段階では「KOOGY」の名前が違っていますが、その際の名前は？',
    options: [
      { optionId: '0', text: 'COOGY' },
      { optionId: '1', text: 'HYDE' },
      { optionId: '2', text: 'CUTiE' },
      { optionId: '3', text: 'KELLY' },
      { optionId: '4', text: 'Swift' },
    ],
  },
  {
    quizId: '148',
    question: '『KIYOSHI騎士』の主人公は？',
    options: [
      { optionId: '0', text: '喜好' },
      { optionId: '1', text: '清志' },
      { optionId: '2', text: '貴吉' },
      { optionId: '3', text: '鬼善' },
      { optionId: '4', text: '騎呼士' },
    ],
  },
  {
    quizId: '149',
    question:
      '中井の発言によると、ジャンプでのアンケート集計は、1週の内に何度行われる？',
    options: [
      { optionId: '0', text: '3回' },
      { optionId: '1', text: '1回' },
      { optionId: '2', text: '2回' },
      { optionId: '3', text: '4回' },
      { optionId: '4', text: '5回' },
    ],
  },
  {
    quizId: '150',
    question: '金未来杯で掲載された『KIYOSHI騎士』の支持率は？',
    options: [
      { optionId: '0', text: '0.79' },
      { optionId: '1', text: '0.76' },
      { optionId: '2', text: '0.73' },
      { optionId: '3', text: '0.66' },
      { optionId: '4', text: '0.53' },
    ],
  },
  {
    quizId: '151',
    question: '金未来杯で掲載された『カラフジカル』の支持率は？',
    options: [
      { optionId: '0', text: '0.53' },
      { optionId: '1', text: '0.28' },
      { optionId: '2', text: '0.42' },
      { optionId: '3', text: '0.66' },
      { optionId: '4', text: '0.73' },
    ],
  },
  {
    quizId: '152',
    question: '第6回 金未来杯で受賞した作品は？',
    options: [
      { optionId: '0', text: 'KIYOSHI騎士、疑探偵TRAP' },
      { optionId: '1', text: 'hideout door、疑探偵TRAP' },
      { optionId: '2', text: 'hideout door、KIYOSHI騎士' },
      { optionId: '3', text: 'カラフジカル' },
      { optionId: '4', text: 'hideout door' },
    ],
  },
  {
    quizId: '153',
    question: '疑探偵TRAPで受賞した金未来杯は第何回目？',
    options: [
      { optionId: '0', text: '第6回目' },
      { optionId: '1', text: '第2回目' },
      { optionId: '2', text: '第4回目' },
      { optionId: '3', text: '第8回目' },
      { optionId: '4', text: '受賞していない' },
    ],
  },
  {
    quizId: '154',
    question:
      '『ラッコ11号』が出されていた連載会議に出されていなかった作品は？',
    options: [
      { optionId: '0', text: 'ガードギアス' },
      { optionId: '1', text: 'タンクトップ' },
      { optionId: '2', text: 'チーズおかき' },
      { optionId: '3', text: '疑探偵TRAP' },
      { optionId: '4', text: 'KIYOSHI騎士' },
    ],
  },
  {
    quizId: '155',
    question:
      '蒼樹紅はジャンプに作品を掲載する以前に、他誌で何本の読切を掲載したことがある？',
    options: [
      { optionId: '0', text: '3本' },
      { optionId: '1', text: '0本' },
      { optionId: '2', text: '1本' },
      { optionId: '3', text: '2本' },
      { optionId: '4', text: '4本' },
    ],
  },
  {
    quizId: '156',
    question: '5巻の表紙で福田真太が怒ってる理由は？',
    options: [
      { optionId: '0', text: '安岡がインクを原稿にこぼしたから' },
      { optionId: '1', text: 'アンケート順位が低かったから' },
      { optionId: '2', text: '安岡がジャンプにカップ麺をこぼしたから' },
      { optionId: '3', text: '雄二郎が遅刻したから' },
      { optionId: '4', text: '蒼樹紅が怒ってきたから' },
    ],
  },
  {
    quizId: '157',
    question: '疑探偵TRAPの担当は？',
    options: [
      { optionId: '0', text: '港浦吾郎' },
      { optionId: '1', text: '服部哲' },
      { optionId: '2', text: '服部雄二郎' },
      { optionId: '3', text: '山久雅和' },
      { optionId: '4', text: '瓶子吉久' },
    ],
  },
  {
    quizId: '158',
    question: '『疑探偵TRAP』の連載開始時点で、服部哲が担当していた作品は？',
    options: [
      { optionId: '0', text: 'タラコーン、ONE PIECE' },
      { optionId: '1', text: 'ブレストレッド、NARUTO' },
      { optionId: '2', text: 'バターマン、BLEACH' },
      { optionId: '3', text: 'こち亀、SKET DANCE' },
      { optionId: '4', text: 'ガチ魔伝、トリコ' },
    ],
  },
  {
    quizId: '159',
    question: '『疑探偵TRAP』連載開始時の担当引き継ぎの帰り際の服部の台詞は？',
    options: [
      { optionId: '0', text: '面白いマンガ読ませてくれ' },
      { optionId: '1', text: 'これからはライバルだ！' },
      { optionId: '2', text: '君達なら頂点を目指せる' },
      { optionId: '3', text: '一言だけ 頑張ってくれ！' },
      { optionId: '4', text: 'ジャンプの連載は甘くないぞ' },
    ],
  },
  {
    quizId: '160',
    question: '初登場時の港浦の年齢は？',
    options: [
      { optionId: '0', text: '23歳' },
      { optionId: '1', text: '24歳' },
      { optionId: '2', text: '25歳' },
      { optionId: '3', text: '26歳' },
      { optionId: '4', text: '27歳' },
    ],
  },
  {
    quizId: '161',
    question: '新人の連載時の原稿料は1ページあたり何円？',
    options: [
      { optionId: '0', text: '一万二千円' },
      { optionId: '1', text: '九千円' },
      { optionId: '2', text: '一万円' },
      { optionId: '3', text: '一万四千円' },
      { optionId: '4', text: '一万七千円' },
    ],
  },
  {
    quizId: '162',
    question:
      '『疑探偵TRAP』連載開始時、ベテランアシスタントの小河にはいくら払うよう港浦に言われた？',
    options: [
      { optionId: '0', text: '最低月38万' },
      { optionId: '1', text: '最低一日3万' },
      { optionId: '2', text: '最低一日2万5千' },
      { optionId: '3', text: '最低月50万' },
      { optionId: '4', text: '最低月24万' },
    ],
  },
  {
    quizId: '163',
    question: '『疑探偵TRAP』の1話目のページ数は？',
    options: [
      { optionId: '0', text: '58ページ' },
      { optionId: '1', text: '45ページ' },
      { optionId: '2', text: '48ページ' },
      { optionId: '3', text: '52ページ' },
      { optionId: '4', text: '55ページ' },
    ],
  },
  {
    quizId: '164',
    question: '亜城木夢叶の『疑探偵TRAP』と同時期に連載開始した作家は？',
    options: [
      { optionId: '0', text: '茨季' },
      { optionId: '1', text: '福田' },
      { optionId: '2', text: '蒼樹' },
      { optionId: '3', text: '皆森' },
      { optionId: '4', text: '華城' },
    ],
  },
  {
    quizId: '165',
    question: '亜城木夢叶が初参加した新年会が行われた日は？',
    options: [
      { optionId: '0', text: '44578' },
      { optionId: '1', text: '44568' },
      { optionId: '2', text: '44573' },
      { optionId: '3', text: '44583' },
      { optionId: '4', text: '44588' },
    ],
  },
  {
    quizId: '166',
    question: '新年会をやむを得ない理由もなく休んだ先生がいるとどうなる？',
    options: [
      { optionId: '0', text: '担当が罰ゲーム' },
      { optionId: '1', text: '先生が罰ゲーム' },
      { optionId: '2', text: '先生が新年会費用の一部を負担' },
      { optionId: '3', text: '担当が新年会費用の一部を負担' },
      { optionId: '4', text: '先生がおまけページの手伝いをする' },
    ],
  },
  {
    quizId: '167',
    question: '新年会の別名は？',
    options: [
      { optionId: '0', text: '強制連行会' },
      { optionId: '1', text: '挨拶会' },
      { optionId: '2', text: '顔合わせ会' },
      { optionId: '3', text: '情熱促進会' },
      { optionId: '4', text: '新人歓迎会' },
    ],
  },
  {
    quizId: '168',
    question: '初登場時の小河の年齢は？',
    options: [
      { optionId: '0', text: '31歳' },
      { optionId: '1', text: '27歳' },
      { optionId: '2', text: '29歳' },
      { optionId: '3', text: '33歳' },
      { optionId: '4', text: '35歳' },
    ],
  },
  {
    quizId: '169',
    question: '初登場時の高浜の年齢は？',
    options: [
      { optionId: '0', text: '19歳' },
      { optionId: '1', text: '18歳' },
      { optionId: '2', text: '20歳' },
      { optionId: '3', text: '21歳' },
      { optionId: '4', text: '22歳' },
    ],
  },
  {
    quizId: '170',
    question: '亜城木夢叶の仕事場にあるコピー機に備わっていない機能は？',
    options: [
      { optionId: '0', text: 'プリンタ' },
      { optionId: '1', text: '縮小' },
      { optionId: '2', text: '拡大' },
      { optionId: '3', text: '反転' },
      { optionId: '4', text: 'ファックス' },
    ],
  },
  {
    quizId: '171',
    question:
      '亜城木夢叶のアシスタントとして来た小河が、顔合わせで仕事場に足りないと言っていないものは？',
    options: [
      { optionId: '0', text: '資料本' },
      { optionId: '1', text: '机' },
      { optionId: '2', text: 'トレース台' },
      { optionId: '3', text: 'パソコン' },
      { optionId: '4', text: 'プリンタ' },
    ],
  },
  {
    quizId: '172',
    question:
      '小河が『疑探偵TRAP』のアシスタントと掛け持ちしていた先生が連載していた雑誌は？',
    options: [
      { optionId: '0', text: '少年スリー' },
      { optionId: '1', text: 'ヤングスリー' },
      { optionId: '2', text: '少年キック' },
      { optionId: '3', text: '少年ウィーク' },
      { optionId: '4', text: 'ジャンプSQ' },
    ],
  },
  {
    quizId: '173',
    question:
      '『疑探偵TRAP』の連載開始当初、小河がアシスタントに入っていた曜日は？',
    options: [
      { optionId: '0', text: '水木金土' },
      { optionId: '1', text: '水木金' },
      { optionId: '2', text: '火水木金' },
      { optionId: '3', text: '火水木' },
      { optionId: '4', text: '木金土' },
    ],
  },
  {
    quizId: '174',
    question: '港浦は『疑探偵TRAP』の3話までをどう思っている？',
    options: [
      { optionId: '0', text: '硬い' },
      { optionId: '1', text: '薄い' },
      { optionId: '2', text: '詰め込み過ぎ' },
      { optionId: '3', text: '深い' },
      { optionId: '4', text: '速い' },
    ],
  },
  {
    quizId: '175',
    question: '初めての新年会、シュージンの服装は？',
    options: [
      { optionId: '0', text: 'スーツ' },
      { optionId: '1', text: 'ブレザー' },
      { optionId: '2', text: 'スウェット' },
      { optionId: '3', text: 'ジャージ' },
      { optionId: '4', text: '学ラン' },
    ],
  },
  {
    quizId: '176',
    question:
      '亜城木夢叶が初めて参加した新年会、亜城木夢叶を担当したハイヤーの運転手は？',
    options: [
      { optionId: '0', text: '帝都交通の田中' },
      { optionId: '1', text: '帝都交通の小野田' },
      { optionId: '2', text: '帝都交通の森田' },
      { optionId: '3', text: '日本交通の小野田' },
      { optionId: '4', text: '日本交通の田中' },
    ],
  },
  {
    quizId: '177',
    question:
      '亜城木夢叶が初めて参加した新年会で平丸は何に生まれたかったと言っていた？',
    options: [
      { optionId: '0', text: '動物園で大切に育てられるパンダ' },
      { optionId: '1', text: '美人に大切に育てられるチワワ' },
      { optionId: '2', text: '温室で大切に育てられる植物' },
      { optionId: '3', text: '水族館で大切に育てられるペンギン' },
      { optionId: '4', text: '街中を自由に過ごしているネコ' },
    ],
  },
  {
    quizId: '178',
    question:
      '亜城木夢叶が初めて参加した新年会で𠮷田は、『ラッコ11号』の3話目の決め台詞を何でいこうと言っていた？',
    options: [
      { optionId: '0', text: '生きている事は楽しいか？' },
      { optionId: '1', text: '自由で何が悪い！' },
      { optionId: '2', text: '明日出来ることは明日すればいい' },
      { optionId: '3', text: '人として許せてもラッコとして許せん' },
      { optionId: '4', text: 'いいや 動かない！' },
    ],
  },
  {
    quizId: '179',
    question: '蒼樹紅の本名は？',
    options: [
      { optionId: '0', text: '青木優梨子' },
      { optionId: '1', text: '青木茜' },
      { optionId: '2', text: '蒼樹まりな' },
      { optionId: '3', text: '木村碧' },
      { optionId: '4', text: '木村詩織' },
    ],
  },
  {
    quizId: '180',
    question: '『ラッコ11号』はラッコ人間が両手を何に変化させ殴りまくる話？',
    options: [
      { optionId: '0', text: 'あらゆる岩石' },
      { optionId: '1', text: 'あらゆる金属' },
      { optionId: '2', text: 'あらゆる生物の手' },
      { optionId: '3', text: 'あらゆる貝' },
      { optionId: '4', text: 'あらゆる海藻' },
    ],
  },
  {
    quizId: '181',
    question: '亜城木夢叶が初参加した新年会、司会進行は誰だった？',
    options: [
      { optionId: '0', text: '相田聡一' },
      { optionId: '1', text: '𠮷田幸司' },
      { optionId: '2', text: '大西恒平' },
      { optionId: '3', text: '瓶子吉久' },
      { optionId: '4', text: '佐々木尚' },
    ],
  },
  {
    quizId: '182',
    question:
      '亜城木夢叶が初参加した新年会、作家の代表として乾杯の音頭を取ったのは？',
    options: [
      { optionId: '0', text: '秋本先生' },
      { optionId: '1', text: '尾田先生' },
      { optionId: '2', text: '岸本先生' },
      { optionId: '3', text: '久保先生' },
      { optionId: '4', text: '荒木先生' },
    ],
  },
  {
    quizId: '183',
    question: '『疑探偵TRAP』連載開始する前の号から連載開始した作品は？',
    options: [
      { optionId: '0', text: 'チーズおかき' },
      { optionId: '1', text: 'ハッスルミンＡ' },
      { optionId: '2', text: 'ラッコ11号' },
      { optionId: '3', text: '#NAME?' },
      { optionId: '4', text: 'KIYOSHI騎士' },
    ],
  },
  {
    quizId: '184',
    question:
      '亜城木夢叶が初参加した新年会のビンゴ前に、編集者のモノマネをした新米編集は誰？',
    options: [
      { optionId: '0', text: '山久' },
      { optionId: '1', text: '小野寺' },
      { optionId: '2', text: '中路' },
      { optionId: '3', text: '内田' },
      { optionId: '4', text: '港浦' },
    ],
  },
  {
    quizId: '185',
    question:
      '亜城木夢叶が初参加した新年会でビンゴ1号となったシュージンが手に入れた景品は？',
    options: [
      { optionId: '0', text: 'テレビ' },
      { optionId: '1', text: 'ＤＶＤレコーダー' },
      { optionId: '2', text: 'パソコン' },
      { optionId: '3', text: '自転車' },
      { optionId: '4', text: '米俵' },
    ],
  },
  {
    quizId: '186',
    question:
      '亜城木夢叶が初参加した新年会のビンゴでサイコーが手に入れた景品は？',
    options: [
      { optionId: '0', text: 'DSの最新型' },
      { optionId: '1', text: 'デジカメ' },
      { optionId: '2', text: 'ＰＳ3の最新型' },
      { optionId: '3', text: 'ＰＳＰの最新型' },
      { optionId: '4', text: 'ウォークマン' },
    ],
  },
  {
    quizId: '187',
    question: '亜城木夢叶が初参加した新年会で吐いていたのは？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '中井巧朗' },
      { optionId: '4', text: '新井貴作' },
    ],
  },
  {
    quizId: '188',
    question:
      '川口たろうができなかった事はマンガで一生食べていく事、では、やり残した事は？',
    options: [
      { optionId: '0', text: 'アンケートで1位を獲る事' },
      { optionId: '1', text: '好きな相手に想いを伝える事' },
      { optionId: '2', text: '再び連載を獲る事' },
      { optionId: '3', text: '結婚する事' },
      { optionId: '4', text: '累計1000万部突破する事' },
    ],
  },
  {
    quizId: '189',
    question:
      '亜城木夢叶が初めて参加した新年会にジャンプSQ.編集長の茨木が呼んだスペシャルゲストは？',
    options: [
      { optionId: '0', text: 'KOOGY' },
      { optionId: '1', text: '北見リリカ' },
      { optionId: '2', text: '亜豆美保' },
      { optionId: '3', text: '何多良幹羅' },
      { optionId: '4', text: 'ふたりぶたり' },
    ],
  },
  {
    quizId: '190',
    question: '蒼樹紅の部屋は何号室？',
    options: [
      { optionId: '0', text: '301号室' },
      { optionId: '1', text: '205号室' },
      { optionId: '2', text: '208号室' },
      { optionId: '3', text: '304号室' },
      { optionId: '4', text: '402号室' },
    ],
  },
  {
    quizId: '191',
    question: '中井が雪の日に公園で原稿を描いたことで、入院した日数は？',
    options: [
      { optionId: '0', text: '3日' },
      { optionId: '1', text: '1日' },
      { optionId: '2', text: '2日' },
      { optionId: '3', text: '4日' },
      { optionId: '4', text: '0日' },
    ],
  },
  {
    quizId: '192',
    question:
      '亜城木夢叶のアシスタントに入った当初、イヤホンをつけて音楽聞きながら作業していたのは？',
    options: [
      { optionId: '0', text: '高浜' },
      { optionId: '1', text: '小河' },
      { optionId: '2', text: '加藤' },
      { optionId: '3', text: '折原' },
      { optionId: '4', text: '森屋' },
    ],
  },
  {
    quizId: '193',
    question: '亜豆美保の通っていた小学校は？',
    options: [
      { optionId: '0', text: '明草第二小学校' },
      { optionId: '1', text: '明陽小学校' },
      { optionId: '2', text: '日下部第二小学校' },
      { optionId: '3', text: '美竹小学校' },
      { optionId: '4', text: '双島小学校' },
    ],
  },
  {
    quizId: '194',
    question: '小学生時の亜豆美保のあだ名は？',
    options: [
      { optionId: '0', text: 'あまめ' },
      { optionId: '1', text: 'みほみほ' },
      { optionId: '2', text: 'みぽりん' },
      { optionId: '3', text: 'あずちゃん' },
      { optionId: '4', text: 'えいちゃん' },
    ],
  },
  {
    quizId: '195',
    question:
      '『KIYOSHI騎士』、『hideout door』の連載開始に伴い終了した作品は『チーズおかき』と何？',
    options: [
      { optionId: '0', text: 'Chain gold' },
      { optionId: '1', text: '#NAME?' },
      { optionId: '2', text: 'タラコーン' },
      { optionId: '3', text: 'タンクトップ' },
      { optionId: '4', text: '裸のオウサマ' },
    ],
  },
  {
    quizId: '196',
    question:
      '疑探偵TRAP、3話目速報9位で、テコ入れはしない方がいいと言っていた編集は？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '相田聡一' },
      { optionId: '2', text: '服部雄二郎' },
      { optionId: '3', text: '瓶子吉久' },
      { optionId: '4', text: '服部哲' },
    ],
  },
  {
    quizId: '197',
    question: '『hideout door』連載開始時点での中井の年齢は？',
    options: [
      { optionId: '0', text: '35歳' },
      { optionId: '1', text: '27歳' },
      { optionId: '2', text: '31歳' },
      { optionId: '3', text: '33歳' },
      { optionId: '4', text: '40歳' },
    ],
  },
  {
    quizId: '198',
    question:
      '港浦が服部のアドバイスを元に、神田の本屋を回って買ってきた名セリフの本になかったのは？',
    options: [
      { optionId: '0', text: 'あなたへ捧げる名セリフ' },
      { optionId: '1', text: 'ビジネスで使える名セリフ' },
      { optionId: '2', text: '恋の名セリフ' },
      { optionId: '3', text: '恋人たちのセリフ集' },
      { optionId: '4', text: '映画名セリフ集' },
    ],
  },
  {
    quizId: '199',
    question:
      '亜豆美保も声優として出演している、「ゆうがたチャンス！」の中で10分間アニメとして放送されているアニメは？',
    options: [
      { optionId: '0', text: 'おてんば忍者隊' },
      { optionId: '1', text: 'みんな魔女っ娘！' },
      { optionId: '2', text: 'マフラー×' },
      { optionId: '3', text: 'となりの妖怪さん' },
      { optionId: '4', text: 'まるごと英会話' },
    ],
  },
  {
    quizId: '200',
    question:
      '『KIYOSHI騎士』連載時から、福田の下でアシスタントをしているのは？',
    options: [
      { optionId: '0', text: '安岡' },
      { optionId: '1', text: '小山' },
      { optionId: '2', text: '塩田' },
      { optionId: '3', text: '奈良' },
      { optionId: '4', text: '内山' },
    ],
  },
  {
    quizId: '201',
    question:
      '最初、福田はアシスタントに、『KIYOSHI騎士』のアイディアを一つ当たり、いくらのボーナスを払っていた？',
    options: [
      { optionId: '0', text: '1000円' },
      { optionId: '1', text: '500円' },
      { optionId: '2', text: '1500円' },
      { optionId: '3', text: '2000円' },
      { optionId: '4', text: '3000円' },
    ],
  },
  {
    quizId: '202',
    question:
      '作者コメントより問題です。\n当初は岩瀬さん派だった大場つぐみは、途中で誰派へ移行した？',
    options: [
      { optionId: '0', text: '蒼樹さん派' },
      { optionId: '1', text: '見吉派' },
      { optionId: '2', text: '亜豆美保派' },
      { optionId: '3', text: '加藤さん派' },
      { optionId: '4', text: '亜豆美奈派' },
    ],
  },
  {
    quizId: '203',
    question: '谷草北高の開校記念日は？',
    options: [
      { optionId: '0', text: '44727' },
      { optionId: '1', text: '44829' },
      { optionId: '2', text: '44706' },
      { optionId: '3', text: '44839' },
      { optionId: '4', text: '44757' },
    ],
  },
  {
    quizId: '204',
    question: '『疑探偵TRAP』連載時、サイコーが入院した病院は？',
    options: [
      { optionId: '0', text: '谷草市立病院' },
      { optionId: '1', text: '谷草中央病院' },
      { optionId: '2', text: '谷草市民病院' },
      { optionId: '3', text: '谷草総合病院' },
      { optionId: '4', text: '谷草赤十字病院' },
    ],
  },
  {
    quizId: '205',
    question:
      '『疑探偵TRAP』連載時、サイコーが入院したのは、どこが悪くなったから？',
    options: [
      { optionId: '0', text: '肝臓' },
      { optionId: '1', text: '心臓' },
      { optionId: '2', text: '胃' },
      { optionId: '3', text: '左腕' },
      { optionId: '4', text: '脳' },
    ],
  },
  {
    quizId: '206',
    question: '真城最高の入院を亜豆美保に知らせたのは誰？',
    options: [
      { optionId: '0', text: '高木秋人' },
      { optionId: '1', text: '見吉香耶' },
      { optionId: '2', text: '真城最高' },
      { optionId: '3', text: '亜豆の母' },
      { optionId: '4', text: '真城の母' },
    ],
  },
  {
    quizId: '207',
    question: 'サイコーが入院した時、同室だったのは？',
    options: [
      { optionId: '0', text: '北下十一' },
      { optionId: '1', text: '佐藤公文' },
      { optionId: '2', text: '古川宗次' },
      { optionId: '3', text: '橋本仙草' },
      { optionId: '4', text: '満山光丸' },
    ],
  },
  {
    quizId: '208',
    question:
      '亜豆美保が入院した真城最高のもとへ初めて行った時、お見舞いに来ていたのは？',
    options: [
      { optionId: '0', text: '加藤奈津実' },
      { optionId: '1', text: '真城の母' },
      { optionId: '2', text: '高木秋人' },
      { optionId: '3', text: '港浦吾郎' },
      { optionId: '4', text: '見吉香耶' },
    ],
  },
  {
    quizId: '209',
    question: '亜豆美保が真城最高を意識し始めたのはいつから？',
    options: [
      { optionId: '0', text: '小4の市民祭' },
      { optionId: '1', text: '小5の林間学校' },
      { optionId: '2', text: '小6の水泳大会' },
      { optionId: '3', text: '中1の入学式' },
      { optionId: '4', text: '中2の自然教室' },
    ],
  },
  {
    quizId: '210',
    question:
      'サイコーが小4の時に、市民祭で展示されていた絵は何に入選したもの？',
    options: [
      { optionId: '0', text: '愛鳥週間ポスターコンクール' },
      { optionId: '1', text: '防災ポスターコンクール' },
      { optionId: '2', text: '環境月間ポスターコンクール' },
      { optionId: '3', text: '交通安全ポスターコンクール' },
      { optionId: '4', text: '歯科衛生ポスターコンクール' },
    ],
  },
  {
    quizId: '211',
    question: 'サイコ―が小5の時、烏口コンパスを欲しがっていた文具店は？',
    options: [
      { optionId: '0', text: '大林文具店' },
      { optionId: '1', text: '小林文具店' },
      { optionId: '2', text: '中林文具店' },
      { optionId: '3', text: '林文具店' },
      { optionId: '4', text: '木林文具店' },
    ],
  },
  {
    quizId: '212',
    question:
      '真城が入院した際の\n「亜城木先生の所へはお邪魔したこともありお世話になってます 見舞いに行くのが社会人としての筋かと\n病院を教えてください」\nという平丸の台詞に、𠮷田は何と返した？',
    options: [
      { optionId: '0', text: 'マンガ家を社会人だと思うなよ' },
      { optionId: '1', text: '君は休みたいだけだろう' },
      { optionId: '2', text: 'その話を仕上げてからな' },
      { optionId: '3', text: '君と真城くんはそこまでの間柄じゃないだろう' },
      { optionId: '4', text: '実は僕も病院は知らないんだ' },
    ],
  },
  {
    quizId: '213',
    question: '次の内、入院したサイコ―のお見舞いに行ったのが一番遅いのは？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '亜豆美保' },
      { optionId: '3', text: '福田真太' },
      { optionId: '4', text: '服部哲' },
    ],
  },
  {
    quizId: '214',
    question:
      '次の内、ジャンプに連載作品を掲載され始めた頃、ジャンプを読んでいなかった作家は？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '新妻エイジ' },
      { optionId: '3', text: '蒼樹紅' },
      { optionId: '4', text: '高浜翔陽' },
    ],
  },
  {
    quizId: '215',
    question:
      'サイコ―が入院した際、編集部が『疑探偵TRAP』を亜城木夢叶が高校を卒業するまで休載としようとした理由は？',
    options: [
      { optionId: '0', text: '川口たろうが死んだから' },
      { optionId: '1', text: 'ジャンプの質が落ちるから' },
      { optionId: '2', text: '病院に迷惑がかかるから' },
      { optionId: '3', text: '高校生だから' },
      { optionId: '4', text: '病院では作業に支障があるから' },
    ],
  },
  {
    quizId: '216',
    question: '川口たろうの誇りは？',
    options: [
      { optionId: '0', text: '一度も締切を破らず、一度も休載しなかったこと' },
      { optionId: '1', text: 'ジャンプで連載したこと' },
      { optionId: '2', text: '連載だけでなく、アニメ化までしたこと' },
      { optionId: '3', text: '一度も諦めなかったこと' },
      { optionId: '4', text: '自分を甘やかさず、妥協しなかったこと' },
    ],
  },
  {
    quizId: '217',
    question: '中学の卒業式の日に、亜豆美保が真城最高に言った事とは？',
    options: [
      { optionId: '0', text: 'ずっと待ってる' },
      { optionId: '1', text: 'きっと待ってる' },
      { optionId: '2', text: 'えっと…… 待ってる' },
      { optionId: '3', text: 'じっと待ってる' },
      { optionId: '4', text: 'もっと待ってる' },
    ],
  },
  {
    quizId: '218',
    question:
      'サイコ―の入院に際してとられた『疑探偵TRAP』の休載措置の抗議として、ボイコットした作品でないのは？',
    options: [
      { optionId: '0', text: 'Business Boy ケンイチ' },
      { optionId: '1', text: 'CROW' },
      { optionId: '2', text: 'KIYOSHI騎士' },
      { optionId: '3', text: 'hideout door' },
      { optionId: '4', text: 'ラッコ11号' },
    ],
  },
  {
    quizId: '219',
    question:
      '亜城木夢叶の休載措置の抗議としてボイコットしようとししている福田組と編集が話し合った場所は？',
    options: [
      { optionId: '0', text: 'ファミレス' },
      { optionId: '1', text: '新妻エイジの仕事場' },
      { optionId: '2', text: '病院' },
      { optionId: '3', text: '集英社の会議室' },
      { optionId: '4', text: '福田真太の仕事場' },
    ],
  },
  {
    quizId: '220',
    question: '真城最高の手術が行われた曜日は？',
    options: [
      { optionId: '0', text: '月曜日' },
      { optionId: '1', text: '火曜日' },
      { optionId: '2', text: '水曜日' },
      { optionId: '3', text: '木曜日' },
      { optionId: '4', text: '金曜日' },
    ],
  },
  {
    quizId: '221',
    question: '手術を翌週に控えている真城に、亜豆が渡したものは？',
    options: [
      { optionId: '0', text: 'お守り' },
      { optionId: '1', text: '手紙' },
      { optionId: '2', text: 'アルバム' },
      { optionId: '3', text: 'ヘアピン' },
      { optionId: '4', text: 'ヨーグルト' },
    ],
  },
  {
    quizId: '222',
    question: 'サイコ―が入院し休載するまでに『疑探偵TRAP』は何話連載していた？',
    options: [
      { optionId: '0', text: '18話' },
      { optionId: '1', text: '15話' },
      { optionId: '2', text: '16話' },
      { optionId: '3', text: '17話' },
      { optionId: '4', text: '19話' },
    ],
  },
  {
    quizId: '223',
    question:
      'サイコ―の入院に際してとられた『疑探偵TRAP』の休載措置の抗議として、福田組がボイコットしたのはジャンプ何号？',
    options: [
      { optionId: '0', text: '2011年32号' },
      { optionId: '1', text: '2011年22号' },
      { optionId: '2', text: '2011年26号' },
      { optionId: '3', text: '2011年38号' },
      { optionId: '4', text: '2011年44号' },
    ],
  },
  {
    quizId: '224',
    question: 'サイコーが退院した日は？',
    options: [
      { optionId: '0', text: '44819' },
      { optionId: '1', text: '44788' },
      { optionId: '2', text: '44798' },
      { optionId: '3', text: '44809' },
      { optionId: '4', text: '44829' },
    ],
  },
  {
    quizId: '225',
    question: 'サイコーが入院中に描いて作った、疑探偵TRAPのストックは何話分？',
    options: [
      { optionId: '0', text: '12話分' },
      { optionId: '1', text: '10話分' },
      { optionId: '2', text: '14話分' },
      { optionId: '3', text: '16話分' },
      { optionId: '4', text: '18話分' },
    ],
  },
  {
    quizId: '226',
    question: 'サイコーは入院の前後で体重がどれだけ変わった？',
    options: [
      { optionId: '0', text: '6キロ増量' },
      { optionId: '1', text: '3キロ増量' },
      { optionId: '2', text: '10キロ増量' },
      { optionId: '3', text: '2キロ減量' },
      { optionId: '4', text: '4キロ減量' },
    ],
  },
  {
    quizId: '227',
    question: '川口たろうが連載を勝ち獲ってから必要だと考えた3つのものは？',
    options: [
      { optionId: '0', text: '体力、精神力、根性' },
      { optionId: '1', text: '努力、体力、やる気' },
      { optionId: '2', text: '体力、精神力、忍耐力' },
      { optionId: '3', text: '努力、忍耐力、やる気' },
      { optionId: '4', text: '創造力、画力、運' },
    ],
  },
  {
    quizId: '228',
    question: 'サイコーの退院後、疑探偵TRAPが再開したのは何号から？',
    options: [
      { optionId: '0', text: '2011年44号' },
      { optionId: '1', text: '2011年22号' },
      { optionId: '2', text: '2011年26号' },
      { optionId: '3', text: '2011年32号' },
      { optionId: '4', text: '2011年38号' },
    ],
  },
  {
    quizId: '229',
    question: '『怪盗チーター』の作者は？',
    options: [
      { optionId: '0', text: '響恭太郎' },
      { optionId: '1', text: '花先俊' },
      { optionId: '2', text: '棒利歩人' },
      { optionId: '3', text: '紫今日市' },
      { optionId: '4', text: '北城西三' },
    ],
  },
  {
    quizId: '230',
    question: '高浜の描いた作品『Business Boy ケンイチ』の主人公は？',
    options: [
      { optionId: '0', text: '椿ケンイチ' },
      { optionId: '1', text: '桜ケンイチ' },
      { optionId: '2', text: '榎本ケンイチ' },
      { optionId: '3', text: '柊ケンイチ' },
      { optionId: '4', text: '桃城ケンイチ' },
    ],
  },
  {
    quizId: '231',
    question:
      '高浜の描いた作品『Business Boy ケンイチ』、読切では残り金額いくらで終わった？',
    options: [
      { optionId: '0', text: '2億8794万7641円' },
      { optionId: '1', text: '2億1684万982円' },
      { optionId: '2', text: '2億6465万9841円' },
      { optionId: '3', text: '2億861万8413円' },
      { optionId: '4', text: '2億4543万5158円' },
    ],
  },
  {
    quizId: '232',
    question:
      '『疑探偵TRAP』連載再開と同時期に『推理屋明智五郎』が連載開始した雑誌は？',
    options: [
      { optionId: '0', text: '少年ウィーク' },
      { optionId: '1', text: 'ヤングスリー' },
      { optionId: '2', text: 'マーガレット' },
      { optionId: '3', text: '少年スリー' },
      { optionId: '4', text: 'ジャンプSQ' },
    ],
  },
  {
    quizId: '233',
    question: '『推理屋明智五郎』の原作者は？',
    options: [
      { optionId: '0', text: '紫今日市' },
      { optionId: '1', text: '花先俊' },
      { optionId: '2', text: '響恭太郎' },
      { optionId: '3', text: '棒利歩人' },
      { optionId: '4', text: '北城西三' },
    ],
  },
  {
    quizId: '234',
    question: '『推理屋明智五郎』の作画担当は？',
    options: [
      { optionId: '0', text: '花先俊' },
      { optionId: '1', text: '響恭太郎' },
      { optionId: '2', text: '棒利歩人' },
      { optionId: '3', text: '紫今日市' },
      { optionId: '4', text: '北城西三' },
    ],
  },
  {
    quizId: '235',
    question: '『CROW』のアニメ、放送時間は？',
    options: [
      { optionId: '0', text: '夕方6時から' },
      { optionId: '1', text: '夕方5時半から' },
      { optionId: '2', text: '朝7時から' },
      { optionId: '3', text: '朝7時から' },
      { optionId: '4', text: '深夜2時から' },
    ],
  },
  {
    quizId: '236',
    question: '『疑探偵TRAP』のヒロインは？',
    options: [
      { optionId: '0', text: 'アミ' },
      { optionId: '1', text: 'マイ' },
      { optionId: '2', text: 'ナホ' },
      { optionId: '3', text: 'サキ' },
      { optionId: '4', text: 'リン' },
    ],
  },
  {
    quizId: '237',
    question: '響恭太郎の本名は？',
    options: [
      { optionId: '0', text: '中島芳介' },
      { optionId: '1', text: '響京一' },
      { optionId: '2', text: '岩本真' },
      { optionId: '3', text: '新庄力勇' },
      { optionId: '4', text: '天場隼人' },
    ],
  },
  {
    quizId: '238',
    question: '平丸がラッコ11号の連載を始めた年に購入した車は？',
    options: [
      { optionId: '0', text: 'ポルシェ' },
      { optionId: '1', text: 'フェラーリ' },
      { optionId: '2', text: 'ランボルギーニ' },
      { optionId: '3', text: 'ベントレー' },
      { optionId: '4', text: 'ベンツ' },
    ],
  },
  {
    quizId: '239',
    question: '平丸の会社勤め時の給料は？',
    options: [
      { optionId: '0', text: '手取り25万足らず' },
      { optionId: '1', text: '手取り20万足らず' },
      { optionId: '2', text: '手取り30万程度' },
      { optionId: '3', text: '手取り35万程度' },
      { optionId: '4', text: '手取り40万超' },
    ],
  },
  {
    quizId: '240',
    question: '亜豆が娘役の声優として出演したアメリカのドラマは？',
    options: [
      { optionId: '0', text: 'ドクターファミリー' },
      { optionId: '1', text: 'ミスターバーム' },
      { optionId: '2', text: 'ストレートフラッシュ' },
      { optionId: '3', text: 'バックパーク' },
      { optionId: '4', text: 'ミレニアム' },
    ],
  },
  {
    quizId: '241',
    question: '『疑探偵TRAP』と同時期に連載終了となった作品は？',
    options: [
      { optionId: '0', text: 'hideout door' },
      { optionId: '1', text: '怪盗チーター' },
      { optionId: '2', text: 'KIYOSHI騎士' },
      { optionId: '3', text: 'チーズおかき' },
      { optionId: '4', text: '#NAME?' },
    ],
  },
  {
    quizId: '242',
    question:
      '『疑探偵TRAP』、『hideout door』の連載終了と入れ替わりで連載開始となった作品は？',
    options: [
      { optionId: '0', text: '『ストロベリーシュート』、『防音 THUNDER』' },
      {
        optionId: '1',
        text: '「Business Boy ケンイチ」、「チャランポリンリンランラン」',
      },
      { optionId: '2', text: '「怪盗チーター」、「防音 THUNDER」' },
      { optionId: '3', text: '「ガードギアス」、「S→NのSTORY」' },
      { optionId: '4', text: '「ガードギアス」、「迷宮の鍵」' },
    ],
  },
  {
    quizId: '243',
    question: '『ストロベリーシュート』の作者は？',
    options: [
      { optionId: '0', text: '棒利歩人' },
      { optionId: '1', text: '花先俊' },
      { optionId: '2', text: '響恭太郎' },
      { optionId: '3', text: '木村一気' },
      { optionId: '4', text: '北城西三' },
    ],
  },
  {
    quizId: '244',
    question: '『防音 THUNDER』の作者は？',
    options: [
      { optionId: '0', text: '木村一気' },
      { optionId: '1', text: '花先俊' },
      { optionId: '2', text: '響恭太郎' },
      { optionId: '3', text: '棒利歩人' },
      { optionId: '4', text: '北城西三' },
    ],
  },
  {
    quizId: '245',
    question:
      '『疑探偵TRAP』の終了をアシスタントに伝えた時、小河が亜城木にまず聞いたことは？',
    options: [
      { optionId: '0', text: '新連載が始まる先生' },
      { optionId: '1', text: '最終話までの展開' },
      { optionId: '2', text: '次作の予定' },
      { optionId: '3', text: '最近の順位' },
      { optionId: '4', text: '担当の電話番号' },
    ],
  },
  {
    quizId: '246',
    question: '『疑探偵TRAP』のコミックは全何冊？',
    options: [
      { optionId: '0', text: '5冊' },
      { optionId: '1', text: '3冊' },
      { optionId: '2', text: '7冊' },
      { optionId: '3', text: '9冊' },
      { optionId: '4', text: '11冊' },
    ],
  },
  {
    quizId: '247',
    question:
      '『疑探偵TRAP』終了を亜豆に知らせた時、亜豆はいつまでには結婚したいとメールに入れて真城に送信していた？',
    options: [
      { optionId: '0', text: '40歳まで' },
      { optionId: '1', text: '30歳まで' },
      { optionId: '2', text: '50歳まで' },
      { optionId: '3', text: '60歳まで' },
      { optionId: '4', text: '27歳まで' },
    ],
  },
  {
    quizId: '248',
    question: '真城最高達の通った大学は？',
    options: [
      { optionId: '0', text: '八名大経済学部' },
      { optionId: '1', text: '谷草大経済学部' },
      { optionId: '2', text: '八名大外国語学部' },
      { optionId: '3', text: '谷草大外総合社会学部' },
      { optionId: '4', text: '弥原大外国語学部' },
    ],
  },
  {
    quizId: '249',
    question:
      '『hideout door』が終わってから、蒼樹紅に何故私の原作で描きたいのか聞かれて、中井は何と答えた？',
    options: [
      { optionId: '0', text: '蒼樹さんを好きだから' },
      { optionId: '1', text: '蒼樹さんと仕事がしたいから' },
      { optionId: '2', text: '蒼樹さんを忘れられないから' },
      { optionId: '3', text: '蒼樹さんの作品が好きだから' },
      { optionId: '4', text: '蒼樹さんしか考えられないから' },
    ],
  },
  {
    quizId: '250',
    question: '亜城木夢叶が『Future watch(仮)』を投稿したのは？',
    options: [
      { optionId: '0', text: '第56回2月期月例賞' },
      { optionId: '1', text: '第46回4月期月例賞' },
      { optionId: '2', text: '第50回8月期月例賞' },
      { optionId: '3', text: '第53回11月期月例賞' },
      { optionId: '4', text: '第61回7月期月例賞' },
    ],
  },
  {
    quizId: '251',
    question:
      '亜城木夢叶が『Future watch(仮)』を投稿した月例賞の審査員となっていた作家は？',
    options: [
      { optionId: '0', text: '新妻エイジ' },
      { optionId: '1', text: '尾田栄一郎' },
      { optionId: '2', text: '鳥山明' },
      { optionId: '3', text: '福田真太' },
      { optionId: '4', text: '空知英秋' },
    ],
  },
  {
    quizId: '252',
    question: '『Future watch(仮)』で主人公の父が主人公に残したものの一つは？',
    options: [
      { optionId: '0', text: '莫大な借金' },
      { optionId: '1', text: '過去に戻れる腕時計' },
      { optionId: '2', text: '携帯電話' },
      { optionId: '3', text: '学業守り' },
      { optionId: '4', text: '当たり馬券' },
    ],
  },
  {
    quizId: '253',
    question:
      '『Future watch-未来時計-』に出てくる時計は、何分後の未来へ行ける時計？',
    options: [
      { optionId: '0', text: '7分後' },
      { optionId: '1', text: '2分後' },
      { optionId: '2', text: '5分後' },
      { optionId: '3', text: '10分後' },
      { optionId: '4', text: '15分後' },
    ],
  },
  {
    quizId: '254',
    question: '『Future watch-未来時計-』の主人公の名前は？',
    options: [
      { optionId: '0', text: '光速男' },
      { optionId: '1', text: '時岡分路' },
      { optionId: '2', text: '間時一' },
      { optionId: '3', text: '朴野未来' },
      { optionId: '4', text: '安住頼人' },
    ],
  },
  {
    quizId: '255',
    question: 'シュージンがネームを描く際に大事だと言っていたことは？',
    options: [
      { optionId: '0', text: '似てる話あるかどうかは調べない' },
      { optionId: '1', text: '思い浮かんだらすぐに描く' },
      { optionId: '2', text: '悩んだら初めから読み直す' },
      { optionId: '3', text: '描く前に大筋の話は決めておく' },
      { optionId: '4', text: 'サイコ―の絵に合う話を考える' },
    ],
  },
  {
    quizId: '256',
    question: 'サイコ―達の受験した大学入試、合格発表日は？',
    options: [
      { optionId: '0', text: '44605' },
      { optionId: '1', text: '44617' },
      { optionId: '2', text: '44629' },
      { optionId: '3', text: '44633' },
      { optionId: '4', text: '44637' },
    ],
  },
  {
    quizId: '257',
    question:
      '月例賞に無断で応募したことでもめていた港浦と亜城木の仲裁に入ったのは？',
    options: [
      { optionId: '0', text: '服部哲' },
      { optionId: '1', text: '服部雄二郎' },
      { optionId: '2', text: '𠮷田幸司' },
      { optionId: '3', text: '相田聡一' },
      { optionId: '4', text: '瓶子吉久' },
    ],
  },
  {
    quizId: '258',
    question: '第56回2月期月例賞に出されていなかった作品は？',
    options: [
      { optionId: '0', text: 'U-400' },
      { optionId: '1', text: '裏返しチェブー' },
      { optionId: '2', text: 'thirteen soccer' },
      { optionId: '3', text: '斜本(日本の終わり)' },
      { optionId: '4', text: 'Me group' },
    ],
  },
  {
    quizId: '259',
    question:
      '第56回2月期月例賞に出されていた作品の内、新妻エイジの評価がオール1でなかった作品は？',
    options: [
      { optionId: '0', text: 'Me group' },
      { optionId: '1', text: '9秒12' },
      { optionId: '2', text: '裏返しチェブー' },
      { optionId: '3', text: 'thirteen soccer' },
      { optionId: '4', text: '飛ぶ勇者' },
    ],
  },
  {
    quizId: '260',
    question:
      '第56回2月期月例賞に出されていた『Future watch』、新妻エイジの審査が5ではなかった項目は？',
    options: [
      { optionId: '0', text: 'キャラクター' },
      { optionId: '1', text: '演出力' },
      { optionId: '2', text: 'オリジナリティ' },
      { optionId: '3', text: '構成力' },
      { optionId: '4', text: 'ストーリー' },
    ],
  },
  {
    quizId: '261',
    question: '静河流の『斜本(日本の終わり)』の月例賞での結果は？',
    options: [
      { optionId: '0', text: '新妻エイジ賞' },
      { optionId: '1', text: '最終候補止まり' },
      { optionId: '2', text: '佳作' },
      { optionId: '3', text: '亜城木夢叶賞' },
      { optionId: '4', text: '準入選' },
    ],
  },
  {
    quizId: '262',
    question: '第56回2月期月例賞のフリワケで山久が選んだ作家は？',
    options: [
      { optionId: '0', text: '静河流、田中三子' },
      { optionId: '1', text: '田所左輔、有北タイチ' },
      { optionId: '2', text: '静河流、佐々村和日' },
      { optionId: '3', text: '静河流、有北タイチ' },
      { optionId: '4', text: '静河流、未多功一' },
    ],
  },
  {
    quizId: '263',
    question: '第56回2月期月例賞で佳作となった作品は？',
    options: [
      { optionId: '0', text: 'とどめの6発' },
      { optionId: '1', text: '9秒12' },
      { optionId: '2', text: 'take up north' },
      { optionId: '3', text: 'MEMORY BLUE' },
      { optionId: '4', text: '飛ぶ勇者' },
    ],
  },
  {
    quizId: '264',
    question: '石沢が4コママンガを連載した雑誌は？',
    options: [
      { optionId: '0', text: 'キャラキラコミック' },
      { optionId: '1', text: 'ヤングスリー' },
      { optionId: '2', text: '少年スリー' },
      { optionId: '3', text: '少年ウィーク' },
      { optionId: '4', text: 'ジャンプSQ' },
    ],
  },
  {
    quizId: '265',
    question: '連載会議で、『TEN』には笑いが必要ないと特に感じていたのは？',
    options: [
      { optionId: '0', text: '瓶子吉久' },
      { optionId: '1', text: '𠮷田幸司' },
      { optionId: '2', text: '相田聡一' },
      { optionId: '3', text: '中路' },
      { optionId: '4', text: '中野' },
    ],
  },
  {
    quizId: '266',
    question:
      '第1回『バクマン。』“マンガ”人気投票結果発表、第3位となった作品は？',
    options: [
      { optionId: '0', text: 'この世は金と知恵' },
      { optionId: '1', text: '疑探偵TRAP' },
      { optionId: '2', text: 'CROW' },
      { optionId: '3', text: 'ラッコ11号' },
      { optionId: '4', text: 'KIYOSHI騎士' },
    ],
  },
  {
    quizId: '267',
    question:
      '次の内、第1回『バクマン。』“マンガ”人気投票結果発表で順位が高かったのは？',
    options: [
      { optionId: '0', text: 'Haitenpepoo' },
      { optionId: '1', text: 'Large bander' },
      { optionId: '2', text: 'エンジェルデイズ' },
      { optionId: '3', text: 'やる気なヤンキー' },
      { optionId: '4', text: 'カラフジカル' },
    ],
  },
  {
    quizId: '268',
    question:
      '月例賞に応募し審査してもらった『Future watch』、オリジナリティの評価は？',
    options: [
      { optionId: '0', text: '4' },
      { optionId: '1', text: '1' },
      { optionId: '2', text: '2' },
      { optionId: '3', text: '3' },
      { optionId: '4', text: '5' },
    ],
  },
  {
    quizId: '269',
    question:
      '高浜のアシスタントに入った中井が、仕事場に到着し、まず高浜に頼んだことは？',
    options: [
      { optionId: '0', text: 'ヒゲ剃り貸してもらえるかな？' },
      { optionId: '1', text: '作業スペースを広くしてもらえないか？' },
      { optionId: '2', text: '原稿を見してくれないか？' },
      { optionId: '3', text: '持ってる資料本を出してくれないか？' },
      { optionId: '4', text: 'トイレの場所を教えてもらえるかな？' },
    ],
  },
  {
    quizId: '270',
    question:
      '登場初期の静河流は、他人が同じ部屋にいるのは、精神的に何分が限界だった？',
    options: [
      { optionId: '0', text: '5分' },
      { optionId: '1', text: '10分' },
      { optionId: '2', text: '15分' },
      { optionId: '3', text: '20分' },
      { optionId: '4', text: '30分' },
    ],
  },
  {
    quizId: '271',
    question:
      'TENの台詞\n「人は簡単に死ぬがライフルの引金は簡単には引けない」\nに続くのは？',
    options: [
      { optionId: '0', text: 'なぜならこのライフルの引金が固いから' },
      { optionId: '1', text: 'なぜならライフルより人の命は重いから' },
      { optionId: '2', text: 'なぜなら殺人犯になってしまうから' },
      { optionId: '3', text: 'なぜならセーフティの外し方を知らないから' },
      { optionId: '4', text: 'なぜなら引き金が壊れてしまっているから' },
    ],
  },
  {
    quizId: '272',
    question:
      'ジャンプ25号で連載開始した『Business Boy ケンイチ』、ジャンプの表紙で主人公が口にくわえていたものは？',
    options: [
      { optionId: '0', text: '食パン' },
      { optionId: '1', text: 'メロンパン' },
      { optionId: '2', text: '焼きそばパン' },
      { optionId: '3', text: 'クリームパン' },
      { optionId: '4', text: 'パイプ' },
    ],
  },
  {
    quizId: '273',
    question:
      '『Future watch-未来時計-』を読んだ亜豆のメール\n「読みました 私も真城くんと一緒に居る未来に早く行きたいような早く行っちゃったらもったいないような…(♡)」\nに対する真城の返信は？',
    options: [
      {
        optionId: '0',
        text: '僕は病院で2人で居る時 時間よ止まれと思いました…',
      },
      {
        optionId: '1',
        text: '僕は亜豆さんと一緒に居られる未来へ早くいきたいです',
      },
      { optionId: '2', text: '僕は未来じゃなくて中学時代に戻りたいです' },
      { optionId: '3', text: 'お互い未来を目指して励みましょう！' },
      { optionId: '4', text: 'いつか恋愛ものの作品も描くので読んでください' },
    ],
  },
  {
    quizId: '274',
    question: 'アンケートがコンピューター集計でないのは？',
    options: [
      { optionId: '0', text: '99年以前' },
      { optionId: '1', text: '97年以前' },
      { optionId: '2', text: '94年以前' },
      { optionId: '3', text: '93年以前' },
      { optionId: '4', text: '90年以前' },
    ],
  },
  {
    quizId: '275',
    question: '亜城木夢叶の『TEN』、平均指示年齢は？',
    options: [
      { optionId: '0', text: '13.6歳' },
      { optionId: '1', text: '9.4歳' },
      { optionId: '2', text: '10.8歳' },
      { optionId: '3', text: '15.2歳' },
      { optionId: '4', text: '18.7歳' },
    ],
  },
  {
    quizId: '276',
    question:
      '亜城木夢叶が打ち合わせでよく使うファミレス、作中では「Famires」ですが、大場ネームでは何となっていた？',
    options: [
      { optionId: '0', text: 'DeniRu' },
      { optionId: '1', text: "FAMILY'S" },
      { optionId: '2', text: 'DESTINYS' },
      { optionId: '3', text: "Demy's" },
      { optionId: '4', text: "Yummy's" },
    ],
  },
  {
    quizId: '277',
    question:
      '蒼樹紅が男性視点での恋愛を人から聞こうかと悩んだ時に、生理的に嫌だと感じた相手は？',
    options: [
      { optionId: '0', text: '山久雅和' },
      { optionId: '1', text: '中井拓郎' },
      { optionId: '2', text: '平丸一也' },
      { optionId: '3', text: '相田聡一' },
      { optionId: '4', text: '福田真太' },
    ],
  },
  {
    quizId: '278',
    question: '岩瀬愛子が通っているのは東応大のどの学部？',
    options: [
      { optionId: '0', text: '文学部' },
      { optionId: '1', text: '外国語学部' },
      { optionId: '2', text: '経済学部' },
      { optionId: '3', text: '理学部' },
      { optionId: '4', text: '社会学部' },
    ],
  },
  {
    quizId: '279',
    question: '秋名愛子が小説すばる新人賞を受賞した作品は？',
    options: [
      { optionId: '0', text: '緑色の卒業' },
      { optionId: '1', text: '春色の卒業' },
      { optionId: '2', text: '瑠璃色の卒業' },
      { optionId: '3', text: '空色の卒業' },
      { optionId: '4', text: '桃色の卒業' },
    ],
  },
  {
    quizId: '280',
    question:
      'ギャグマンガの資料として港浦が送ってきたダンボールに入っていなかったマンガは？',
    options: [
      { optionId: '0', text: 'ついでにとんちんかん' },
      { optionId: '1', text: '天才バカボン' },
      { optionId: '2', text: 'ハレンチ学園' },
      { optionId: '3', text: 'ど根性ガエル' },
      { optionId: '4', text: 'がきデカ' },
    ],
  },
  {
    quizId: '281',
    question:
      'ギャグマンガの資料として港浦が送ってきたダンボールに入っていた本は？',
    options: [
      {
        optionId: '0',
        text: '笑いの方程式、ギャグの法則、ギャグマンガの描き方',
      },
      {
        optionId: '1',
        text: '笑わせるギャグ、オヤジギャグ100連発、ウケる技術',
      },
      { optionId: '2', text: '笑いの方程式、ギャグの法則、笑撃ユーモア術' },
      {
        optionId: '3',
        text: '笑わせるギャグ、オヤジギャグ100連発、ギャグの法則',
      },
      {
        optionId: '4',
        text: '笑いの方程式、オヤジギャグ100連発、偉人に学ぶ笑い',
      },
    ],
  },
  {
    quizId: '282',
    question: '高木秋人の作る話は、女の子に魅力がないと言っていた編集は？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '服部雄二郎' },
      { optionId: '2', text: '相田聡一' },
      { optionId: '3', text: '服部哲' },
      { optionId: '4', text: '瓶子吉久' },
    ],
  },
  {
    quizId: '283',
    question:
      '子供向けのギャグ作品を作ることに決めた翌日、気分転換にシュージンが出かけた場所は？',
    options: [
      { optionId: '0', text: '動物園' },
      { optionId: '1', text: '博物館' },
      { optionId: '2', text: '水族館' },
      { optionId: '3', text: '映画館' },
      { optionId: '4', text: 'ゲームセンター' },
    ],
  },
  {
    quizId: '284',
    question:
      '大学院に通っている蒼樹紅は、マンガで駄目なら何になろうと考えている？',
    options: [
      { optionId: '0', text: '教師' },
      { optionId: '1', text: '医者' },
      { optionId: '2', text: '保育士' },
      { optionId: '3', text: '出版関係' },
      { optionId: '4', text: '弁護士' },
    ],
  },
  {
    quizId: '285',
    question: 'シュージンが蒼樹紅と意見交換のために初めて電話をかけた時間は？',
    options: [
      { optionId: '0', text: '10時ピッタリ' },
      { optionId: '1', text: '9時ピッタリ' },
      { optionId: '2', text: '11時ピッタリ' },
      { optionId: '3', text: '12時ピッタリ' },
      { optionId: '4', text: '1時ピッタリ' },
    ],
  },
  {
    quizId: '286',
    question:
      'シュージンが動物園で渡された本に挟んであった、岩瀬の手紙に記されていた日付は？',
    options: [
      { optionId: '0', text: '41078' },
      { optionId: '1', text: '41072' },
      { optionId: '2', text: '41102' },
      { optionId: '3', text: '41133' },
      { optionId: '4', text: '41108' },
    ],
  },
  {
    quizId: '287',
    question:
      '『走れ！大発タント』、主人公「大発タント」の祖父で発明家の名前は？',
    options: [
      { optionId: '0', text: '大発明人' },
      { optionId: '1', text: '大発ゼブラ' },
      { optionId: '2', text: '大発アトレー' },
      { optionId: '3', text: '大発ムーヴ' },
      { optionId: '4', text: '大発デルタ' },
    ],
  },
  {
    quizId: '288',
    question: '『走れ！大発タント』、主人公「大発タント」の担任教師の名前は？',
    options: [
      { optionId: '0', text: '豊田ノア' },
      { optionId: '1', text: '三菱デリカ' },
      { optionId: '2', text: '日産セレナ' },
      { optionId: '3', text: '松田キャロル' },
      { optionId: '4', text: '鈴木パレット' },
    ],
  },
  {
    quizId: '289',
    question: '『走れ！大発タント』、主人公のペットの名前は？',
    options: [
      { optionId: '0', text: 'ニャンワンチューピヨピヨ' },
      { optionId: '1', text: 'ワンモーキィガオガオ' },
      { optionId: '2', text: 'ワンニャンモーピヨピヨ' },
      { optionId: '3', text: 'メ―モーチューガオガオ' },
      { optionId: '4', text: 'メ―キィガオガオ' },
    ],
  },
  {
    quizId: '290',
    question: '『走れ！大発タント』、ヒロインの名前は？',
    options: [
      { optionId: '0', text: '鈴木パレット' },
      { optionId: '1', text: '三菱デリカ' },
      { optionId: '2', text: '日産セレナ' },
      { optionId: '3', text: '松田キャロル' },
      { optionId: '4', text: '豊田ノア' },
    ],
  },
  {
    quizId: '291',
    question:
      '『走れ！大発タント』が赤マル掲載された号に作品が掲載されていた作家は？',
    options: [
      { optionId: '0', text: '静河流、蒼樹紅' },
      { optionId: '1', text: '高浜翔陽、折原一力' },
      { optionId: '2', text: '秋名愛子、蒼樹紅' },
      { optionId: '3', text: '響恭太郎、静河流' },
      { optionId: '4', text: '高浜翔陽、静河流' },
    ],
  },
  {
    quizId: '292',
    question: '『走れ！大発タント』の主人公「大発タント」の外見的特徴は？',
    options: [
      { optionId: '0', text: 'ハート型の髪型、夏でもマフラー' },
      { optionId: '1', text: 'ハート型の髪型、晴れでも長靴' },
      { optionId: '2', text: 'ハート型の髪型、ライト付きゴーグル' },
      { optionId: '3', text: '星型の髪型、夏でもマフラー' },
      { optionId: '4', text: '星型の髪型、晴れでも長靴' },
    ],
  },
  {
    quizId: '293',
    question: '『青葉の頃』の主人公は？',
    options: [
      { optionId: '0', text: '麻芽翔一郎' },
      { optionId: '1', text: '麻芽大豆' },
      { optionId: '2', text: '麻芽達也' },
      { optionId: '3', text: '円藤麻芽' },
      { optionId: '4', text: '河合麻芽' },
    ],
  },
  {
    quizId: '294',
    question: '『青葉の頃』で、中井が作画を担当する為に蒼樹紅に出した条件は？',
    options: [
      { optionId: '0', text: '正式に僕と付き合ってください' },
      { optionId: '1', text: '正式に僕と結婚してください' },
      { optionId: '2', text: '僕の言うことを聞いてください' },
      { optionId: '3', text: '話作りに口を出させてください' },
      { optionId: '4', text: '仕事場を共同にしてください' },
    ],
  },
  {
    quizId: '295',
    question: '『走れ！大発タント』、連載ネームの1話目に登場した発明品は？',
    options: [
      { optionId: '0', text: 'カッコイイ事ばかり言うガム、倍返しパンチギブス' },
      {
        optionId: '1',
        text: '飲むと年寄りになる炭酸飲料ファンタ爺、飲むと若返る強力若元',
      },
      {
        optionId: '2',
        text: 'カッコイイ事ばかり言うガム、着るとヒーローになる1160スーツ',
      },
      {
        optionId: '3',
        text: 'どんなに教科書入れても重くならない無重力ランドセル',
      },
      {
        optionId: '4',
        text: '飲むと悪い事したくなっちゃう乳酸菌飲料、体重の軽くなる無重力アメ',
      },
    ],
  },
  {
    quizId: '296',
    question:
      '高木秋人は岩瀬の1000倍見吉が好きと言っていたが、蒼樹紅と比べると何倍見吉が好き？',
    options: [
      { optionId: '0', text: '3倍' },
      { optionId: '1', text: '10倍' },
      { optionId: '2', text: '30倍' },
      { optionId: '3', text: '100倍' },
      { optionId: '4', text: '300倍' },
    ],
  },
  {
    quizId: '297',
    question: '高木が見吉にプロポーズした場所は？',
    options: [
      { optionId: '0', text: '上野動物園の猿山付近' },
      { optionId: '1', text: '上野動物園のなかよし広場' },
      { optionId: '2', text: '上野動物園の爬虫類館' },
      { optionId: '3', text: '上野動物園のアイアイの森付近' },
      { optionId: '4', text: '上野動物園のクマの丘付近' },
    ],
  },
  {
    quizId: '298',
    question: '福田の仕事場のトイレのドアに貼っている文字は？',
    options: [
      { optionId: '0', text: 'いきなり開けるべからず ノックすること!!' },
      { optionId: '1', text: '最後のヤツは紙補充すること!!' },
      { optionId: '2', text: '開けたら閉める！ 閉めても開けない！' },
      { optionId: '3', text: '出したら流せ!!' },
      { optionId: '4', text: 'マンガ家たるもの常にマンガのことを考えろ!!' },
    ],
  },
  {
    quizId: '299',
    question: '服部哲の同期で、『小説すばる』で編集をしているのは？',
    options: [
      { optionId: '0', text: '谷中' },
      { optionId: '1', text: '古見' },
      { optionId: '2', text: '佐々岡' },
      { optionId: '3', text: '峰倉' },
      { optionId: '4', text: '名波' },
    ],
  },
  {
    quizId: '300',
    question:
      '連載ネームの批評で、静河流の『True human』に「作品は認めるが作者に問題あり。」と書いていたのは？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '大西恒平' },
      { optionId: '2', text: '瓶子吉久' },
      { optionId: '3', text: '相田聡一' },
      { optionId: '4', text: '服部雄二郎' },
    ],
  },
  {
    quizId: '301',
    question: '見吉の父親は火、水、木曜日に近くの道場で何を教えている？',
    options: [
      { optionId: '0', text: '空手' },
      { optionId: '1', text: '少林寺' },
      { optionId: '2', text: '柔道' },
      { optionId: '3', text: '合気道' },
      { optionId: '4', text: '剣道' },
    ],
  },
  {
    quizId: '302',
    question:
      '山久が『青葉の頃』を連載会議に出していた頃に担当していた作品は？',
    options: [
      { optionId: '0', text: 'バターマン' },
      { optionId: '1', text: 'タラコーン' },
      { optionId: '2', text: 'ガードギアス' },
      { optionId: '3', text: 'ノンフィクションゲーム' },
      { optionId: '4', text: 'ハウスルール' },
    ],
  },
  {
    quizId: '303',
    question: '中井の地元は？',
    options: [
      { optionId: '0', text: '秋田' },
      { optionId: '1', text: '青森' },
      { optionId: '2', text: '岩手' },
      { optionId: '3', text: '宮城' },
      { optionId: '4', text: '山形' },
    ],
  },
  {
    quizId: '304',
    question:
      '「作品の結果が出なかったのを編集部や担当のせいにする作家は1番愚かだと考えている」\n誰の台詞？',
    options: [
      { optionId: '0', text: '佐々木' },
      { optionId: '1', text: '瓶子' },
      { optionId: '2', text: '𠮷田' },
      { optionId: '3', text: '相田' },
      { optionId: '4', text: '中野' },
    ],
  },
  {
    quizId: '305',
    question: '山久が静河流の部屋へ行き、一緒にしていたゲームのジャンルは？',
    options: [
      { optionId: '0', text: '格闘ゲーム' },
      { optionId: '1', text: 'シューティングゲーム' },
      { optionId: '2', text: '落ちものゲーム' },
      { optionId: '3', text: 'サッカーゲーム' },
      { optionId: '4', text: 'レースゲーム' },
    ],
  },
  {
    quizId: '306',
    question: '静河流はいつから引き籠もりになった？',
    options: [
      { optionId: '0', text: '中2' },
      { optionId: '1', text: '小2' },
      { optionId: '2', text: '小4' },
      { optionId: '3', text: '小6' },
      { optionId: '4', text: '高1' },
    ],
  },
  {
    quizId: '307',
    question: '『走れ！大発タント』、悪のライバル発明家は？',
    options: [
      { optionId: '0', text: '目樽ブラック' },
      { optionId: '1', text: '窓布ラップ' },
      { optionId: '2', text: '黒武メッキ' },
      { optionId: '3', text: '災戸ランプ' },
      { optionId: '4', text: '番波フェイス' },
    ],
  },
  {
    quizId: '308',
    question: '『走れ！大発タント』、悪のライバル発明家の孫の名前は？',
    options: [
      { optionId: '0', text: '目樽桃' },
      { optionId: '1', text: '目樽蒼' },
      { optionId: '2', text: '目樽碧' },
      { optionId: '3', text: '目樽桜' },
      { optionId: '4', text: '目樽紅' },
    ],
  },
  {
    quizId: '309',
    question: '『＋NATURAL』を連載会議に出した際の、新妻エイジのペンネームは？',
    options: [
      { optionId: '0', text: 'MONEYS' },
      { optionId: '1', text: '明倉かずや' },
      { optionId: '2', text: 'イズナ' },
      { optionId: '3', text: '石江自院' },
      { optionId: '4', text: '一時限目' },
    ],
  },
  {
    quizId: '310',
    question: '『＋NATURAL』の主人公は？',
    options: [
      { optionId: '0', text: 'マナブ' },
      { optionId: '1', text: 'ツトム' },
      { optionId: '2', text: 'カズト' },
      { optionId: '3', text: 'カイト' },
      { optionId: '4', text: 'アキラ' },
    ],
  },
  {
    quizId: '311',
    question: '連載会議でMONEYSが新妻エイジだと気付いた編集は？',
    options: [
      { optionId: '0', text: '𠮷田' },
      { optionId: '1', text: '佐々木' },
      { optionId: '2', text: '中野' },
      { optionId: '3', text: '大西' },
      { optionId: '4', text: '瓶子' },
    ],
  },
  {
    quizId: '312',
    question: '大場つぐみがネームで指定していた静河流のイメージに無いものは？',
    options: [
      { optionId: '0', text: '情緒不安定' },
      { optionId: '1', text: '清潔感がある' },
      { optionId: '2', text: '暗い' },
      { optionId: '3', text: '神経質' },
      { optionId: '4', text: '無感・無表情' },
    ],
  },
  {
    quizId: '313',
    question: '見吉の父親への挨拶の練習で、真城が高木に聞いていたことは？',
    options: [
      { optionId: '0', text: 'マンガ家で生計は立つのかね' },
      { optionId: '1', text: '香耶のどこが好きなのかな' },
      { optionId: '2', text: '今の貯金はどれだけあるのかね' },
      { optionId: '3', text: '子どもは何人になる予定かな' },
      { optionId: '4', text: 'どんな家庭を築こうと思っているのかな' },
    ],
  },
  {
    quizId: '314',
    question: '平丸は新妻エイジがジャンプで2本連載する事を誰に聞いた？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '真城最高' },
      { optionId: '3', text: '高木秋人' },
      { optionId: '4', text: '蒼樹紅' },
    ],
  },
  {
    quizId: '315',
    question:
      '蒼樹紅へのプレゼントとして、2012年12月25日に𠮷田が平丸に渡したものは？',
    options: [
      { optionId: '0', text: 'ティファニーの2012年限定ネックレス' },
      { optionId: '1', text: 'カルティエの2012年限定ネックレス' },
      { optionId: '2', text: 'ブルガリの2012年限定ネックレス' },
      { optionId: '3', text: 'カルティエの2012年限定リング' },
      { optionId: '4', text: 'ブルガリの2012年限定リング' },
    ],
  },
  {
    quizId: '316',
    question:
      '初対面で新妻エイジに\n「ハゥドユド───です！」\nと言われ、岩瀬が返した台詞は？',
    options: [
      { optionId: '0', text: 'Pleased to meet you' },
      { optionId: '1', text: 'How do you do' },
      { optionId: '2', text: 'はじめまして' },
      { optionId: '3', text: "I'm glad to see you" },
      { optionId: '4', text: 'あなたが新妻さんですか' },
    ],
  },
  {
    quizId: '317',
    question:
      '新妻エイジがジャンプで2本連載する事が決まってから行われた福田組の集会、新妻エイジのどのような一言で集会は終わった？',
    options: [
      { optionId: '0', text: '文句は勝ってから言え' },
      { optionId: '1', text: '僕の作品が一番です' },
      { optionId: '2', text: '皆さんお疲れですし もう休みましょう' },
      { optionId: '3', text: '結論は本誌で決めましょう' },
      { optionId: '4', text: '話は僕の新連載を見てからです' },
    ],
  },
  {
    quizId: '318',
    question: 'シュージンが婚約の件で見吉家へ挨拶に行った日は？',
    options: [
      { optionId: '0', text: '44922' },
      { optionId: '1', text: '44921' },
      { optionId: '2', text: '44923' },
      { optionId: '3', text: '44924' },
      { optionId: '4', text: '44925' },
    ],
  },
  {
    quizId: '319',
    question: '見吉の母親が結婚した時の年齢は？',
    options: [
      { optionId: '0', text: '19歳' },
      { optionId: '1', text: '16歳' },
      { optionId: '2', text: '22歳' },
      { optionId: '3', text: '25歳' },
      { optionId: '4', text: '28歳' },
    ],
  },
  {
    quizId: '320',
    question: '見吉の父が中学生時に所属していた部活は？',
    options: [
      { optionId: '0', text: '柔道部' },
      { optionId: '1', text: '空手部' },
      { optionId: '2', text: 'テニス部' },
      { optionId: '3', text: '剣道部' },
      { optionId: '4', text: 'マンガ研究部' },
    ],
  },
  {
    quizId: '321',
    question: '中学時代、見吉の父は真城信弘を何と呼んでいた？',
    options: [
      { optionId: '0', text: 'ノブ' },
      { optionId: '1', text: 'シンコー' },
      { optionId: '2', text: 'マーちゃん' },
      { optionId: '3', text: 'マヒロ' },
      { optionId: '4', text: 'クリボー' },
    ],
  },
  {
    quizId: '322',
    question:
      '高木秋人が婚約の件で見吉家へ行った際、真城最高呼び出して、高木秋人、見吉の父親との三人で話した場所は？',
    options: [
      { optionId: '0', text: 'Famires' },
      { optionId: '1', text: '道場' },
      { optionId: '2', text: '亜城木の仕事場' },
      { optionId: '3', text: '真城家' },
      { optionId: '4', text: '病院' },
    ],
  },
  {
    quizId: '323',
    question: '中学時代、真城信弘は見吉の父を何と呼んでいた？',
    options: [
      { optionId: '0', text: 'ヨッシー' },
      { optionId: '1', text: 'マリオ' },
      { optionId: '2', text: 'クッパ' },
      { optionId: '3', text: 'パックン' },
      { optionId: '4', text: 'ドンキー' },
    ],
  },
  {
    quizId: '324',
    question:
      '真城信弘、見吉の父はキャンディーズならスーちゃん、ピンクレディならケイちゃん、おニャン子なら？',
    options: [
      { optionId: '0', text: 'その子ちゃん' },
      { optionId: '1', text: '新田ちゃん' },
      { optionId: '2', text: 'まみまみ' },
      { optionId: '3', text: 'ゆうゆ' },
      { optionId: '4', text: 'あっこ' },
    ],
  },
  {
    quizId: '325',
    question:
      '『走れ！大発タント』の連載で亜城木夢叶が出席していた新年会で、最後まで残っていた作家は？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '新妻エイジ' },
      { optionId: '3', text: '高木秋人' },
      { optionId: '4', text: '蒼樹紅' },
    ],
  },
  {
    quizId: '326',
    question: '折原一力が『超ヒーロー伝説』の中で特に好きな話は？',
    options: [
      { optionId: '0', text: '「たっちゃん編」と「おたんこ仮面」' },
      { optionId: '1', text: '「腕レンジャー編」と「ひょっとこ仮面」' },
      { optionId: '2', text: '「やっちゃん編」と「ひょっとこ仮面」' },
      { optionId: '3', text: '「表宇宙編」と「おたんこ仮面」' },
      { optionId: '4', text: '「やっちゃん編」と「腕レンジャー編」' },
    ],
  },
  {
    quizId: '327',
    question: '高木秋人、香耶の新居の家賃は？',
    options: [
      { optionId: '0', text: '5万円' },
      { optionId: '1', text: '0円' },
      { optionId: '2', text: '10万円' },
      { optionId: '3', text: '20万円' },
      { optionId: '4', text: '30万円' },
    ],
  },
  {
    quizId: '328',
    question: '『走れ！大発タント』、3話目の話は？',
    options: [
      {
        optionId: '0',
        text: '飲むと年寄りになる炭酸飲料ファンタ爺 VS 飲むと若返る強力若元！',
      },
      { optionId: '1', text: '着るとヒーローになる1160スーツ' },
      {
        optionId: '2',
        text: 'どんなに教科書入れても重くならない無重力ランドセル',
      },
      { optionId: '3', text: '飲むと悪い事したくなっちゃう乳酸菌飲料' },
      { optionId: '4', text: '福助の服が透ける服透けコンタクト' },
    ],
  },
  {
    quizId: '329',
    question:
      '高木秋人、香耶の新居の引っ越しで、高木秋人に元気がなかった理由は？',
    options: [
      { optionId: '0', text: 'ベッドが気に入らなかったから' },
      { optionId: '1', text: 'タントの順位がイマイチだったから' },
      { optionId: '2', text: 'NATURALが面白いから' },
      { optionId: '3', text: '自分の荷物がほとんどないから' },
      { optionId: '4', text: '運動してなくて体力がないから' },
    ],
  },
  {
    quizId: '330',
    question: '結婚後、高木秋人と香耶で意見が別れたらどのように決めるとした？',
    options: [
      { optionId: '0', text: 'ジャンケン' },
      { optionId: '1', text: '話し合い' },
      { optionId: '2', text: '真城に決めてもらう' },
      { optionId: '3', text: 'にらめっこ' },
      { optionId: '4', text: '交互に決定権を持つ' },
    ],
  },
  {
    quizId: '331',
    question: '高木秋人と香耶の結婚式の日取りは？',
    options: [
      { optionId: '0', text: '44721' },
      { optionId: '1', text: '44714' },
      { optionId: '2', text: '44728' },
      { optionId: '3', text: '44735' },
      { optionId: '4', text: '44742' },
    ],
  },
  {
    quizId: '332',
    question:
      'アンケートで取っていれば、ひとまずは終わらないと編集部で言われている票数は？',
    options: [
      { optionId: '0', text: '100票' },
      { optionId: '1', text: '50票' },
      { optionId: '2', text: '60票' },
      { optionId: '3', text: '80票' },
      { optionId: '4', text: '90票' },
    ],
  },
  {
    quizId: '333',
    question: '『走れ！大発タント』連載時、ジャンプの読者年齢平均は？',
    options: [
      { optionId: '0', text: '17歳' },
      { optionId: '1', text: '11歳' },
      { optionId: '2', text: '13歳' },
      { optionId: '3', text: '15歳' },
      { optionId: '4', text: '19歳' },
    ],
  },
  {
    quizId: '334',
    question:
      '『走れ！大発タント』の参考に、マンガやお笑いの決めギャグを調べていて、シュージンがすごいと思ったギャグは？',
    options: [
      { optionId: '0', text: 'コマネチ！' },
      { optionId: '1', text: 'ゲッツ！' },
      { optionId: '2', text: 'アイーン' },
      { optionId: '3', text: '間違いないっ！' },
      { optionId: '4', text: 'ガチョーン' },
    ],
  },
  {
    quizId: '335',
    question:
      '新妻エイジが『走れ！大発タント』を読んでいないことを伝えるため、服部が港浦を誘った昼食は？',
    options: [
      { optionId: '0', text: '蕎麦' },
      { optionId: '1', text: '寿司' },
      { optionId: '2', text: '中華料理' },
      { optionId: '3', text: 'ラーメン' },
      { optionId: '4', text: '牛丼' },
    ],
  },
  {
    quizId: '336',
    question: 'タントの決めギャグは？',
    options: [
      { optionId: '0', text: 'どうだろうか？' },
      { optionId: '1', text: 'コマネズミ' },
      { optionId: '2', text: 'サーモンピンク' },
      { optionId: '3', text: 'チン発明' },
      { optionId: '4', text: 'ヅラじゃない' },
    ],
  },
  {
    quizId: '337',
    question: 'テレフォンジョギングで新妻エイジを紹介したのは？',
    options: [
      { optionId: '0', text: '何多良幹羅' },
      { optionId: '1', text: '北見リリカ' },
      { optionId: '2', text: '大月奈々観' },
      { optionId: '3', text: '田中美菅' },
      { optionId: '4', text: '郷田多可実' },
    ],
  },
  {
    quizId: '338',
    question: '『CROW』で何多良幹羅が声を当てていた役は？',
    options: [
      { optionId: '0', text: 'LADY CROW' },
      { optionId: '1', text: 'GIRL CROW' },
      { optionId: '2', text: 'MISS CROW' },
      { optionId: '3', text: 'SEXY CROW' },
      { optionId: '4', text: 'DAME CROW' },
    ],
  },
  {
    quizId: '339',
    question: '新妻エイジが出演したテレビ番組は？',
    options: [
      { optionId: '0', text: '笑っていいかも!' },
      { optionId: '1', text: 'モーレツ大陸' },
      { optionId: '2', text: '現代マンガ家事情' },
      { optionId: '3', text: '悦子の部屋' },
      { optionId: '4', text: 'タイガーはごきげんですね' },
    ],
  },
  {
    quizId: '340',
    question: '新妻エイジのテレビ出演に付き添った編集は？',
    options: [
      { optionId: '0', text: '服部哲、服部雄二郎' },
      { optionId: '1', text: '相田聡一、服部雄二郎' },
      { optionId: '2', text: '港浦吾郎、服部雄二郎' },
      { optionId: '3', text: '瓶子吉久、服部雄二郎' },
      { optionId: '4', text: '佐々木尚、服部雄二郎' },
    ],
  },
  {
    quizId: '341',
    question: '高木秋人、香耶の新婚旅行の行き先は？',
    options: [
      { optionId: '0', text: '鬼怒川' },
      { optionId: '1', text: 'ディズニーランド' },
      { optionId: '2', text: '箱根' },
      { optionId: '3', text: '韓国' },
      { optionId: '4', text: '草津' },
    ],
  },
  {
    quizId: '342',
    question: '高木秋人、香耶の新婚旅行、高木秋人の提案した行き先は？',
    options: [
      { optionId: '0', text: 'ディズニーランド' },
      { optionId: '1', text: '鬼怒川' },
      { optionId: '2', text: '箱根' },
      { optionId: '3', text: '韓国' },
      { optionId: '4', text: '草津' },
    ],
  },
  {
    quizId: '343',
    question: '小学生時、「男子嫌い 一生結婚しない」と言っていたのは？',
    options: [
      { optionId: '0', text: '見吉香耶' },
      { optionId: '1', text: '亜豆美保' },
      { optionId: '2', text: '蒼樹紅' },
      { optionId: '3', text: '岩瀬愛子' },
      { optionId: '4', text: '北見リリカ' },
    ],
  },
  {
    quizId: '344',
    question:
      '『走れ！大発タント』の連載終了決定後、「貧すれば鈍する」からお金を使うように高木秋人が言ったことから、香耶が買うと宣言したものは？',
    options: [
      { optionId: '0', text: 'シャネルの口紅' },
      { optionId: '1', text: 'ヴィトンのバッグ' },
      { optionId: '2', text: 'クロエの香水' },
      { optionId: '3', text: 'ティファニーのネックレス' },
      { optionId: '4', text: 'フィアット500' },
    ],
  },
  {
    quizId: '345',
    question:
      '『この世はKTM』が連載会議で落ち、亜城木夢叶が次に描いた作品のジャンルは？',
    options: [
      { optionId: '0', text: '冒険ファンタジー' },
      { optionId: '1', text: 'スポーツ' },
      { optionId: '2', text: 'ラブコメ' },
      { optionId: '3', text: 'ヤンキー' },
      { optionId: '4', text: '学園' },
    ],
  },
  {
    quizId: '346',
    question:
      '『+NATURAL』の打ち合わせ中、\n「最近私の原作を褒めてくれませんね」\nという秋名愛子に、服部は何と返した？',
    options: [
      { optionId: '0', text: 'いつも通りだからだ' },
      { optionId: '1', text: '最初の頃ほどの勢いがないからだ' },
      { optionId: '2', text: '慢心してほしくないからだ' },
      { optionId: '3', text: 'そうだったか？' },
      { optionId: '4', text: '上には上がいるからだ' },
    ],
  },
  {
    quizId: '347',
    question: '亜城木夢叶が『この世はKTM』の次に、連載会議用に描いた作品は？',
    options: [
      { optionId: '0', text: 'STOPPER OF MAGMA (仮題)' },
      { optionId: '1', text: '完全犯罪クラブ' },
      { optionId: '2', text: '魔饗竜伝(仮)' },
      { optionId: '3', text: 'HITMAN10' },
      { optionId: '4', text: '#NAME?' },
    ],
  },
  {
    quizId: '348',
    question: '亜城木夢叶の作品、『STOPPER OF MAGMA(仮題)』の主人公の年齢は？',
    options: [
      { optionId: '0', text: '9歳' },
      { optionId: '1', text: '6歳' },
      { optionId: '2', text: '12歳' },
      { optionId: '3', text: '15歳' },
      { optionId: '4', text: '18歳' },
    ],
  },
  {
    quizId: '349',
    question:
      '静河流の『True human』の連載開始したジャンプ41号で、センターカラーだった作品は？',
    options: [
      { optionId: '0', text: 'BLEACH' },
      { optionId: '1', text: 'CROW' },
      { optionId: '2', text: 'ラッコ11号' },
      { optionId: '3', text: 'KIYOSHI騎士' },
      { optionId: '4', text: 'NARUTO' },
    ],
  },
  {
    quizId: '350',
    question:
      '『ラッコ11号』で、見せ物にされていた人面ラッコを助けに、ラッコがTV局に突撃したトラックはどこのもの？',
    options: [
      { optionId: '0', text: '鮮魚 魚政' },
      { optionId: '1', text: '鮮魚 魚壱' },
      { optionId: '2', text: '鮮魚 魚清' },
      { optionId: '3', text: '鮮魚 魚所' },
      { optionId: '4', text: '鮮魚 魚魚' },
    ],
  },
  {
    quizId: '351',
    question:
      '『ラッコ11号』で、見せ物にされていた人面ラッコを助けに、ラッコが突撃したTV局は？',
    options: [
      { optionId: '0', text: 'すみれTV' },
      { optionId: '1', text: 'さくらTV' },
      { optionId: '2', text: 'あやめTV' },
      { optionId: '3', text: 'キンカンTV' },
      { optionId: '4', text: 'みつばTV' },
    ],
  },
  {
    quizId: '352',
    question: '『ラッコ11号』のアニメ開始時の放送時間は？',
    options: [
      { optionId: '0', text: '深夜1時15分から' },
      { optionId: '1', text: '夕方5時半から' },
      { optionId: '2', text: '朝8時から' },
      { optionId: '3', text: '夕方6時から' },
      { optionId: '4', text: '深夜2時15分から' },
    ],
  },
  {
    quizId: '353',
    question: '「今週の蒼樹紅」情報によると、蒼樹紅の好きな紅茶は？',
    options: [
      { optionId: '0', text: 'アールグレイ' },
      { optionId: '1', text: 'ダージリン' },
      { optionId: '2', text: 'アッサム' },
      { optionId: '3', text: 'オレンジペコ' },
      { optionId: '4', text: 'ウバ' },
    ],
  },
  {
    quizId: '354',
    question:
      '『走れ！大発タント』をやめた亜城木夢叶が、年内の連載会議で通らなければジャンプに作品を載せることが出来なくなるという条件を、香耶は誰から聞いた？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '高木秋人' },
      { optionId: '2', text: '真城最高' },
      { optionId: '3', text: '高浜昇陽' },
      { optionId: '4', text: '港浦吾郎' },
    ],
  },
  {
    quizId: '355',
    question:
      'サイコー、シュージンが服部哲を尾行する際、シュージンは服部の住所をどうやって調べた？',
    options: [
      { optionId: '0', text: '年賀状' },
      { optionId: '1', text: '名刺' },
      { optionId: '2', text: '電話帳' },
      { optionId: '3', text: '港浦に聞いた' },
      { optionId: '4', text: '記憶を辿った' },
    ],
  },
  {
    quizId: '356',
    question: '服部哲の自宅の最寄り駅は？',
    options: [
      { optionId: '0', text: '菊川駅' },
      { optionId: '1', text: '岩本町駅' },
      { optionId: '2', text: '森下駅' },
      { optionId: '3', text: '船堀駅' },
      { optionId: '4', text: '一之江駅' },
    ],
  },
  {
    quizId: '357',
    question: '真城、高木が服部哲を尾行した際に、購入したアイテムは？',
    options: [
      { optionId: '0', text: '帽子、マスク、サングラス' },
      { optionId: '1', text: 'ウィッグ、マスク、サングラス' },
      { optionId: '2', text: '帽子、付けひげ、眼鏡' },
      { optionId: '3', text: 'ウィッグ、付けひげ、サングラス' },
      { optionId: '4', text: '帽子、マスク、眼鏡' },
    ],
  },
  {
    quizId: '358',
    question:
      'サイコ―、シュージンが服部哲を尾行して集英社を見張っていた時に、集英社内から出てきた人物は？',
    options: [
      { optionId: '0', text: '高浜昇陽' },
      { optionId: '1', text: '服部雄二郎' },
      { optionId: '2', text: '茨木' },
      { optionId: '3', text: '新妻エイジ' },
      { optionId: '4', text: '山久雅和' },
    ],
  },
  {
    quizId: '359',
    question: 'サイコ―、シュージンが服部哲を尾行中、服部哲が立ち寄った書店は？',
    options: [
      { optionId: '0', text: '三省堂書店' },
      { optionId: '1', text: '東京堂書店' },
      { optionId: '2', text: '廣文館書店' },
      { optionId: '3', text: '岩波ブックセンター' },
      { optionId: '4', text: '書泉ブックマート' },
    ],
  },
  {
    quizId: '360',
    question:
      'サイコ―、シュージンが服部哲を尾行中、三省堂書店で服部が手に取った本は？',
    options: [
      {
        optionId: '0',
        text: '「恋愛マナー編」、「恋する女性のツボ」、「主導権をにぎる恋愛術」',
      },
      {
        optionId: '1',
        text: '「恋をかなえる基本」、「恋する女性のツボ」、「主導権をにぎる恋愛術」',
      },
      {
        optionId: '2',
        text: '「大人の恋愛力」、「恋する女性のツボ」、「上手くいく恋愛術」',
      },
      {
        optionId: '3',
        text: '「気になる乙女心」、「上手くいく恋愛術」、「すぐに分かる恋愛ガイド」',
      },
      {
        optionId: '4',
        text: '「大人の恋愛力」、「気になる乙女心」、「すぐに分かる恋愛ガイド」',
      },
    ],
  },
  {
    quizId: '361',
    question:
      '「今日の私綺麗ですか？」\nと秋名愛子に聞かれた服部は質問に何と答えた？',
    options: [
      { optionId: '0', text: '綺麗というか若さが眩しいよ' },
      { optionId: '1', text: 'とても綺麗だよ' },
      { optionId: '2', text: 'それはともかくこの文章だが…' },
      { optionId: '3', text: '僕にはない美しさだよ' },
      { optionId: '4', text: '今日も素敵だよ きっといいお嫁さんになるね' },
    ],
  },
  {
    quizId: '362',
    question:
      'サイコ―、シュージンが服部哲を尾行していた際、服部哲、服部雄二郎、港浦吾郎の3人で飲んだ店は？',
    options: [
      { optionId: '0', text: 'ROSE BAR' },
      { optionId: '1', text: 'BRILLIA' },
      { optionId: '2', text: 'Wind bell' },
      { optionId: '3', text: 'Lunar Maria' },
      { optionId: '4', text: 'ハレイロ' },
    ],
  },
  {
    quizId: '363',
    question:
      'サイコ―、シュージンが服部哲を尾行したのに使った時間はおよそ何時間？',
    options: [
      { optionId: '0', text: 'およそ19時間' },
      { optionId: '1', text: 'およそ8時間' },
      { optionId: '2', text: 'およそ12時間' },
      { optionId: '3', text: 'およそ15時間' },
      { optionId: '4', text: 'およそ24時間' },
    ],
  },
  {
    quizId: '364',
    question: '静河流が山久に連れられて出かけた場所は？',
    options: [
      { optionId: '0', text: 'キャバクラ' },
      { optionId: '1', text: '遊園地' },
      { optionId: '2', text: 'ボウリング' },
      { optionId: '3', text: 'ゲーセン' },
      { optionId: '4', text: 'クラブ' },
    ],
  },
  {
    quizId: '365',
    question:
      '香耶が亜豆美保の誕生日プレゼントとして、谷草ヒルタウンで購入したワンピースのラッピングの柄は？',
    options: [
      { optionId: '0', text: 'ハート柄' },
      { optionId: '1', text: 'バラ柄' },
      { optionId: '2', text: '音符柄' },
      { optionId: '3', text: 'タータンチェック' },
      { optionId: '4', text: 'よつ葉柄' },
    ],
  },
  {
    quizId: '366',
    question:
      '真城と高木秋人が、香耶が亜豆美保の誕生日プレゼントに用意したワンピースと似顔絵を交換する際に、真城の携帯電話にあった着信は誰からのものだった？',
    options: [
      { optionId: '0', text: '港浦吾郎' },
      { optionId: '1', text: '服部哲' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '自宅' },
      { optionId: '4', text: '新妻エイジ' },
    ],
  },
  {
    quizId: '367',
    question:
      '『完全犯罪クラブ』の初期ネームの1話目で最初に行われた完全犯罪で、片付けたはずの給食の食器を再び席に置かれていたのは誰？',
    options: [
      { optionId: '0', text: '高橋くん' },
      { optionId: '1', text: '安田くん' },
      { optionId: '2', text: '北村くん' },
      { optionId: '3', text: '六塚くん' },
      { optionId: '4', text: '南くん' },
    ],
  },
  {
    quizId: '368',
    question:
      '『完全犯罪クラブ』の初期ネームの1話目で行われた完全犯罪で、教室に迷い込み授業が中断するきっかけとなった生き物は何？',
    options: [
      { optionId: '0', text: '雀' },
      { optionId: '1', text: 'ゴキブリ' },
      { optionId: '2', text: 'イグアナ' },
      { optionId: '3', text: 'ハムスター' },
      { optionId: '4', text: 'たぬき' },
    ],
  },
  {
    quizId: '369',
    question: '『PCP -完全犯罪党-』のヒロインは？',
    options: [
      { optionId: '0', text: '安之城舞' },
      { optionId: '1', text: '安之城恵' },
      { optionId: '2', text: '安之城唯' },
      { optionId: '3', text: '安之城奏' },
      { optionId: '4', text: '安之城理菜' },
    ],
  },
  {
    quizId: '370',
    question: '『+NATURAL』のアニメが始まったのはいつから？',
    options: [
      { optionId: '0', text: '2014年4月から' },
      { optionId: '1', text: '2014年7月から' },
      { optionId: '2', text: '2014年10月から' },
      { optionId: '3', text: '2014年1月から' },
      { optionId: '4', text: '2015年1月から' },
    ],
  },
  {
    quizId: '371',
    question: '𠮷田さん得意の自業自得',
    options: [
      { optionId: '0', text: '自業自得' },
      { optionId: '1', text: 'よく聞け' },
      { optionId: '2', text: '身から出たサビ' },
      { optionId: '3', text: '因果応報' },
      { optionId: '4', text: '一難去ってまた一難' },
    ],
  },
  {
    quizId: '372',
    question: '『完全犯罪クラブ』、連載会議締切2日前に香耶が指摘した部分は？',
    options: [
      { optionId: '0', text: '「今だに」になってる！ 正しくは「未だに」！' },
      { optionId: '1', text: '「以外に」になってる！ 正しくは「意外に」！' },
      { optionId: '2', text: '「甚しい」になってる！ 正しくは「甚だしい」！' },
      {
        optionId: '3',
        text: '「絶対絶命」になってる！ 正しくは「絶体絶命」！',
      },
      {
        optionId: '4',
        text: '「聞いた風」になってる！ 正しくは「利いた風」！',
      },
    ],
  },
  {
    quizId: '373',
    question:
      '連載会議に出した『完全犯罪クラブ』の上書きに書いた港浦のコメントは？',
    options: [
      { optionId: '0', text: 'こんなマンガ見たことない!!' },
      { optionId: '1', text: '亜城木夢叶の完成形はこれだ！' },
      { optionId: '2', text: '自信の一作です!!' },
      { optionId: '3', text: '言葉で表せない面白さがあります！' },
      { optionId: '4', text: '新しい亜城木夢叶をその目で確認してください！' },
    ],
  },
  {
    quizId: '374',
    question:
      '亜城木夢叶が『完全犯罪クラブ』を連載会議に出していた時のクリスマスイブに、真城、高木秋人、香耶の3人で食べた亜豆手作りのケーキに混入していたものは？',
    options: [
      { optionId: '0', text: 'USBメモリ' },
      { optionId: '1', text: '指輪' },
      { optionId: '2', text: 'SDカード' },
      { optionId: '3', text: '手紙' },
      { optionId: '4', text: 'ペンダント' },
    ],
  },
  {
    quizId: '375',
    question:
      '『完全犯罪クラブ』の批評で「亜城木夢叶の作家性を引き出している」といった内容を書いていたのは？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '大西恒平' },
      { optionId: '2', text: '瓶子吉久' },
      { optionId: '3', text: '佐々木尚' },
      { optionId: '4', text: '相田聡一' },
    ],
  },
  {
    quizId: '376',
    question:
      '『完全犯罪クラブ』について、学校への不法侵入について直しが必要と考えていたのは？',
    options: [
      { optionId: '0', text: '𠮷田幸司' },
      { optionId: '1', text: '大西恒平' },
      { optionId: '2', text: '瓶子吉久' },
      { optionId: '3', text: '佐々木尚' },
      { optionId: '4', text: '相田聡一' },
    ],
  },
  {
    quizId: '377',
    question:
      '『完全犯罪クラブ』を読み、「幼い頃好きな女の子を尾行して家をつきとめた事がある」と言っていたのは？',
    options: [
      { optionId: '0', text: '中野' },
      { optionId: '1', text: '大西' },
      { optionId: '2', text: '矢作' },
      { optionId: '3', text: '瓶子' },
      { optionId: '4', text: '相田' },
    ],
  },
  {
    quizId: '378',
    question:
      '連載会議で行った『完全犯罪クラブ』が新妻エイジの作品に勝っているかの多数決で、負けから勝ちに変更したのは？',
    options: [
      { optionId: '0', text: '大西、中野、瓶子' },
      { optionId: '1', text: '𠮷田、中野、瓶子' },
      { optionId: '2', text: '矢作、中野、瓶子' },
      { optionId: '3', text: '大西、𠮷田、瓶子' },
      { optionId: '4', text: '大西、𠮷田、中野' },
    ],
  },
  {
    quizId: '379',
    question: '香耶の作ったケーキの文字「れんさいおめでとう!!　祝」',
    options: [
      { optionId: '0', text: 'れんさいおめでとう!!　祝' },
      { optionId: '1', text: 'おそらくおめでとう！' },
      { optionId: '2', text: '祝 れんさい決定!!' },
      { optionId: '3', text: 'れんさい決定おめでとう！' },
      { optionId: '4', text: 'おめでとう 亜しろ木む叶！' },
    ],
  },
  {
    quizId: '380',
    question:
      '2013年末に連載会議に回されていた『カタログ請求の神ジョン』の作者は？',
    options: [
      { optionId: '0', text: '甘田シゲオ' },
      { optionId: '1', text: '座星成' },
      { optionId: '2', text: '有北タイチ' },
      { optionId: '3', text: 'オランダカズオ' },
      { optionId: '4', text: '吉田丸夫' },
    ],
  },
  {
    quizId: '381',
    question:
      '2013年末に連載会議に回されていた『カタログ請求の神ジョン』の担当は？',
    options: [
      { optionId: '0', text: '小池' },
      { optionId: '1', text: '本田' },
      { optionId: '2', text: '内田' },
      { optionId: '3', text: '嶋崎' },
      { optionId: '4', text: '門司' },
    ],
  },
  {
    quizId: '382',
    question: '『KIYOSHI騎士』で開かれていた「Y-1」とは何のこと？',
    options: [
      { optionId: '0', text: 'ヤンキータッグトーナメント' },
      { optionId: '1', text: 'やる気な漢トーナメント' },
      { optionId: '2', text: 'やばい男トーナメント' },
      { optionId: '3', text: 'ワイが1番トーナメント' },
      { optionId: '4', text: 'ヤングNo.1トーナメント' },
    ],
  },
  {
    quizId: '383',
    question:
      '『PCP -完全犯罪党-』は何話までに新妻エイジに並べなければ打ち切りになるという条件で連載を開始した？',
    options: [
      { optionId: '0', text: '25話まで' },
      { optionId: '1', text: '10話まで' },
      { optionId: '2', text: '15話まで' },
      { optionId: '3', text: '20話まで' },
      { optionId: '4', text: '30話まで' },
    ],
  },
  {
    quizId: '384',
    question:
      '『ラッコ11号』のラッコフィギュアのシークレットバージョンの「パジャマで尻尾の出てるラッコ」、この尻尾が出せる穴は何のためにある？',
    options: [
      { optionId: '0', text: '寝る時に寝苦しくないように' },
      { optionId: '1', text: 'おしりの部分が膨らまないように' },
      { optionId: '2', text: '尻尾が蒸れてしまわないように' },
      { optionId: '3', text: 'パジャマのままでも泳ぐため' },
      { optionId: '4', text: 'おしゃれのため' },
    ],
  },
  {
    quizId: '385',
    question:
      '『ラッコ11号』のラッコフィギュアのシークレットバージョンでは、ラッコの手を何と付け替えることができる？',
    options: [
      { optionId: '0', text: '本物の石灰岩' },
      { optionId: '1', text: 'ドリル' },
      { optionId: '2', text: 'ホタテ' },
      { optionId: '3', text: 'ホッキ貝' },
      { optionId: '4', text: 'ペーパーナイフ' },
    ],
  },
  {
    quizId: '386',
    question:
      '『完全犯罪クラブ』と新妻エイジの作品を比べ、新妻エイジの方が勝っていると服部哲が言った点は？',
    options: [
      { optionId: '0', text: '遠近感のつけ方' },
      { optionId: '1', text: 'デッサン力' },
      { optionId: '2', text: '写実画' },
      { optionId: '3', text: 'アイデアの量' },
      { optionId: '4', text: '話の意外性' },
    ],
  },
  {
    quizId: '387',
    question:
      '文章原作をマンガにしている新妻エイジについて、何が凄いとサイコーは言っていた？',
    options: [
      { optionId: '0', text: '想像力' },
      { optionId: '1', text: '表現力' },
      { optionId: '2', text: '創造力' },
      { optionId: '3', text: '読解力' },
      { optionId: '4', text: '構成力' },
    ],
  },
  {
    quizId: '388',
    question: '連載会議に出した『完全犯罪クラブ』の時の主人公の名前は？',
    options: [
      { optionId: '0', text: '地光計' },
      { optionId: '1', text: '喜入念' },
      { optionId: '2', text: '細目守' },
      { optionId: '3', text: '周藤洋示' },
      { optionId: '4', text: '智全完一' },
    ],
  },
  {
    quizId: '389',
    question: '新妻エイジの事をエスパーと言ったのは誰？',
    options: [
      { optionId: '0', text: '服部哲' },
      { optionId: '1', text: '服部雄二郎' },
      { optionId: '2', text: '港浦吾郎' },
      { optionId: '3', text: '真城最高' },
      { optionId: '4', text: '福田真太' },
    ],
  },
  {
    quizId: '390',
    question: '2013年末に亜城木夢叶の仕事場に年越しそばの出前をしたのは？',
    options: [
      { optionId: '0', text: '高木香耶庵' },
      { optionId: '1', text: '高木香耶亭' },
      { optionId: '2', text: 'そば処 高木' },
      { optionId: '3', text: '手打ち亭 香耶' },
      { optionId: '4', text: 'そば屋 香耶' },
    ],
  },
  {
    quizId: '391',
    question: '真城最高の参加した成人式の日付は？',
    options: [
      { optionId: '0', text: '参加していない' },
      { optionId: '1', text: '44573' },
      { optionId: '2', text: '44574' },
      { optionId: '3', text: '44580' },
      { optionId: '4', text: '44581' },
    ],
  },
  {
    quizId: '392',
    question:
      '『PCP -完全犯罪党-』主人公のキャラクターデザイン案で、携帯ストラップに付いていなかったツールは？',
    options: [
      { optionId: '0', text: 'ルーペ' },
      { optionId: '1', text: 'ドライバー' },
      { optionId: '2', text: 'メジャー' },
      { optionId: '3', text: 'ホチキス' },
      { optionId: '4', text: 'サバイバルツール' },
    ],
  },
  {
    quizId: '393',
    question: '『hideout door』は全何巻？',
    options: [
      { optionId: '0', text: '全4巻' },
      { optionId: '1', text: '全3巻' },
      { optionId: '2', text: '全5巻' },
      { optionId: '3', text: '全6巻' },
      { optionId: '4', text: '全7巻' },
    ],
  },
  {
    quizId: '394',
    question:
      'シュージンが『PCP -完全犯罪党-』主人公の名前を考えている時に、出ていた案は？',
    options: [
      { optionId: '0', text: '一零' },
      { optionId: '1', text: '廿面海示' },
      { optionId: '2', text: '入野学' },
      { optionId: '3', text: '日高マサル' },
      { optionId: '4', text: '今未来' },
    ],
  },
  {
    quizId: '395',
    question: '次の内、デザイン系の専門学校に通っていたのは？',
    options: [
      { optionId: '0', text: '森屋秀一' },
      { optionId: '1', text: '白鳥シュン' },
      { optionId: '2', text: '折原一力' },
      { optionId: '3', text: '加藤奈津実' },
      { optionId: '4', text: '小河直人' },
    ],
  },
  {
    quizId: '396',
    question: '森屋秀一にとってマンガとは？',
    options: [
      { optionId: '0', text: '自己表現であり芸術' },
      { optionId: '1', text: '生活のための手段' },
      { optionId: '2', text: '現実では起こりえない妄想の場' },
      { optionId: '3', text: '人生そのもの' },
      { optionId: '4', text: 'デザートのようなもの' },
    ],
  },
  {
    quizId: '397',
    question: '『PCP -完全犯罪党-』の主人公達の名前は？',
    options: [
      { optionId: '0', text: '道本真、徳長実' },
      { optionId: '1', text: '本城正太、真木義一' },
      { optionId: '2', text: '尾田正義、竹田公平' },
      { optionId: '3', text: '菅直也、原仁也' },
      { optionId: '4', text: '伊藤海斗、白琴仁志' },
    ],
  },
  {
    quizId: '398',
    question:
      '『PCP -完全犯罪党-』の1話目本ちゃんで420票超えをリアルで初めて見た服部哲は、我に返った時には何をしていた？',
    options: [
      { optionId: '0', text: 'デパートで鯛と赤飯買ってた' },
      { optionId: '1', text: '大声でガッツポーズしてた' },
      { optionId: '2', text: '編集部内の人達と握手' },
      { optionId: '3', text: '焼肉を食べてた' },
      { optionId: '4', text: '亜城木の仕事場に来ていた' },
    ],
  },
  {
    quizId: '399',
    question: '『CROW』第1話のアンケート得票数は？',
    options: [
      { optionId: '0', text: '401票' },
      { optionId: '1', text: '310票' },
      { optionId: '2', text: '382票' },
      { optionId: '3', text: '397票' },
      { optionId: '4', text: '418票' },
    ],
  },
  {
    quizId: '400',
    question:
      '福田真太が『ロードレーサー淵切』の読切を描いているとき、大場ネームでのみ福田真太の作業机に置いてあるものは？',
    options: [
      { optionId: '0', text: '125CCのバイクのフィギュア' },
      { optionId: '1', text: '栄養ドリンク' },
      { optionId: '2', text: 'KIYOSHI騎士' },
      { optionId: '3', text: 'カップ麺' },
      { optionId: '4', text: 'うさぎのぬいぐるみ' },
    ],
  },
  {
    quizId: '401',
    question: '亜豆が最終候補まで残った、『+NATURAL』のヒロインは？',
    options: [
      { optionId: '0', text: '三宮沙也乃' },
      { optionId: '1', text: '川島祐実' },
      { optionId: '2', text: '内田遥' },
      { optionId: '3', text: '八木みさき' },
      { optionId: '4', text: '岩崎彩菜' },
    ],
  },
  {
    quizId: '402',
    question:
      '『+NATURAL』のオーディション時の亜豆美保のプロフィールによると、亜豆の身長は？',
    options: [
      { optionId: '0', text: '162cm' },
      { optionId: '1', text: '156cm' },
      { optionId: '2', text: '157cm' },
      { optionId: '3', text: '159cm' },
      { optionId: '4', text: '164cm' },
    ],
  },
  {
    quizId: '403',
    question:
      '『+NATURAL』のオーディション時の亜豆美保のプロフィールによると、亜豆の体重は？',
    options: [
      { optionId: '0', text: '44kg' },
      { optionId: '1', text: '40kg' },
      { optionId: '2', text: '42kg' },
      { optionId: '3', text: '46kg' },
      { optionId: '4', text: '48kg' },
    ],
  },
  {
    quizId: '404',
    question:
      'アニメ『+NATURAL』の声優オーディションの件で、亜豆が真城に「私達 意地っ張りかな？」メールした時の真城の返信内容は？',
    options: [
      { optionId: '0', text: 'わからない。' },
      { optionId: '1', text: 'どうだろうか？' },
      { optionId: '2', text: '亜豆さんは意地っ張りだね。' },
      { optionId: '3', text: '僕達 意地っ張りだよね。' },
      { optionId: '4', text: '普通だよ。' },
    ],
  },
  {
    quizId: '405',
    question:
      '『KIYOSHI騎士』の連載終了が決定した会議で、次の会議で危険だと判断された作品は？',
    options: [
      { optionId: '0', text: 'True human、カタログ請求の神ジョン' },
      { optionId: '1', text: 'True human、スカウトマン女好' },
      { optionId: '2', text: 'バターマン、スカウトマン女好' },
      { optionId: '3', text: 'タラコーン、チャランポリンリンランラン' },
      { optionId: '4', text: 'バターマン、148cmのGK' },
    ],
  },
  {
    quizId: '406',
    question:
      '蒼樹紅とそのアシスタント、平丸一也、𠮷田幸司、静河流、山久雅和でのお茶会を行う条件として平丸が同意した契約書の内容は？',
    options: [
      { optionId: '0', text: '向こう半年はラッコ11号を休まない' },
      { optionId: '1', text: '向こう1年はラッコ11号を休まない' },
      { optionId: '2', text: '向こう半年は𠮷田の言うことを聞く' },
      { optionId: '3', text: '向こう1年は𠮷田の言うことを聞く' },
      { optionId: '4', text: 'お茶会では𠮷田のアドバイスに従う' },
    ],
  },
  {
    quizId: '407',
    question:
      '『PCP -完全犯罪党-』連載初期、森屋のデザイン系の専門行ってた者としての、真城への発言は？',
    options: [
      { optionId: '0', text: '少しトーンに頼り過ぎです' },
      { optionId: '1', text: '少しベタを使い過ぎです' },
      { optionId: '2', text: '少し線がかたいです' },
      { optionId: '3', text: 'パースがきっちりし過ぎです' },
      { optionId: '4', text: '下書きに時間をかけ過ぎです' },
    ],
  },
  {
    quizId: '408',
    question: '蒼樹紅はいつも飲んでいる紅茶の種類は？',
    options: [
      { optionId: '0', text: 'ダージリン' },
      { optionId: '1', text: 'アールグレイ' },
      { optionId: '2', text: 'アッサム' },
      { optionId: '3', text: 'オレンジペコ' },
      { optionId: '4', text: 'ウバ' },
    ],
  },
  {
    quizId: '409',
    question: 'サイコ―は大学に何年間通った？',
    options: [
      { optionId: '0', text: '2年間' },
      { optionId: '1', text: '1年間' },
      { optionId: '2', text: '3年間' },
      { optionId: '3', text: '4年間' },
      { optionId: '4', text: '5年間' },
    ],
  },
  {
    quizId: '410',
    question: 'アニメ『+NATURAL』の放送開始時間は？',
    options: [
      { optionId: '0', text: '0.770833333333333' },
      { optionId: '1', text: '18時' },
      { optionId: '2', text: '17時' },
      { optionId: '3', text: '0.354166666666667' },
      { optionId: '4', text: '10時' },
    ],
  },
  {
    quizId: '411',
    question:
      '『CROW』がセリフなしの絵だけでストーリーを作ったのはジャンプの何号？',
    options: [
      { optionId: '0', text: '2015年24号' },
      { optionId: '1', text: '2015年16号' },
      { optionId: '2', text: '2015年29号' },
      { optionId: '3', text: '2015年21号' },
      { optionId: '4', text: '2015年30号' },
    ],
  },
  {
    quizId: '412',
    question: '『正義の三肩』の作中年は？',
    options: [
      { optionId: '0', text: '202X年' },
      { optionId: '1', text: '201X年' },
      { optionId: '2', text: '20XX年' },
      { optionId: '3', text: '2XXX年' },
      { optionId: '4', text: '21XX年' },
    ],
  },
  {
    quizId: '413',
    question: '『NANDE!!』の主人公は？',
    options: [
      { optionId: '0', text: '偏差ゴン' },
      { optionId: '1', text: '金田二郎' },
      { optionId: '2', text: '江良理クイン' },
      { optionId: '3', text: '阿宅ハジメ' },
      { optionId: '4', text: '天下統' },
    ],
  },
  {
    quizId: '414',
    question:
      '『CROW』と『+NATURAL』のコラボが行われたのはジャンプの何号から？',
    options: [
      { optionId: '0', text: '2015年30号' },
      { optionId: '1', text: '2015年16号' },
      { optionId: '2', text: '2015年29号' },
      { optionId: '3', text: '2015年21号' },
      { optionId: '4', text: '2015年24号' },
    ],
  },
  {
    quizId: '415',
    question: '『+NATURAL』での言葉、「念生物」を何と読む？',
    options: [
      { optionId: '0', text: 'サイコライフ' },
      { optionId: '1', text: 'ナチュラルネイチャー' },
      { optionId: '2', text: 'プラスライフ' },
      { optionId: '3', text: 'バイオプラス' },
      { optionId: '4', text: 'ユニークモンスター' },
    ],
  },
  {
    quizId: '416',
    question:
      '『PCP -完全犯罪党-』の明知シリーズで、PCPが花火を打ち上げた場所は？',
    options: [
      { optionId: '0', text: '砂場' },
      { optionId: '1', text: 'スプリンクラー' },
      { optionId: '2', text: '鉄棒' },
      { optionId: '3', text: 'グラウンドの中心' },
      { optionId: '4', text: 'すべり台' },
    ],
  },
  {
    quizId: '417',
    question: '真城、高木が中学1年の時、最初の学力テストで4位だったのは？',
    options: [
      { optionId: '0', text: '阿部美々' },
      { optionId: '1', text: '高木秋人' },
      { optionId: '2', text: '岩瀬愛子' },
      { optionId: '3', text: '神保星次' },
      { optionId: '4', text: '相田好示' },
    ],
  },
  {
    quizId: '418',
    question: '真城、高木と、中学生時に同級生だった、神保の親の職業は？',
    options: [
      { optionId: '0', text: '医者' },
      { optionId: '1', text: '弁護士' },
      { optionId: '2', text: '刑事' },
      { optionId: '3', text: 'マンガ家のアシスタント' },
      { optionId: '4', text: '高校教諭' },
    ],
  },
  {
    quizId: '419',
    question:
      '『バクマン。』の第98ページ「握手と手直し」の扉絵に描かれていなかった作品は？',
    options: [
      { optionId: '0', text: '正義の三肩' },
      { optionId: '1', text: '青葉の頃' },
      { optionId: '2', text: 'ラッコ11号' },
      { optionId: '3', text: 'True human' },
      { optionId: '4', text: 'CROW' },
    ],
  },
  {
    quizId: '420',
    question: 'シュージンの中学1年時のクラスは？',
    options: [
      { optionId: '0', text: '1年1組' },
      { optionId: '1', text: '1年2組' },
      { optionId: '2', text: '1年3組' },
      { optionId: '3', text: '1年A組' },
      { optionId: '4', text: '1年B組' },
    ],
  },
  {
    quizId: '421',
    question:
      '『PCP -完全犯罪党-』連載開始当初、集英社前での高木秋人への秋名愛子からの台詞より問題です。\n「………絶対に負けないわよ そっちが負けたら連載を辞めるって言うのなら……\nそうね… 私が負けたら○○」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '裸で逆立ちして集英社のまわり1周' },
      { optionId: '1', text: '道路の真ん中で土下座してもいい' },
      { optionId: '2', text: '犬のようにあなたの靴を舐めてもいい' },
      { optionId: '3', text: 'NATURALの連載を辞める' },
      { optionId: '4', text: 'マンガは二度と描かない' },
    ],
  },
  {
    quizId: '422',
    question:
      '『PCP -完全犯罪党-』の明知シリーズのラストで、明知がPCP -完全犯罪党-に聞いたことは？',
    options: [
      { optionId: '0', text: '「PCP -完全犯罪党-」の最後の「P」は？' },
      {
        optionId: '1',
        text: '「PCP -完全犯罪党-」はいつから結成しているんだ？',
      },
      { optionId: '2', text: '「PCP -完全犯罪党-」は何人組なんだ？' },
      { optionId: '3', text: 'なんでこんな事をしている？' },
      {
        optionId: '4',
        text: '「PCP -完全犯罪党-」の正体を知っているヤツはいるのか？',
      },
    ],
  },
  {
    quizId: '423',
    question: '『PCP -完全犯罪党-』の話数カウントは？',
    options: [
      { optionId: '0', text: 'CRIME' },
      { optionId: '1', text: 'PERFECT' },
      { optionId: '2', text: 'PARTY' },
      { optionId: '3', text: 'TRICK' },
      { optionId: '4', text: 'FILE' },
    ],
  },
  {
    quizId: '424',
    question: '『正義の三肩』で2回目の巻頭カラーは何話目？',
    options: [
      { optionId: '0', text: '15話目' },
      { optionId: '1', text: '23話目' },
      { optionId: '2', text: '25話目' },
      { optionId: '3', text: '30話目' },
      { optionId: '4', text: '49話目' },
    ],
  },
  {
    quizId: '425',
    question:
      '『PCP -完全犯罪党-』連載開始から半年程度の段階で、アニメ制作を打診してきていた会社は？',
    options: [
      { optionId: '0', text: '(株)スタジオ A.N.K' },
      { optionId: '1', text: '(株)マクドハウス' },
      { optionId: '2', text: '(株)A.C.STAFF' },
      { optionId: '3', text: '(株)GOMZO' },
      { optionId: '4', text: '(株)ガイメックス' },
    ],
  },
  {
    quizId: '426',
    question:
      '『PCP -完全犯罪党-』を真似て、公園の砂場に落とし穴を作っていた小学生は？',
    options: [
      { optionId: '0', text: 'あおいちゃんたち' },
      { optionId: '1', text: 'あやなちゃんたち' },
      { optionId: '2', text: 'さおりちゃんたち' },
      { optionId: '3', text: 'なおちゃんたち' },
      { optionId: '4', text: 'ゆみちゃんたち' },
    ],
  },
  {
    quizId: '427',
    question: '白鳥シュンの飼っている犬の名前は？',
    options: [
      { optionId: '0', text: 'ピース' },
      { optionId: '1', text: 'ラフィ' },
      { optionId: '2', text: 'リッチー' },
      { optionId: '3', text: 'ショコラ' },
      { optionId: '4', text: 'ラッキー' },
    ],
  },
  {
    quizId: '428',
    question: '白鳥家が経営しているのは何の会社？',
    options: [
      { optionId: '0', text: '化粧品' },
      { optionId: '1', text: '美術商' },
      { optionId: '2', text: '経営コンサルタント' },
      { optionId: '3', text: '衣料' },
      { optionId: '4', text: 'ソフトウェア開発' },
    ],
  },
  {
    quizId: '429',
    question: '白鳥シュンの『恋太&ピース』の主人公の初期ネームでの名前は？',
    options: [
      { optionId: '0', text: '羅歩田' },
      { optionId: '1', text: '恋太' },
      { optionId: '2', text: '良部太' },
      { optionId: '3', text: '愛汰' },
      { optionId: '4', text: '好田' },
    ],
  },
  {
    quizId: '430',
    question: '『PCP -完全犯罪党-』の小説版の作者は？',
    options: [
      { optionId: '0', text: '田鍋一揆' },
      { optionId: '1', text: '鳴子平八' },
      { optionId: '2', text: '甘原皇乱' },
      { optionId: '3', text: '篠山検地' },
      { optionId: '4', text: '三ヶ嶋刹那' },
    ],
  },
  {
    quizId: '431',
    question: '『恋太&ピース』のピースについて誤った情報は？',
    options: [
      { optionId: '0', text: '目で善人と悪人を見極める事が出来る' },
      { optionId: '1', text: '人と直接の会話は出来ない' },
      { optionId: '2', text: '鼻で善人と悪人を嗅ぎ分ける事が出来る' },
      { optionId: '3', text: '耳で建前が本音で聞く事が出来る' },
      { optionId: '4', text: '舌で舐めると本音を言わせる事が出来る' },
    ],
  },
  {
    quizId: '432',
    question: '2014年10月期の月例賞審査員は？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '亜城木夢叶' },
      { optionId: '3', text: '福田真太' },
      { optionId: '4', text: '尾田栄一郎' },
    ],
  },
  {
    quizId: '433',
    question:
      '白鳥シュンが『恋太&ピース』を応募しようとした10月期の月例賞審査員は？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '秋名愛子' },
      { optionId: '3', text: '岸本斉史' },
      { optionId: '4', text: '秋本治' },
    ],
  },
  {
    quizId: '434',
    question: '読切の『恋太&ピース』の原作者のペンネームは？',
    options: [
      { optionId: '0', text: '木人高秋' },
      { optionId: '1', text: '高木秋人' },
      { optionId: '2', text: '秋木高人' },
      { optionId: '3', text: '木高人秋' },
      { optionId: '4', text: '尾近伊賀方' },
    ],
  },
  {
    quizId: '435',
    question:
      '「白鳥家の長男がマンガの手伝いなんて人に言えない」と、母親がシュンに準備していたのは？',
    options: [
      { optionId: '0', text: 'パリの留学' },
      { optionId: '1', text: 'ロンドンの留学' },
      { optionId: '2', text: 'ベルンの留学' },
      { optionId: '3', text: 'リスボンの留学' },
      { optionId: '4', text: 'フィレンツェの留学' },
    ],
  },
  {
    quizId: '436',
    question: '初登場時の白鳥シュンは父、母を何と呼ぶ？',
    options: [
      { optionId: '0', text: '父さん、母さん' },
      { optionId: '1', text: 'パパ、ママ' },
      { optionId: '2', text: '父君、母君' },
      { optionId: '3', text: 'お父様、お母様' },
      { optionId: '4', text: 'ダディ、マム' },
    ],
  },
  {
    quizId: '437',
    question: '『恋太&ピース』の読切が載ったジャンプで巻頭カラーだった作品は？',
    options: [
      { optionId: '0', text: 'CROW' },
      { optionId: '1', text: 'PCP -完全犯罪党- -完全犯罪党-' },
      { optionId: '2', text: 'ONE PIECE' },
      { optionId: '3', text: '#NAME?' },
      { optionId: '4', text: 'NARUTO' },
    ],
  },
  {
    quizId: '438',
    question:
      '読切の『恋太&ピース』の原作が高木のだと、新妻エイジは何から気付いた？',
    options: [
      { optionId: '0', text: '人間の本音の部分' },
      { optionId: '1', text: '原作名' },
      { optionId: '2', text: '話のエグさ' },
      { optionId: '3', text: 'なんとなく、雰囲気' },
      { optionId: '4', text: '独特なセリフの言い回し' },
    ],
  },
  {
    quizId: '439',
    question:
      '『PCP -完全犯罪党-』の安之城舞は「地球最後の日に何食べたい？」と聞かれて何と答えた？',
    options: [
      { optionId: '0', text: '楽に死ねる薬飲む' },
      { optionId: '1', text: '睡眠薬飲んで眠りたい' },
      { optionId: '2', text: 'メロンお腹いっぱい食べたい' },
      { optionId: '3', text: 'ママの手料理かな' },
      { optionId: '4', text: '地球最後の日にならないと分からない' },
    ],
  },
  {
    quizId: '440',
    question:
      '服部哲にダメを出されて、森屋秀一が自分の作品を持ち込んだ雑誌は？',
    options: [
      { optionId: '0', text: '少年スリー' },
      { optionId: '1', text: 'ヤングジャンプ' },
      { optionId: '2', text: '少年ウィーク' },
      { optionId: '3', text: '月刊ハッスル' },
      { optionId: '4', text: '少年キック' },
    ],
  },
  {
    quizId: '441',
    question: '一人暮らしを始めた白鳥シュンは、どのようにご飯を炊こうとした？',
    options: [
      { optionId: '0', text: '炊飯器にお米入れて熱湯入れて3分' },
      { optionId: '1', text: '炊飯器を空のままスイッチオン' },
      { optionId: '2', text: '炊飯器にお米だけ入れてスイッチオン' },
      { optionId: '3', text: '炊飯器にお米入れて水入れて火にかける' },
      { optionId: '4', text: 'お米をレンジでチン' },
    ],
  },
  {
    quizId: '442',
    question: '白鳥シュンの姉の名前は？',
    options: [
      { optionId: '0', text: '人美' },
      { optionId: '1', text: '麻美' },
      { optionId: '2', text: '明美' },
      { optionId: '3', text: '一美' },
      { optionId: '4', text: '裕美' },
    ],
  },
  {
    quizId: '443',
    question:
      '『恋太&ピース』の読切が載った号、センターカラーは『恋太&ピース』と何？',
    options: [
      { optionId: '0', text: 'デビルデーモン' },
      { optionId: '1', text: '黒帯ナイン!!' },
      { optionId: '2', text: 'ガードギアス' },
      { optionId: '3', text: 'スカウトマン女好' },
      { optionId: '4', text: 'CROW' },
    ],
  },
  {
    quizId: '444',
    question: '白鳥シュンの父親、初登場時の年齢は？',
    options: [
      { optionId: '0', text: '46歳' },
      { optionId: '1', text: '42歳' },
      { optionId: '2', text: '44歳' },
      { optionId: '3', text: '48歳' },
      { optionId: '4', text: '50歳' },
    ],
  },
  {
    quizId: '445',
    question: '白鳥シュンの姉が母親に内緒で単行本を買っていた作品は？',
    options: [
      { optionId: '0', text: 'SLAM DUNK、るろうに剣心' },
      { optionId: '1', text: 'SLAM DUNK、幽☆遊☆白書' },
      { optionId: '2', text: 'SLAM DUNK、DRAGON BALL' },
      { optionId: '3', text: 'SLAM DUNK、キャプテン翼' },
      { optionId: '4', text: 'SLAM DUNK、遊☆戯☆王' },
    ],
  },
  {
    quizId: '446',
    question:
      '白鳥シュンの説得に亜城木の仕事場にやってきた白鳥家の面々、帰った後白鳥シュンの姉をステキだと感じていたのは？',
    options: [
      { optionId: '0', text: '森屋秀一' },
      { optionId: '1', text: '折原一力' },
      { optionId: '2', text: '加藤奈津実' },
      { optionId: '3', text: '高木秋人' },
      { optionId: '4', text: '真城最高' },
    ],
  },
  {
    quizId: '447',
    question: '『ラッコ11号』の連載機関はおよそ何年？',
    options: [
      { optionId: '0', text: '4年' },
      { optionId: '1', text: '1年' },
      { optionId: '2', text: '2年' },
      { optionId: '3', text: '3年' },
      { optionId: '4', text: '5年' },
    ],
  },
  {
    quizId: '448',
    question: '『ラッコ11号』と同時期に連載が終了した作品は？',
    options: [
      { optionId: '0', text: '青葉の頃' },
      { optionId: '1', text: '美味しい餃子の作り方' },
      { optionId: '2', text: 'KIYOSHI騎士' },
      { optionId: '3', text: 'ツタヤのタツヤ' },
      { optionId: '4', text: 'こんなシュートどうですか' },
    ],
  },
  {
    quizId: '449',
    question: '次の内、人気作家恋愛読切祭への参加決定が最も遅かったのは？',
    options: [
      { optionId: '0', text: '福田真太' },
      { optionId: '1', text: '亜城木夢叶' },
      { optionId: '2', text: '新妻エイジ' },
      { optionId: '3', text: '平丸一也' },
      { optionId: '4', text: '新井貴作' },
    ],
  },
  {
    quizId: '450',
    question:
      '真城が人気作家恋愛読切祭への参加決定した12月末、作品に悩んで散歩に出た際に自動販売機で購入した飲み物は？',
    options: [
      { optionId: '0', text: 'ブラックコーヒー' },
      { optionId: '1', text: 'ココア' },
      { optionId: '2', text: 'コーンポタージュ' },
      { optionId: '3', text: 'おしるこ' },
      { optionId: '4', text: '抹茶ミルク' },
    ],
  },
  {
    quizId: '451',
    question:
      '新妻エイジが、NATURALの声優オーディションの時に真城が亜豆を連れていった時に思い出した映画は？',
    options: [
      { optionId: '0', text: '卒業' },
      { optionId: '1', text: '１７歳のカルテ' },
      { optionId: '2', text: 'めぐりあい' },
      { optionId: '3', text: '青春残酷物語' },
      { optionId: '4', text: 'きつね' },
    ],
  },
  {
    quizId: '452',
    question: '新年会で、シュージンが見ていて落ち着くと言っていたのは？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '蒼樹紅' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '高浜翔陽' },
      { optionId: '4', text: '相田聡一' },
    ],
  },
  {
    quizId: '453',
    question: '新井が投稿時代によく描いていたマンガのジャンルは？',
    options: [
      { optionId: '0', text: 'ラブコメ' },
      { optionId: '1', text: 'スポ根' },
      { optionId: '2', text: 'ギャグ' },
      { optionId: '3', text: '異世界ファンタジー' },
      { optionId: '4', text: '動物' },
    ],
  },
  {
    quizId: '454',
    question:
      '恋愛ものの読切について、新年会前に真城が亜豆に電話した際、大場ネームでは亜豆の着信音は誰の曲だった？',
    options: [
      { optionId: '0', text: 'コブクロ' },
      { optionId: '1', text: 'ゆず' },
      { optionId: '2', text: 'Mr.Children' },
      { optionId: '3', text: '宇多田ヒカル' },
      { optionId: '4', text: 'aiko' },
    ],
  },
  {
    quizId: '455',
    question:
      '人気作家恋愛読切祭で掲載された、亜城木夢叶の『ささやかな時』の主人公、ヒロインの名前は？',
    options: [
      { optionId: '0', text: '健吾、明花' },
      { optionId: '1', text: '高次、美来' },
      { optionId: '2', text: '秋良、香恋' },
      { optionId: '3', text: '拓己、真央' },
      { optionId: '4', text: '夏樹、美咲' },
    ],
  },
  {
    quizId: '456',
    question:
      '人気作家恋愛読切祭で掲載された、蒼樹紅の『神様がくれた…』の主人公、ヒロインのキューピッド名前は？',
    options: [
      { optionId: '0', text: '陽斗、ルナ' },
      { optionId: '1', text: '悠太、マリ' },
      { optionId: '2', text: 'アキラ、ハル' },
      { optionId: '3', text: 'マモル、ルナ' },
      { optionId: '4', text: '雪人、ハル' },
    ],
  },
  {
    quizId: '457',
    question:
      '人気作家恋愛読切祭で掲載された、秋名愛子の『4春期』の作画担当は？',
    options: [
      { optionId: '0', text: '八本木八郎' },
      { optionId: '1', text: '一本木一郎' },
      { optionId: '2', text: '三本木三郎' },
      { optionId: '3', text: '六本木六郎' },
      { optionId: '4', text: '十本木十郎' },
    ],
  },
  {
    quizId: '458',
    question:
      '人気作家恋愛読切祭で掲載された、亜城木夢叶の『ささやかな時』の主人公、ヒロインの名前は？',
    options: [
      { optionId: '0', text: 'カズオ、涼子' },
      { optionId: '1', text: 'カズヤ、陽子' },
      { optionId: '2', text: 'カズヒコ、静' },
      { optionId: '3', text: 'カズオ、桃子' },
      { optionId: '4', text: 'カズヤ、遥' },
    ],
  },
  {
    quizId: '459',
    question: '『バクマン。』キャラ人気投票結果発表!!で1位だったのは？',
    options: [
      { optionId: '0', text: '新妻エイジ' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '高木秋人' },
      { optionId: '3', text: '平丸一也' },
      { optionId: '4', text: '亜豆美保' },
    ],
  },
  {
    quizId: '460',
    question:
      '『バクマン。』キャラ人気投票結果発表!!で作中作品の登場人物の内、最も順位が高かったのは？',
    options: [
      { optionId: '0', text: 'ラッコ11号' },
      { optionId: '1', text: 'クロウ' },
      { optionId: '2', text: '道本真' },
      { optionId: '3', text: '疑探偵TRAP' },
      { optionId: '4', text: 'KIYOSHI' },
    ],
  },
  {
    quizId: '461',
    question: '『バクマン。』キャラ人気投票結果発表!!で同票30位でない人物は？',
    options: [
      { optionId: '0', text: '安岡' },
      { optionId: '1', text: 'KOOGY' },
      { optionId: '2', text: '鳥嶋取締役' },
      { optionId: '3', text: '茨木編集長(SQ.)' },
      { optionId: '4', text: 'プリンスエイト社長' },
    ],
  },
  {
    quizId: '462',
    question: '人気作家恋愛読切祭用直前に、『+NATURAL』に出てきた新念生物は？',
    options: [
      { optionId: '0', text: 'モモサビ' },
      { optionId: '1', text: 'ピヨメキ' },
      { optionId: '2', text: 'イノギリ' },
      { optionId: '3', text: 'パトロイ' },
      { optionId: '4', text: 'パンビータ' },
    ],
  },
  {
    quizId: '463',
    question: 'ピースのエサ代は一月当たりどのくらい？',
    options: [
      { optionId: '0', text: '4～5万' },
      { optionId: '1', text: '5～6千' },
      { optionId: '2', text: '7～8千' },
      { optionId: '3', text: '1～2万' },
      { optionId: '4', text: '2～3万' },
    ],
  },
  {
    quizId: '464',
    question:
      '亜城木夢叶の仕事場から、白鳥シュンが一人暮らししている家までどのくらい？',
    options: [
      { optionId: '0', text: '自転車で3分くらい' },
      { optionId: '1', text: '徒歩で3分くらい' },
      { optionId: '2', text: '自転車で5分くらい' },
      { optionId: '3', text: 'タクシーで10分くらい' },
      { optionId: '4', text: '徒歩で5分くらい' },
    ],
  },
  {
    quizId: '465',
    question: '白鳥シュンがアシスタントを辞めた時の森屋の台詞は？',
    options: [
      {
        optionId: '0',
        text: '人生とは出会いと別れの繰り返し… 別れは出会いの始まり…',
      },
      { optionId: '1', text: '別れはこの世の理 仕方のないことです' },
      { optionId: '2', text: '一期一会を大切に…' },
      {
        optionId: '3',
        text: '会うは別れの始め… そして別れなくして出会いなし…',
      },
      { optionId: '4', text: '僕は君のことを忘れない' },
    ],
  },
  {
    quizId: '466',
    question: '『ラッコ11号』のラストは？',
    options: [
      { optionId: '0', text: '海に帰ったラッコがカリブ海に漂うラスト' },
      { optionId: '1', text: '海に帰ったラッコが日本海に漂うラスト' },
      { optionId: '2', text: '海に帰ったラッコが地中海に漂うラスト' },
      { optionId: '3', text: '海に帰ったラッコがインド洋に漂うラスト' },
      { optionId: '4', text: '海に帰ったラッコがアラビア海に漂うラスト' },
    ],
  },
  {
    quizId: '467',
    question:
      '𠮷田の用意した「お茶会における平丸くん、蒼樹さん会話シナリオ」で2枚目が白紙だった事について、「ジャンプコミックスだって表紙の次は必ず白紙のページが1枚あるだろ」と説明した時の背景にあったマンガは？',
    options: [
      { optionId: '0', text: 'いぬまるだしっ' },
      { optionId: '1', text: '保健室の死神' },
      { optionId: '2', text: 'めだかボックス' },
      { optionId: '3', text: '賢い犬リリエンタール' },
      { optionId: '4', text: 'ぬらりひょんの孫' },
    ],
  },
  {
    quizId: '468',
    question: 'サイコーが初めて殴った人は？',
    options: [
      { optionId: '0', text: '高木秋人' },
      { optionId: '1', text: '鈴木' },
      { optionId: '2', text: '石沢' },
      { optionId: '3', text: '七峰透' },
      { optionId: '4', text: '山下' },
    ],
  },
  {
    quizId: '469',
    question:
      'サイコー、シュージンの二人がもみじ公園で殴り合った時、サイコ―の初撃はガードされましたが二撃目はどこに決まった？',
    options: [
      { optionId: '0', text: 'アゴ' },
      { optionId: '1', text: 'メガネ' },
      { optionId: '2', text: '首' },
      { optionId: '3', text: '胸' },
      { optionId: '4', text: '腹' },
    ],
  },
  {
    quizId: '470',
    question: '白鳥シュンの仕事場の間取りは？',
    options: [
      { optionId: '0', text: '2LDK' },
      { optionId: '1', text: '1LDK' },
      { optionId: '2', text: '2DK' },
      { optionId: '3', text: '1DK' },
      { optionId: '4', text: '3DK' },
    ],
  },
  {
    quizId: '471',
    question: '人気作家恋愛読切祭での掲載が最も遅かったのは？',
    options: [
      { optionId: '0', text: '少年E少女B' },
      { optionId: '1', text: '殺生由意' },
      { optionId: '2', text: '4春期' },
      { optionId: '3', text: '僕には通じない' },
      { optionId: '4', text: '神様がくれた…' },
    ],
  },
  {
    quizId: '472',
    question:
      '人気作家恋愛読切祭で掲載された新妻エイジの『LOVE力AtoZ』の主人公の名前は？',
    options: [
      { optionId: '0', text: '風斗' },
      { optionId: '1', text: '侑介' },
      { optionId: '2', text: '祈織' },
      { optionId: '3', text: '琉生' },
      { optionId: '4', text: '棗' },
    ],
  },
  {
    quizId: '473',
    question:
      '人気作家恋愛読切祭で掲載された新妻エイジの『LOVE力AtoZ』を読んだ亜城木夢叶の仕事場の面々の内、面白くないと感じたのは？',
    options: [
      { optionId: '0', text: '高木、加藤' },
      { optionId: '1', text: '真城、折原、森屋' },
      { optionId: '2', text: '高木、折原、森屋' },
      { optionId: '3', text: '真城、加藤' },
      { optionId: '4', text: '折原、加藤、森屋' },
    ],
  },
  {
    quizId: '474',
    question: '新妻エイジが小学2年生の時に好きだった、隣のクラスの女の子は？',
    options: [
      { optionId: '0', text: '外海時江' },
      { optionId: '1', text: '対馬ゆかり' },
      { optionId: '2', text: '相馬恵美' },
      { optionId: '3', text: '野呂井加奈' },
      { optionId: '4', text: '棟方喜子' },
    ],
  },
  {
    quizId: '475',
    question: '人気作家恋愛読切祭で3位となった作品は？',
    options: [
      { optionId: '0', text: '少年E少女B' },
      { optionId: '1', text: '僕には通じない' },
      { optionId: '2', text: 'ささやかな時' },
      { optionId: '3', text: '殺生由意' },
      { optionId: '4', text: '4春期' },
    ],
  },
  {
    quizId: '476',
    question:
      '人気作家恋愛読切祭で1位となった『神様がくれた…』は、1000票のアンケート集計の内、何票獲得した？',
    options: [
      { optionId: '0', text: '259票' },
      { optionId: '1', text: '512票' },
      { optionId: '2', text: '402票' },
      { optionId: '3', text: '330票' },
      { optionId: '4', text: '188票' },
    ],
  },
  {
    quizId: '477',
    question:
      '平丸のポルシェを安岡は1日ドライブすることを条件にいくらで購入した？',
    options: [
      { optionId: '0', text: '10万円' },
      { optionId: '1', text: '1万円' },
      { optionId: '2', text: '5万円' },
      { optionId: '3', text: '50万円' },
      { optionId: '4', text: '100万円' },
    ],
  },
  {
    quizId: '478',
    question: '平丸が蒼樹紅に交際を申し込む際に用意したプレゼントは？',
    options: [
      { optionId: '0', text: 'ティファニー' },
      { optionId: '1', text: 'カルティエ' },
      { optionId: '2', text: 'ブルガリ' },
      { optionId: '3', text: 'グッチ' },
      { optionId: '4', text: 'ルイ・ヴィトン' },
    ],
  },
  {
    quizId: '479',
    question: '𠮷田は平丸を何年に1人の逸材と言った？',
    options: [
      { optionId: '0', text: '2～3年に1人' },
      { optionId: '1', text: '半年に1人' },
      { optionId: '2', text: '1年に1人' },
      { optionId: '3', text: '3～4年に1人' },
      { optionId: '4', text: '5年に1人' },
    ],
  },
  {
    quizId: '480',
    question: '平丸の蒼樹紅への交際申し込みした際の告白の台詞は？',
    options: [
      {
        optionId: '0',
        text: '初めて会った時綺麗な人だ！好きだ！って思いました\n付き合ってください',
      },
      { optionId: '1', text: '初恋でした！\n付き合ってください' },
      {
        optionId: '2',
        text: '一目ぼれです！これまでもこれからも一生大好きです\n付き合ってください',
      },
      {
        optionId: '3',
        text: '好きです！ずっとあなたと寄り添っていたいです！\n付き合ってください',
      },
      {
        optionId: '4',
        text: '一目見て「大好き！」と感じました\n付き合ってください',
      },
    ],
  },
  {
    quizId: '481',
    question: '2015年5月期の月例賞の審査員は誰？',
    options: [
      { optionId: '0', text: '亜城木夢叶' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '蒼樹紅' },
      { optionId: '3', text: '福田真太' },
      { optionId: '4', text: '久保帯人' },
    ],
  },
  {
    quizId: '482',
    question:
      '『PCP -完全犯罪党-』の連載50回で亜城木夢叶が出席した連載表彰式に出席していなかったのは？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '平丸一也' },
      { optionId: '3', text: '福田真太' },
      { optionId: '4', text: '高浜翔陽' },
    ],
  },
  {
    quizId: '483',
    question:
      '『PCP -完全犯罪党-』の連載50回で亜城木夢叶が出席した連載表彰式、『+NATURAL』は連載何回で表彰されていた？',
    options: [
      { optionId: '0', text: '100回' },
      { optionId: '1', text: '表彰されていない' },
      { optionId: '2', text: '150回' },
      { optionId: '3', text: '200回' },
      { optionId: '4', text: '250回' },
    ],
  },
  {
    quizId: '484',
    question: '作中初期の週刊少年ジャンプ編集長である佐々木の名前は？',
    options: [
      { optionId: '0', text: '尚' },
      { optionId: '1', text: '作中では不明' },
      { optionId: '2', text: '尚継' },
      { optionId: '3', text: '尚哉' },
      { optionId: '4', text: '尚佳' },
    ],
  },
  {
    quizId: '485',
    question:
      '『PCP -完全犯罪党-』の連載50回で亜城木夢叶が出席した連載表彰式で、締めの挨拶をしたのは？',
    options: [
      { optionId: '0', text: '瓶子' },
      { optionId: '1', text: '𠮷田' },
      { optionId: '2', text: '佐々木' },
      { optionId: '3', text: '鳥嶋' },
      { optionId: '4', text: '相田' },
    ],
  },
  {
    quizId: '486',
    question: '『シンジツの教室』で主人公のクラス1年C組の担任は？',
    options: [
      { optionId: '0', text: '中村先生' },
      { optionId: '1', text: '神谷先生' },
      { optionId: '2', text: '小野先生' },
      { optionId: '3', text: '石田先生' },
      { optionId: '4', text: '平川先生' },
    ],
  },
  {
    quizId: '487',
    question:
      '『シンジツの教室』で主人公のクラス1年C組の中で最も脱落が速かった生徒は？？',
    options: [
      { optionId: '0', text: '田上' },
      { optionId: '1', text: '小倉' },
      { optionId: '2', text: '仁藤' },
      { optionId: '3', text: '高橋' },
      { optionId: '4', text: '渡辺' },
    ],
  },
  {
    quizId: '488',
    question: '『シンジツの教室』で主人公のクラス1年C組の生徒は何人？',
    options: [
      { optionId: '0', text: '37人' },
      { optionId: '1', text: '31人' },
      { optionId: '2', text: '33人' },
      { optionId: '3', text: '35人' },
      { optionId: '4', text: '39人' },
    ],
  },
  {
    quizId: '489',
    question: '『シンジツの教室』の主人公の名前は？',
    options: [
      { optionId: '0', text: '高橋' },
      { optionId: '1', text: '田上' },
      { optionId: '2', text: '小倉' },
      { optionId: '3', text: '仁藤' },
      { optionId: '4', text: '渡辺' },
    ],
  },
  {
    quizId: '490',
    question:
      '『シンジツの教室』で主人公のクラス1年C組内で皆が黙ってから行われた質問タイム、最初に質問された学級委員の名前は？',
    options: [
      { optionId: '0', text: '渡辺' },
      { optionId: '1', text: '田上' },
      { optionId: '2', text: '小倉' },
      { optionId: '3', text: '仁藤' },
      { optionId: '4', text: '高橋' },
    ],
  },
  {
    quizId: '491',
    question: '『シンジツの教室』で主人公のクラス1年C組の副委員長は？',
    options: [
      { optionId: '0', text: '佐伯' },
      { optionId: '1', text: '三木' },
      { optionId: '2', text: '南原' },
      { optionId: '3', text: '志摩' },
      { optionId: '4', text: '上野' },
    ],
  },
  {
    quizId: '492',
    question:
      '『シンジツの教室』で主人公のクラス1年C組の副委員長が学級委員に立候補した理由は？',
    options: [
      { optionId: '0', text: 'クラスの皆の為により良いクラスにするため' },
      { optionId: '1', text: '学級委員をやれば内申書が良くなると聞いたから' },
      { optionId: '2', text: '皆の上に立つのが気持ちいいから' },
      { optionId: '3', text: '友達に勧められたから' },
      { optionId: '4', text: 'クラスを自分好みに変えたかったから' },
    ],
  },
  {
    quizId: '493',
    question:
      '『シンジツの教室』で主人公のクラス1年C組で起きた体操服盗難事件の被害者は？',
    options: [
      { optionId: '0', text: '南原' },
      { optionId: '1', text: '三木' },
      { optionId: '2', text: '佐伯' },
      { optionId: '3', text: '志摩' },
      { optionId: '4', text: '上野' },
    ],
  },
  {
    quizId: '494',
    question:
      '『シンジツの教室』で主人公のクラス1年C組で起きた体操服盗難事件の犯人は？',
    options: [
      { optionId: '0', text: '志摩' },
      { optionId: '1', text: '三木' },
      { optionId: '2', text: '南原' },
      { optionId: '3', text: '佐伯' },
      { optionId: '4', text: '上野' },
    ],
  },
  {
    quizId: '495',
    question:
      '『シンジツの教室』で主人公のクラス1年C組内でペアを作った時、ペアを組めずに脱落したのは？',
    options: [
      { optionId: '0', text: '三木' },
      { optionId: '1', text: '志摩' },
      { optionId: '2', text: '南原' },
      { optionId: '3', text: '佐伯' },
      { optionId: '4', text: '上野' },
    ],
  },
  {
    quizId: '496',
    question: '『シンジツの教室』での情報として間違っているのは？',
    options: [
      { optionId: '0', text: '1年C組の出席番号1番は石田くん' },
      { optionId: '1', text: '放送の声の主は『カミ』を名乗った' },
      { optionId: '2', text: '1年C組の担任教師は眼鏡をかけている' },
      { optionId: '3', text: '第1ゲームで時、教室内は時間が止まっていた' },
      { optionId: '4', text: '1年C組で盗難事件が起きたのは5月13日' },
    ],
  },
  {
    quizId: '497',
    question: '『シンジツの教室』での情報として間違っているのは？',
    options: [
      { optionId: '0', text: 'ネットで自分を含めた10人で協力して作った' },
      { optionId: '1', text: '第1ゲームで脱落せず1年C組から脱出できたのは8人' },
      {
        optionId: '2',
        text: '第1ゲームでは脱落するための故意の嘘では脱落しない',
      },
      {
        optionId: '3',
        text: '第1ゲームで1年C組での質問タイム終了時の残りは29人',
      },
      { optionId: '4', text: '主人公が脱落したのは第3ゲーム' },
    ],
  },
  {
    quizId: '498',
    question:
      '月例賞に投稿された『シンジツの教室』、亜城木夢叶の評価が最も低かった項目は？',
    options: [
      { optionId: '0', text: 'キャラクター' },
      { optionId: '1', text: 'オリジナリティ' },
      { optionId: '2', text: 'ストーリー' },
      { optionId: '3', text: '演出力' },
      { optionId: '4', text: '構成力' },
    ],
  },
  {
    quizId: '499',
    question: '次の内、相田班でないのは？',
    options: [
      { optionId: '0', text: '小野寺' },
      { optionId: '1', text: 'キム' },
      { optionId: '2', text: '服部哲' },
      { optionId: '3', text: '港浦' },
      { optionId: '4', text: '小杉' },
    ],
  },
  {
    quizId: '500',
    question: '『シンジツの教室』を投稿した頃、七峰透がしていたバイトは？',
    options: [
      { optionId: '0', text: 'ピザの配達' },
      { optionId: '1', text: 'コンビニの店員' },
      { optionId: '2', text: 'ファミレス' },
      { optionId: '3', text: '大福作りのライン工' },
      { optionId: '4', text: 'ウェブデザイナー' },
    ],
  },
  {
    quizId: '501',
    question:
      '次の内、『シンジツの教室』をブログにUPしたことが、ネットのトップニュース欄に取り上げられた時にあった他記事は？',
    options: [
      { optionId: '0', text: '松好アナやっぱり婚約破棄' },
      { optionId: '1', text: '東北で竜巻発生' },
      { optionId: '2', text: '月9ドラマ 驚異の視聴率30%超' },
      { optionId: '3', text: '熊大量出没注意 分布域拡大' },
      { optionId: '4', text: 'ルーブル美術館 過去最大入場数更新' },
    ],
  },
  {
    quizId: '502',
    question: '次の内、『シンジツの教室』を読んだのが最も遅いのは？',
    options: [
      { optionId: '0', text: '折原一力' },
      { optionId: '1', text: '森屋秀一' },
      { optionId: '2', text: '加藤奈津実' },
      { optionId: '3', text: '真城最高' },
      { optionId: '4', text: '高木秋人' },
    ],
  },
  {
    quizId: '503',
    question:
      '小杉が七峰を連れて亜城木の仕事場へ行った際、小杉は何の仕事を忘れていて相田に呼び戻された？',
    options: [
      { optionId: '0', text: 'プレゼントページ' },
      { optionId: '1', text: '議事録のまとめ' },
      { optionId: '2', text: 'アンケート集計' },
      { optionId: '3', text: '印刷所との打ち合わせ' },
      { optionId: '4', text: '持ち込みの約束' },
    ],
  },
  {
    quizId: '504',
    question:
      '『緊張とそれに伴う気体』についてのネット会議で、「主人公とヒロインの立場逆にした方が良くね？」と提案したのは？',
    options: [
      { optionId: '0', text: 'taka' },
      { optionId: '1', text: 'nobuo' },
      { optionId: '2', text: 'kenchan' },
      { optionId: '3', text: 'haru' },
      { optionId: '4', text: 'SUGI' },
    ],
  },
  {
    quizId: '505',
    question:
      '『緊張とそれに伴う気体』が掲載された2015年35・36合併号の巻頭カラーは？',
    options: [
      { optionId: '0', text: 'トリコ' },
      { optionId: '1', text: 'NARUTO' },
      { optionId: '2', text: 'CROW' },
      { optionId: '3', text: 'ONE PIECE' },
      { optionId: '4', text: 'ロードレーサーGIRI' },
    ],
  },
  {
    quizId: '506',
    question:
      '七峰透が亜城木夢叶にケンカを売ったことを理由に、ネット会議から抜けたのは？',
    options: [
      { optionId: '0', text: 'kk34、nanaco' },
      { optionId: '1', text: 'osaru、cha1' },
      { optionId: '2', text: 'emo、f-u' },
      { optionId: '3', text: 'ituka、Tama' },
      { optionId: '4', text: 'Ta1、sara' },
    ],
  },
  {
    quizId: '507',
    question: '小杉の思う、編集に1番必要なものは？',
    options: [
      { optionId: '0', text: 'マンガを見極める目' },
      { optionId: '1', text: 'マンガを作る力' },
      { optionId: '2', text: '経験' },
      { optionId: '3', text: '作家との協力体制' },
      { optionId: '4', text: '作家に向き合う時間をつくる事' },
    ],
  },
  {
    quizId: '508',
    question:
      '蒼樹紅にフラれたと勘違いして、自宅で酒を飲んでいた平丸、来訪した𠮷田に誰にフラれたと言った？',
    options: [
      { optionId: '0', text: 'ユウコリン' },
      { optionId: '1', text: 'ゆーみん' },
      { optionId: '2', text: 'ゆりっぺ' },
      { optionId: '3', text: 'こにたん' },
      { optionId: '4', text: 'あおたん' },
    ],
  },
  {
    quizId: '509',
    question:
      '蒼樹紅のアシスタントに入った平丸は、女性アシスタントに先生のどこが好きかと聞かれて何と答えた？',
    options: [
      { optionId: '0', text: '顔' },
      { optionId: '1', text: '優しいところ' },
      { optionId: '2', text: '頭いいのに鼻にかけないところ' },
      { optionId: '3', text: '可愛いところ' },
      { optionId: '4', text: '全部' },
    ],
  },
  {
    quizId: '510',
    question:
      'アシスタントの依頼で七峰が秋田に帰っていた中井に電話をした時、中井が飲んでいた居酒屋は？',
    options: [
      { optionId: '0', text: '酒処 よっちゃん' },
      { optionId: '1', text: '酒処 もっちゃん' },
      { optionId: '2', text: '酒処 みっちゃん' },
      { optionId: '3', text: '酒処 かっちゃん' },
      { optionId: '4', text: '酒処 おっちゃん' },
    ],
  },
  {
    quizId: '511',
    question:
      '七峰のアシスタントをしている時、中井が宅配を頼んでいたピザ店は？',
    options: [
      { optionId: '0', text: 'STAR PIZZA' },
      { optionId: '1', text: 'PIZZA-NYA' },
      { optionId: '2', text: "DoReMi's" },
      { optionId: '3', text: 'Pizza Cap' },
      { optionId: '4', text: "Seven's Pizza" },
    ],
  },
  {
    quizId: '512',
    question:
      '大場ネームで、七峰透のアシスタントに入った、見るからにふた廻り太った中井の推定体重は？',
    options: [
      { optionId: '0', text: '170kg' },
      { optionId: '1', text: '120kg' },
      { optionId: '2', text: '140kg' },
      { optionId: '3', text: '150kg' },
      { optionId: '4', text: '200kg' },
    ],
  },
  {
    quizId: '513',
    question:
      'ネット会議で『有意義な学園生活に必要なソレ』が『PCP -完全犯罪党-』がやるネタを先にやるという意見を最初に出したのは？',
    options: [
      { optionId: '0', text: 'devi' },
      { optionId: '1', text: 'cha1' },
      { optionId: '2', text: 'nobuo' },
      { optionId: '3', text: 'take20' },
      { optionId: '4', text: 'right' },
    ],
  },
  {
    quizId: '514',
    question:
      '『有意義な学園生活に必要なソレ』のアシスタントをしている中井が、スーツを着て蒼樹紅の自宅付近へ行った時に、蒼樹紅と平丸がドライブ帰りに指切りしているのを見て、誰をクビにしてやるとぼやいていた？',
    options: [
      { optionId: '0', text: '南田くん、小倉くん' },
      { optionId: '1', text: '中村くん、日高くん' },
      { optionId: '2', text: '北原くん、大久保くん' },
      { optionId: '3', text: '西野くん、黒沢くん' },
      { optionId: '4', text: '東野くん、石原くん' },
    ],
  },
  {
    quizId: '515',
    question:
      '『僕には通じない』の連載が決定した連載会議で、終了が決定した作品は？',
    options: [
      { optionId: '0', text: '妄想使いモシモ' },
      { optionId: '1', text: '有意義な学園生活に必要なソレ' },
      { optionId: '2', text: '奇跡の瞬き' },
      { optionId: '3', text: '恋太&ピース' },
      { optionId: '4', text: '神様がくれた…' },
    ],
  },
  {
    quizId: '516',
    question:
      '『PCP -完全犯罪党-』と『有意義な学園生活に必要なソレ』が同じ号で同じ話をするように小杉が亜城木に頼んだ時に、小杉が服部からことづかってきた言葉は？',
    options: [
      { optionId: '0', text: '差を見せつけてやれ' },
      { optionId: '1', text: '絶対に負けないでくれ' },
      { optionId: '2', text: '間違いを正してやれ' },
      { optionId: '3', text: '気にせず実力を出し切れ' },
      { optionId: '4', text: 'いつも通りにすれば絶対に勝てる' },
    ],
  },
  {
    quizId: '517',
    question:
      '『PCP -完全犯罪党-』、『有意義な学園生活に必要なソレ』が〝生徒会長に圧倒的不利な状況で立候補した生徒を勝たす話〟を同号に載せたのはジャンプは？',
    options: [
      { optionId: '0', text: '2016年5・6合併号' },
      { optionId: '1', text: '2016年4号' },
      { optionId: '2', text: '2016年7号' },
      { optionId: '3', text: '2016年8号' },
      { optionId: '4', text: '2016年9号' },
    ],
  },
  {
    quizId: '518',
    question: 'ネットで意見を求める七峰透のやり方を、高木は一言で何と言った？',
    options: [
      { optionId: '0', text: '船頭多くして船山に登る' },
      { optionId: '1', text: '三人寄れば文殊の知恵' },
      { optionId: '2', text: '蛇の道は蛇' },
      { optionId: '3', text: '舎を道傍に作れば三年にして成らず' },
      { optionId: '4', text: '毒を食らわば皿まで' },
    ],
  },
  {
    quizId: '519',
    question:
      '『有意義な学園生活に必要なソレ』の〝生徒会長に圧倒的不利な状況で立候補した生徒を勝たす話〟についてのネット会議で「選挙当日まで顔を知られないようにしといて実は超美少女」という意見を出したのは？',
    options: [
      { optionId: '0', text: 'SUGI' },
      { optionId: '1', text: 'take20' },
      { optionId: '2', text: 'zebu3' },
      { optionId: '3', text: 'boss' },
      { optionId: '4', text: 'kenchan' },
    ],
  },
  {
    quizId: '520',
    question:
      'シュージンの台詞より問題です。\n「簡単に言うと七峰くんのやり方で週刊連載が上手くいったらアドバイザーは全員賢く忠実な○○で七峰くんは△△……」\n○○、△△に入る言葉は？',
    options: [
      { optionId: '0', text: '天使、神様' },
      { optionId: '1', text: '犬、飼い主' },
      { optionId: '2', text: '手下、天才' },
      { optionId: '3', text: '生徒、先生' },
      { optionId: '4', text: '国民、大統領' },
    ],
  },
  {
    quizId: '521',
    question: '『シンジツの教室』で七峰透が考えた案は？',
    options: [
      { optionId: '0', text: '嘘をつくと殺される' },
      { optionId: '1', text: '食料が与えられるのは1日5人' },
      { optionId: '2', text: '盗難犯人の質問' },
      { optionId: '3', text: '自分とのカクレンボ' },
      { optionId: '4', text: 'ペアでの脱落者の話し合い' },
    ],
  },
  {
    quizId: '522',
    question: '少年マンガには何がもっとあるべきというのが小杉の持論？',
    options: [
      { optionId: '0', text: '〝熱血〟〝泥臭さ〟〝汗臭さ〟' },
      { optionId: '1', text: '〝友情〟〝努力〟〝勝利〟' },
      { optionId: '2', text: '〝冒険〟〝成長〟〝スリル〟' },
      { optionId: '3', text: '〝単純さ〟〝笑い〟〝感動〟' },
      { optionId: '4', text: '〝王道感〟〝爽快感〟〝マンガらしさ〟' },
    ],
  },
  {
    quizId: '523',
    question: '次の内、ドラマ化した作品は？',
    options: [
      { optionId: '0', text: '正義の三肩' },
      { optionId: '1', text: 'PCP -完全犯罪党- -完全犯罪党-' },
      { optionId: '2', text: '僕には通じない' },
      { optionId: '3', text: '青葉の頃' },
      { optionId: '4', text: 'ロードレーサーGIRI' },
    ],
  },
  {
    quizId: '524',
    question:
      '渋谷のハチ公口を出た路上で似顔絵描きをしていた中井は、1枚何円で似顔絵を描いていた？',
    options: [
      { optionId: '0', text: '500円' },
      { optionId: '1', text: '100円' },
      { optionId: '2', text: '300円' },
      { optionId: '3', text: '1000円' },
      { optionId: '4', text: '1500円' },
    ],
  },
  {
    quizId: '525',
    question:
      '渋谷のハチ公口を出た路上で似顔絵描きをしていた中井を誘惑し、賭けをしていた3人組の内、賭けに負けたのは？',
    options: [
      { optionId: '0', text: 'アキ、モエ' },
      { optionId: '1', text: 'ユイ、ミオ' },
      { optionId: '2', text: 'ヨウコ、アヤ' },
      { optionId: '3', text: 'リン、ユキ' },
      { optionId: '4', text: 'ルリ、ノノ' },
    ],
  },
  {
    quizId: '526',
    question: '小学生時代、シュージンが結構好きだった女の子は？',
    options: [
      { optionId: '0', text: '直井いちこ' },
      { optionId: '1', text: '中村かなで' },
      { optionId: '2', text: '立花ゆり' },
      { optionId: '3', text: '日向よう子' },
      { optionId: '4', text: '椎名あや' },
    ],
  },
  {
    quizId: '527',
    question: '小学生時の同級生とのクラス会を、シュージンが欠席した理由は？',
    options: [
      { optionId: '0', text: '香耶が40度近い熱を出したから' },
      { optionId: '1', text: '香耶の父親が病気で倒れたから' },
      { optionId: '2', text: '自分が風邪をひいてしまったから' },
      { optionId: '3', text: '当時の同級生に会うのが恥ずかしいから' },
      { optionId: '4', text: '面倒臭いから' },
    ],
  },
  {
    quizId: '528',
    question: 'サイコーも出席した小学生時のクラス会が行われた場所は？',
    options: [
      { optionId: '0', text: '居酒屋 笑笑' },
      { optionId: '1', text: '居酒屋 千年の宴' },
      { optionId: '2', text: '居酒屋 土間土間' },
      { optionId: '3', text: '居酒屋 金の蔵' },
      { optionId: '4', text: '居酒屋 かまどか' },
    ],
  },
  {
    quizId: '529',
    question: '小学生時の同級生とのクラス会で、新たに計画されていたのは？',
    options: [
      { optionId: '0', text: 'スキー' },
      { optionId: '1', text: '海水浴' },
      { optionId: '2', text: 'バーベキュー' },
      { optionId: '3', text: 'キャンプ' },
      { optionId: '4', text: '温泉旅行' },
    ],
  },
  {
    quizId: '530',
    question:
      '私立中学に進学したヤマちゃん、クラス会に参加したした時に内定を貰っていた就職したい企業No.1の会社は？',
    options: [
      { optionId: '0', text: 'KNN通信' },
      { optionId: '1', text: 'SANY' },
      { optionId: '2', text: 'KOOKLE' },
      { optionId: '3', text: 'SOYODA自動車' },
      { optionId: '4', text: '凜天堂' },
    ],
  },
  {
    quizId: '531',
    question:
      '小学生時の同級生とのクラス会の帰り間際、サイコーがアドレス交換したのは誰？',
    options: [
      { optionId: '0', text: '山下' },
      { optionId: '1', text: '鈴木' },
      { optionId: '2', text: '中島' },
      { optionId: '3', text: '直井' },
      { optionId: '4', text: '和田' },
    ],
  },
  {
    quizId: '532',
    question:
      '『PCP -完全犯罪党-』の模倣犯について、ＴＶでコメントしていた文化育成大学教授は？',
    options: [
      { optionId: '0', text: '出目田金一' },
      { optionId: '1', text: '伊谷那康一' },
      { optionId: '2', text: '樽井米人' },
      { optionId: '3', text: '入田井研一' },
      { optionId: '4', text: '飛土井信一' },
    ],
  },
  {
    quizId: '533',
    question:
      '銀行に侵入した『PCP -完全犯罪党-』の模倣犯についてのニュースで、許可なくコミックスを映したテレビは？',
    options: [
      { optionId: '0', text: 'さくらTV' },
      { optionId: '1', text: 'すみれTV' },
      { optionId: '2', text: 'あやめTV' },
      { optionId: '3', text: 'キンカンTV' },
      { optionId: '4', text: 'みつばTV' },
    ],
  },
  {
    quizId: '534',
    question:
      '『バクマン。』133ページ「励みと想い」の扉絵で先頭を走っているのは？',
    options: [
      { optionId: '0', text: '高木香耶' },
      { optionId: '1', text: '新妻エイジ' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '亜豆美保' },
      { optionId: '4', text: '高木秋人' },
    ],
  },
  {
    quizId: '535',
    question:
      '『バクマン。』133ページ「励みと想い」の扉絵でローラースケートを履いているのは？',
    options: [
      { optionId: '0', text: '新妻エイジ' },
      { optionId: '1', text: '高木香耶' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '亜豆美保' },
      { optionId: '4', text: '高木秋人' },
    ],
  },
  {
    quizId: '536',
    question:
      '『PCP -完全犯罪党-』の模倣犯、二度目の犯行での置き手紙の内容は？',
    options: [
      { optionId: '0', text: '「この金庫に入りました PCP -完全犯罪党-」' },
      { optionId: '1', text: '「侵入した」' },
      { optionId: '2', text: '「私たちの勝ちです」' },
      { optionId: '3', text: '「PCP -完全犯罪党-は最強です」' },
      { optionId: '4', text: '「亜城木夢叶は悪くない」' },
    ],
  },
  {
    quizId: '537',
    question:
      '『PCP -完全犯罪党-』の作中で、皆から教科書を盗んでいた模倣犯は誰？',
    options: [
      { optionId: '0', text: '六塚くん' },
      { optionId: '1', text: '安田くん' },
      { optionId: '2', text: '北村くん' },
      { optionId: '3', text: '高橋くん' },
      { optionId: '4', text: '南くん' },
    ],
  },
  {
    quizId: '538',
    question: '『PCP -完全犯罪党-』で模倣犯を題材にした話は第何話？',
    options: [
      { optionId: '0', text: '99話' },
      { optionId: '1', text: '66話' },
      { optionId: '2', text: '77話' },
      { optionId: '3', text: '88話' },
      { optionId: '4', text: '111話' },
    ],
  },
  {
    quizId: '539',
    question: '次の内、スマートフォンに変えたのが最も早かったのは？',
    options: [
      { optionId: '0', text: '服部哲' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '蒼樹紅' },
      { optionId: '3', text: '亜豆美保' },
      { optionId: '4', text: '高木香耶' },
    ],
  },
  {
    quizId: '540',
    question: '『CROW』の最終回直前、アンケートで連続1位を獲り始めた時は何編？',
    options: [
      { optionId: '0', text: '天空監獄編' },
      { optionId: '1', text: '悪霊騒乱編' },
      { optionId: '2', text: '星空の棲家編' },
      { optionId: '3', text: '幻の大罪編' },
      { optionId: '4', text: '禍々しい神々編' },
    ],
  },
  {
    quizId: '541',
    question:
      'スーパーマンガ家を目指してランニングを始めた中井、1kmくらい走った時点で立ち寄った店は？',
    options: [
      { optionId: '0', text: 'GIGA BURGER' },
      { optionId: '1', text: "WcDonald's" },
      { optionId: '2', text: '𠮷田屋' },
      { optionId: '3', text: 'すすき屋' },
      { optionId: '4', text: 'Mr. Donut' },
    ],
  },
  {
    quizId: '542',
    question:
      '『ロードレーサーGIRI』のアニメ4話で、主人公が隼を抜いた時の技は？',
    options: [
      { optionId: '0', text: 'GIRI必殺三角飛びコーナリング' },
      { optionId: '1', text: 'GIRI必殺直角折コーナリング' },
      { optionId: '2', text: 'GIRI必殺垂直飛びコーナリング' },
      { optionId: '3', text: 'GIRI必殺回転コーナリング' },
      { optionId: '4', text: 'GIRI必殺右曲りコーナリング' },
    ],
  },
  {
    quizId: '543',
    question:
      '『ロードレーサーGIRI』のアニメ4話で、レース中の隼のゼッケン番号は？',
    options: [
      { optionId: '0', text: '43' },
      { optionId: '1', text: '65' },
      { optionId: '2', text: '16' },
      { optionId: '3', text: '29' },
      { optionId: '4', text: '71' },
    ],
  },
  {
    quizId: '544',
    question:
      '新妻エイジの終わらせたい作品について問いただす為に福田組が集合した時、平丸が持っていた手帳の表紙に描かれていた絵は？',
    options: [
      { optionId: '0', text: 'パンダ' },
      { optionId: '1', text: 'ラッコ' },
      { optionId: '2', text: 'ネコ' },
      { optionId: '3', text: 'ヒヨコ' },
      { optionId: '4', text: 'ウサギ' },
    ],
  },
  {
    quizId: '545',
    question:
      '『バクマン。』136ページ「伸びしろと対抗策」の扉絵になかった擬音は？',
    options: [
      { optionId: '0', text: 'キュイィーン' },
      { optionId: '1', text: 'ガキイィーン' },
      { optionId: '2', text: 'ドドド' },
      { optionId: '3', text: 'ゴゴゴ' },
      { optionId: '4', text: 'バキバキ' },
    ],
  },
  {
    quizId: '546',
    question:
      '『CROW』の連続1位での連載終了を阻止するための、『ロードレーサーGIRI』の展開に当てはまらないのは？',
    options: [
      { optionId: '0', text: '新サーキット' },
      { optionId: '1', text: '新キャラ' },
      { optionId: '2', text: '幻のライディングテクニック' },
      { optionId: '3', text: '秘密特訓' },
      { optionId: '4', text: 'ニューマシン' },
    ],
  },
  {
    quizId: '547',
    question:
      '『CROW』が連続で1位を獲り続けたら終了することについての編集部での意見。\n「終わらせるのが作家のため」というのは誰の意見？',
    options: [
      { optionId: '0', text: '山久' },
      { optionId: '1', text: '相田' },
      { optionId: '2', text: '中野' },
      { optionId: '3', text: '𠮷田' },
      { optionId: '4', text: '佐々木' },
    ],
  },
  {
    quizId: '548',
    question:
      '『CROW』が連続で1位を獲り続けたら終了することについての編集部での意見。\n「商業誌に載ってる時点で作品は作家だけのものじゃない」というのは誰の意見？',
    options: [
      { optionId: '0', text: '中野' },
      { optionId: '1', text: '山久' },
      { optionId: '2', text: '相田' },
      { optionId: '3', text: '𠮷田' },
      { optionId: '4', text: '佐々木' },
    ],
  },
  {
    quizId: '549',
    question: '『正義の三肩』の主人公の名前は？',
    options: [
      { optionId: '0', text: 'アキラ' },
      { optionId: '1', text: 'ヒロト' },
      { optionId: '2', text: 'ケイタ' },
      { optionId: '3', text: 'セイジ' },
      { optionId: '4', text: 'カズマ' },
    ],
  },
  {
    quizId: '550',
    question:
      '次の内、新妻エイジの『CROW』終了を阻止するために、アンケート1位を狙っていなかった作家は？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '亜城木夢叶' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '平丸一也' },
      { optionId: '4', text: '高浜翔陽' },
    ],
  },
  {
    quizId: '551',
    question:
      '平丸が1位を獲り『CROW』の終了を阻止出来た時の報酬として、蒼樹にお願いした内容は？',
    options: [
      { optionId: '0', text: '蒼樹に「カズタン」と呼んでもらうこと' },
      { optionId: '1', text: '蒼樹とお茶してもらうこと' },
      { optionId: '2', text: '蒼樹と付き合ってもらうこと' },
      { optionId: '3', text: '蒼樹に同棲してもらうこと' },
      { optionId: '4', text: '蒼樹にひざ枕してもらうこと' },
    ],
  },
  {
    quizId: '552',
    question:
      '次回作のテストとして『PCP -完全犯罪党-』で登場させた、敵か味方か分からない謎のキャラクターは？',
    options: [
      { optionId: '0', text: 'Σ' },
      { optionId: '1', text: 'γ' },
      { optionId: '2', text: 'Δ' },
      { optionId: '3', text: 'Ω' },
      { optionId: '4', text: 'λ' },
    ],
  },
  {
    quizId: '553',
    question: '次の内、スマートフォンに変えたのが最も遅かったのは？',
    options: [
      { optionId: '0', text: '蒼樹紅' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '秋名愛子' },
      { optionId: '3', text: '山久' },
      { optionId: '4', text: '吉田幸司' },
    ],
  },
  {
    quizId: '554',
    question:
      '2016年34号のジャンプに掲載された、『PCP -完全犯罪党-』の仕掛けを施したセンターカラーの絵でマコトの部屋になかった本は？',
    options: [
      { optionId: '0', text: 'オルディプス症候群' },
      { optionId: '1', text: 'モンスターの匣' },
      { optionId: '2', text: '十字加の呪い' },
      { optionId: '3', text: 'ミステリーZ' },
      { optionId: '4', text: '探偵七不思議' },
    ],
  },
  {
    quizId: '555',
    question: '『PCP -完全犯罪党-』でマコト達が通う小学校の開港記念日は？',
    options: [
      { optionId: '0', text: '44751' },
      { optionId: '1', text: '44702' },
      { optionId: '2', text: '44589' },
      { optionId: '3', text: '44809' },
      { optionId: '4', text: '44878' },
    ],
  },
  {
    quizId: '556',
    question: '『PCP -完全犯罪党-』でΣから出された正体状の示す場所は？',
    options: [
      { optionId: '0', text: 'たぬき寺' },
      { optionId: '1', text: 'きつね寺' },
      { optionId: '2', text: 'からす寺' },
      { optionId: '3', text: 'いのしし寺' },
      { optionId: '4', text: 'ねずみ寺' },
    ],
  },
  {
    quizId: '557',
    question: 'シュージンは服部哲のことを携帯電話に何と登録している？',
    options: [
      { optionId: '0', text: 'WJ 服部さん' },
      { optionId: '1', text: '服部 哲' },
      { optionId: '2', text: '集英社 服部哲さん' },
      { optionId: '3', text: '編集部 服部さん' },
      { optionId: '4', text: '服部 哲さん' },
    ],
  },
  {
    quizId: '558',
    question:
      '新妻エイジが『CROW』終了後に描いていた元素記号を使ったヒーローもののマンガ、100ページ程度しか描いていない段階で出ていたキャラは？',
    options: [
      { optionId: '0', text: 'Pt、Ag' },
      { optionId: '1', text: 'Mg、CU' },
      { optionId: '2', text: 'Ni、Fe' },
      { optionId: '3', text: 'Au、Ag' },
      { optionId: '4', text: 'Cu、Fe' },
    ],
  },
  {
    quizId: '559',
    question:
      '『CROW』最終回を描き終えてから、服部雄二郎に「行ってみたいところはないか？」と聞かれ、新妻エイジは何と答えた？',
    options: [
      { optionId: '0', text: 'ルーブル美術館とピラミッドとオーロラみたいです' },
      { optionId: '1', text: 'ないです マンガを描いていたいです' },
      { optionId: '2', text: '富士山と鳥取砂丘と美ら海水族館みたいです' },
      { optionId: '3', text: 'エベレストとサハラ砂漠とカスピ海みたいです' },
      { optionId: '4', text: '三大瀑布と三大図書館と三大陵墓みたいです' },
    ],
  },
  {
    quizId: '560',
    question:
      'CROWの最終回掲載号の目次コメントで新妻エイジにコメントを入れ忘れて、電話で直接労いを伝えたのは？',
    options: [
      { optionId: '0', text: '福田真太' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '蒼樹紅' },
      { optionId: '3', text: '平丸一也' },
      { optionId: '4', text: '高浜翔陽' },
    ],
  },
  {
    quizId: '561',
    question: '森屋秀一が世に出たマンガで1番すごいと思う作品は？',
    options: [
      { optionId: '0', text: '火の鳥' },
      { optionId: '1', text: 'はだしのゲン' },
      { optionId: '2', text: 'ベルサイユのばら' },
      { optionId: '3', text: 'SLAM DUNK' },
      { optionId: '4', text: 'あしたのジョー' },
    ],
  },
  {
    quizId: '562',
    question: '真城最高が世に出たマンガで1番すごいと思う作品は？',
    options: [
      { optionId: '0', text: 'はだしのゲン' },
      { optionId: '1', text: '火の鳥' },
      { optionId: '2', text: 'ベルサイユのばら' },
      { optionId: '3', text: 'SLAM DUNK' },
      { optionId: '4', text: 'あしたのジョー' },
    ],
  },
  {
    quizId: '563',
    question: '『正義の三肩』のドラマが始まる日は？',
    options: [
      { optionId: '0', text: '42651' },
      { optionId: '1', text: '41920' },
      { optionId: '2', text: '42285' },
      { optionId: '3', text: '42193' },
      { optionId: '4', text: '42559' },
    ],
  },
  {
    quizId: '564',
    question:
      '少年ジャンプへの持ち込みの際、東美紀彦が服部哲に「書かなくては駄目でしょうか？」と尋ねたアンケートの項目は？',
    options: [
      { optionId: '0', text: '年齢' },
      { optionId: '1', text: '住所' },
      { optionId: '2', text: '氏名' },
      { optionId: '3', text: '略歴' },
      { optionId: '4', text: '好きなマンガ' },
    ],
  },
  {
    quizId: '565',
    question: '『ぱんちらファイト』より問題です。\n真心モモコのTDアイテムは？',
    options: [
      { optionId: '0', text: '2倍速' },
      { optionId: '1', text: '風' },
      { optionId: '2', text: '透明化' },
      { optionId: '3', text: '筋力倍増' },
      { optionId: '4', text: '復元' },
    ],
  },
  {
    quizId: '566',
    question: '『ぱんちらファイト』より問題です。\n星柳菜緒のTDアイテムは？',
    options: [
      { optionId: '0', text: '風' },
      { optionId: '1', text: '2倍速' },
      { optionId: '2', text: '透明化' },
      { optionId: '3', text: '筋力倍増' },
      { optionId: '4', text: '復元' },
    ],
  },
  {
    quizId: '567',
    question: '『ぱんちらファイト』より問題です。\n星柳菜緒のレベルは？',
    options: [
      { optionId: '0', text: 'レベル34022' },
      { optionId: '1', text: 'レベル68011' },
      { optionId: '2', text: 'レベル14335' },
      { optionId: '3', text: 'レベル86116' },
      { optionId: '4', text: 'レベル73216' },
    ],
  },
  {
    quizId: '568',
    question:
      '『ぱんちらファイト』より問題です。\nパンチラファイト2016が行われるアリーナに設置されている、競技に使うカメラの数は？',
    options: [
      { optionId: '0', text: '48個' },
      { optionId: '1', text: '16個' },
      { optionId: '2', text: '32個' },
      { optionId: '3', text: '64個' },
      { optionId: '4', text: '80個' },
    ],
  },
  {
    quizId: '569',
    question: '『ぱんちらファイト』の主人公は？',
    options: [
      { optionId: '0', text: '真心モモコの弟' },
      { optionId: '1', text: '星柳菜緒の兄' },
      { optionId: '2', text: '真心モモコ' },
      { optionId: '3', text: '星柳菜緒' },
      { optionId: '4', text: '真心モモコの父' },
    ],
  },
  {
    quizId: '570',
    question: '以前、東美紀彦が連載をしていたことのあるマンガ雑誌は？',
    options: [
      { optionId: '0', text: '少年スリー' },
      { optionId: '1', text: '少年ウィーク' },
      { optionId: '2', text: 'ヤングスリー' },
      { optionId: '3', text: 'キャラキラコミック' },
      { optionId: '4', text: '月刊ハッスル' },
    ],
  },
  {
    quizId: '571',
    question: '東美紀彦が以前少年スリーで連載していた作品は？',
    options: [
      { optionId: '0', text: 'LOVE ME どう？' },
      { optionId: '1', text: '恋する惑星(ラブ プラネット)' },
      { optionId: '2', text: '青春学園' },
      { optionId: '3', text: '愛マイな世界' },
      { optionId: '4', text: 'I,my,meで生きてみよー!' },
    ],
  },
  {
    quizId: '572',
    question: '𠮷田の話によると、蒼樹紅の姉の名前は何？',
    options: [
      { optionId: '0', text: '青木恵梨子' },
      { optionId: '1', text: '青木優香子' },
      { optionId: '2', text: '青木佳菜子' },
      { optionId: '3', text: '青木真理子' },
      { optionId: '4', text: '青木芳子' },
    ],
  },
  {
    quizId: '573',
    question: '𠮷田の話による、蒼樹紅と姉の見分け方は？',
    options: [
      { optionId: '0', text: '泣き黒子の位置' },
      { optionId: '1', text: '髪型' },
      { optionId: '2', text: '身長' },
      { optionId: '3', text: '目が一重か二重か' },
      { optionId: '4', text: '声の高さ' },
    ],
  },
  {
    quizId: '574',
    question: 'SHINJITSU.COの作品の内、新井が担当した作品は？',
    options: [
      { optionId: '0', text: 'Tornament & School' },
      { optionId: '1', text: '侍バッターキル' },
      { optionId: '2', text: '時超剣' },
      { optionId: '3', text: '1000億と美少女' },
      { optionId: '4', text: 'ぱんちらファイト' },
    ],
  },
  {
    quizId: '575',
    question:
      '南国先生がSHINJITSU.CO作品をジャンプへ持ち込む以前、野球マンガを連載していた雑誌は？',
    options: [
      { optionId: '0', text: '月刊ハッスル' },
      { optionId: '1', text: '少年キック' },
      { optionId: '2', text: '少年スリー' },
      { optionId: '3', text: '少年ウィーク' },
      { optionId: '4', text: '月刊ジャンプ' },
    ],
  },
  {
    quizId: '576',
    question: '次の内、4大少年誌に含まれない雑誌は？',
    options: [
      { optionId: '0', text: 'ウィーク' },
      { optionId: '1', text: 'ハッスル' },
      { optionId: '2', text: 'キック' },
      { optionId: '3', text: 'スリー' },
      { optionId: '4', text: 'ジャンプ' },
    ],
  },
  {
    quizId: '577',
    question: '次の内、SHINJITSU.COの講師は？',
    options: [
      { optionId: '0', text: '響恭太郎' },
      { optionId: '1', text: '七峰透' },
      { optionId: '2', text: '丸井須賀男' },
      { optionId: '3', text: '間界野昂次' },
      { optionId: '4', text: '中井巧朗' },
    ],
  },
  {
    quizId: '578',
    question: 'SHINJITSU.CO作品を描く以前に、丸井須賀男が連載していた雑誌は？',
    options: [
      { optionId: '0', text: '月刊ハッスル' },
      { optionId: '1', text: '少年スリー' },
      { optionId: '2', text: '少年ウィーク' },
      { optionId: '3', text: '少年キック' },
      { optionId: '4', text: '月刊ジャンプ' },
    ],
  },
  {
    quizId: '579',
    question:
      '『ぱんちらファイト』の短期集中連載が決定したことにより、SHINJITSU.COでモニターをしている高校生の時給はいくら上がった？',
    options: [
      { optionId: '0', text: '30円アップ' },
      { optionId: '1', text: '10円アップ' },
      { optionId: '2', text: '20円アップ' },
      { optionId: '3', text: '40円アップ' },
      { optionId: '4', text: '50円アップ' },
    ],
  },
  {
    quizId: '580',
    question:
      '『ぱんちらファイト』の短期集中連載が決定したことにより、SHINJITSU.COでモニターをしている高校生からのアイディアの買い取りは1000円からいくらに上がった？',
    options: [
      { optionId: '0', text: '2000円' },
      { optionId: '1', text: '1200円' },
      { optionId: '2', text: '1500円' },
      { optionId: '3', text: '1800円' },
      { optionId: '4', text: '2500円' },
    ],
  },
  {
    quizId: '581',
    question: 'SHINJITSU.CO作品、『侍バッターキル』の作者は？',
    options: [
      { optionId: '0', text: '南国' },
      { optionId: '1', text: '丸井須賀男' },
      { optionId: '2', text: '新井貴作' },
      { optionId: '3', text: '八薙シグレ' },
      { optionId: '4', text: '東美紀彦' },
    ],
  },
  {
    quizId: '582',
    question: '七峰透の小学6年生時のクラスは？',
    options: [
      { optionId: '0', text: '6-C' },
      { optionId: '1', text: '6-A' },
      { optionId: '2', text: '6-B' },
      { optionId: '3', text: '44713' },
      { optionId: '4', text: '44714' },
    ],
  },
  {
    quizId: '583',
    question: 'SHINJITSU.COの入っているビルの4階は？',
    options: [
      { optionId: '0', text: 'HIBIKI M.S' },
      { optionId: '1', text: 'SHINJITSU.CO' },
      { optionId: '2', text: 'HIBIKI M.K' },
      { optionId: '3', text: 'SHINJITSU M.S' },
      { optionId: '4', text: 'SHINJITSU M.S' },
    ],
  },
  {
    quizId: '584',
    question:
      'SHINJITSU.COの入っているビルの4階に入っている「HIBIKI M.S」、M.Sは何の略？',
    options: [
      { optionId: '0', text: 'マンガ総合研究所' },
      { optionId: '1', text: 'マンガ製作研究所' },
      { optionId: '2', text: 'マンガ創作研究所' },
      { optionId: '3', text: 'マンガスペシャルラボ' },
      { optionId: '4', text: 'マンガスーパーラボ' },
    ],
  },
  {
    quizId: '585',
    question: 'SHINJITSU.COのモニターの男女比は？',
    options: [
      { optionId: '0', text: '7対3' },
      { optionId: '1', text: '5対5' },
      { optionId: '2', text: '6対4' },
      { optionId: '3', text: '4対6' },
      { optionId: '4', text: '8対2' },
    ],
  },
  {
    quizId: '586',
    question:
      'SHINJITSU.COでの作品を七峰作品とはいえないと言う真城に、七峰は会社のシステムにおける自分を何に例えて説明した？',
    options: [
      { optionId: '0', text: '映画監督' },
      { optionId: '1', text: '主演俳優' },
      { optionId: '2', text: '発明家' },
      { optionId: '3', text: 'プロデューサー' },
      { optionId: '4', text: 'ゴーストライター' },
    ],
  },
  {
    quizId: '587',
    question: '川口たろうの最後の連載作品は？',
    options: [
      { optionId: '0', text: 'ヒーロー残酷物語' },
      { optionId: '1', text: '不良ヒーロー物語' },
      { optionId: '2', text: '続ヒーロー伝説' },
      { optionId: '3', text: 'ヒーロー無用物語' },
      { optionId: '4', text: '残念ヒーロー物語' },
    ],
  },
  {
    quizId: '588',
    question:
      'SHINJITSU.COでの『Tornament & School』の連載用のモニター評価は？',
    options: [
      { optionId: '0', text: '8.9' },
      { optionId: '1', text: '8.2' },
      { optionId: '2', text: '8.7' },
      { optionId: '3', text: '8.1' },
      { optionId: '4', text: '9.3' },
    ],
  },
  {
    quizId: '589',
    question:
      'SHINJITSU.COでの『ぱんちらファイト』の短期集中連載のモニター評価は？',
    options: [
      { optionId: '0', text: '8.2' },
      { optionId: '1', text: '8.9' },
      { optionId: '2', text: '8.7' },
      { optionId: '3', text: '8.1' },
      { optionId: '4', text: '9.3' },
    ],
  },
  {
    quizId: '590',
    question:
      '自室に『超ヒーロー伝説』を右から1巻の順で並べて配置していたのは？',
    options: [
      { optionId: '0', text: '東美紀彦' },
      { optionId: '1', text: '真城最高' },
      { optionId: '2', text: '高木秋人' },
      { optionId: '3', text: '折原一力' },
      { optionId: '4', text: '港浦吾郎' },
    ],
  },
  {
    quizId: '591',
    question:
      '七峰透からのネーム提供が中断されるという電話を、東美紀彦が受けた時にいた場所は？',
    options: [
      { optionId: '0', text: '亜城木の仕事場' },
      { optionId: '1', text: '集英社' },
      { optionId: '2', text: '自宅' },
      { optionId: '3', text: 'ファミレス' },
      { optionId: '4', text: '居酒屋' },
    ],
  },
  {
    quizId: '592',
    question: '次の内、亜城木の仕事場に来たことがないのは？',
    options: [
      { optionId: '0', text: '亜豆美保' },
      { optionId: '1', text: '東美紀彦' },
      { optionId: '2', text: '新妻エイジ' },
      { optionId: '3', text: '七峰透' },
      { optionId: '4', text: '平丸一也' },
    ],
  },
  {
    quizId: '593',
    question: '目の上下にクリップで眠気対策をしていたのは？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '高浜翔陽' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '真城最高' },
      { optionId: '4', text: '高木秋人' },
    ],
  },
  {
    quizId: '594',
    question:
      'シンジツコーポレーションの七峰作品が本誌に載り、戦う事を望んでいないのは？',
    options: [
      { optionId: '0', text: '平丸一也' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '高浜翔陽' },
      { optionId: '3', text: '蒼樹紅' },
      { optionId: '4', text: '亜城木夢叶' },
    ],
  },
  {
    quizId: '595',
    question:
      '『1000億と美少女』で社長の16歳の一人娘の婿を決める大会、書類審査を通ったのは何人？',
    options: [
      { optionId: '0', text: '5万人' },
      { optionId: '1', text: '2千人' },
      { optionId: '2', text: '5千人' },
      { optionId: '3', text: '2万人' },
      { optionId: '4', text: '20万人' },
    ],
  },
  {
    quizId: '596',
    question: '『超ヒーロー伝説』の主人公超ヒーローの兄弟は？',
    options: [
      { optionId: '0', text: '絶ヒーロー' },
      { optionId: '1', text: '神ヒーロー' },
      { optionId: '2', text: '越ヒーロー' },
      { optionId: '3', text: '天ヒーロー' },
      { optionId: '4', text: '魔ヒーロー' },
    ],
  },
  {
    quizId: '597',
    question: '『超ヒーロー伝説』のたっちゃんの父親が死んだ理由は？',
    options: [
      { optionId: '0', text: 'ペットボトルのフタが開けられなかったから' },
      { optionId: '1', text: '腕立てが2回しかできなかったから' },
      { optionId: '2', text: 'ポテトチップの袋が開けられなかったから' },
      { optionId: '3', text: '玄関のドアが開けられなかったから' },
      { optionId: '4', text: '電話を持ち上げられなかったから' },
    ],
  },
  {
    quizId: '598',
    question: '2016年12月24日に真城が亜豆に送ったメールの本文は？',
    options: [
      { optionId: '0', text: 'Merry Christmas' },
      { optionId: '1', text: 'メリークリスマス' },
      { optionId: '2', text: 'メリークリスマス！' },
      { optionId: '3', text: 'Merry Christmas！' },
      { optionId: '4', text: 'ハッピークリスマス！' },
    ],
  },
  {
    quizId: '599',
    question: '小杉が少年誌に1番大切だと思う部分は？',
    options: [
      { optionId: '0', text: 'キャラクターの心' },
      { optionId: '1', text: '爽快感' },
      { optionId: '2', text: '少年らしさ' },
      { optionId: '3', text: 'バトル' },
      { optionId: '4', text: '仲間との絆' },
    ],
  },
  {
    quizId: '600',
    question:
      'SHINJITSU.CO作品の内、読切掲載時のアンケート順位が最も低かったのは？',
    options: [
      { optionId: '0', text: '時超剣' },
      { optionId: '1', text: '1000億と美少女' },
      { optionId: '2', text: '侍バッターキル' },
      { optionId: '3', text: 'Tornament & School' },
      { optionId: '4', text: 'ぱんちらファイト' },
    ],
  },
  {
    quizId: '601',
    question: '歴代編集で立ち上げた連載が1番多いのは？',
    options: [
      { optionId: '0', text: '瓶子吉久' },
      { optionId: '1', text: '相田聡一' },
      { optionId: '2', text: '𠮷田幸司' },
      { optionId: '3', text: '大西恒平' },
      { optionId: '4', text: '佐々木尚' },
    ],
  },
  {
    quizId: '602',
    question: '佐々木編集長と一緒に必勝ジャンプに異動したのは？',
    options: [
      { optionId: '0', text: '中野' },
      { optionId: '1', text: '内田' },
      { optionId: '2', text: '大西' },
      { optionId: '3', text: '小野寺' },
      { optionId: '4', text: '中路' },
    ],
  },
  {
    quizId: '603',
    question:
      '佐々木編集長が必勝ジャンプに異動した事により、週刊少年ジャンプの副編集長になったのは？',
    options: [
      { optionId: '0', text: '相田聡一' },
      { optionId: '1', text: '大西恒平' },
      { optionId: '2', text: '𠮷田幸司' },
      { optionId: '3', text: '服部雄二郎' },
      { optionId: '4', text: '服部哲' },
    ],
  },
  {
    quizId: '604',
    question:
      '『REVERSI』のタイトルを見て「オセロマンガですか？」と言った編集は？',
    options: [
      { optionId: '0', text: '山久雅和' },
      { optionId: '1', text: '港浦吾郎' },
      { optionId: '2', text: '𠮷田幸司' },
      { optionId: '3', text: '大西恒平' },
      { optionId: '4', text: '服部雄二郎' },
    ],
  },
  {
    quizId: '605',
    question: '平丸一也が嫌いなものは？',
    options: [
      { optionId: '0', text: 'ゴキブリ' },
      { optionId: '1', text: '犬' },
      { optionId: '2', text: 'クモ' },
      { optionId: '3', text: '猫' },
      { optionId: '4', text: 'ナメクジ' },
    ],
  },
  {
    quizId: '606',
    question: '『即席12』で亜豆が声優を務めるヒロインの名前は？',
    options: [
      { optionId: '0', text: '眼' },
      { optionId: '1', text: '米' },
      { optionId: '2', text: '叶' },
      { optionId: '3', text: '君' },
      { optionId: '4', text: '剣' },
    ],
  },
  {
    quizId: '607',
    question: '読切の『REVERSI』の獲得票数は？',
    options: [
      { optionId: '0', text: '694票' },
      { optionId: '1', text: '692票' },
      { optionId: '2', text: '573票' },
      { optionId: '3', text: '575票' },
      { optionId: '4', text: '611票' },
    ],
  },
  {
    quizId: '608',
    question: '掲載誌を移った後の『PCP -完全犯罪党-』の担当編集者は？',
    options: [
      { optionId: '0', text: '中野' },
      { optionId: '1', text: '佐々木' },
      { optionId: '2', text: '大西' },
      { optionId: '3', text: '中路' },
      { optionId: '4', text: '片山' },
    ],
  },
  {
    quizId: '609',
    question:
      '『PCP -完全犯罪党-』は中学生編への移行と同時に、週刊少年ジャンプからどの雑誌へ移った？',
    options: [
      { optionId: '0', text: '必勝ジャンプ' },
      { optionId: '1', text: '最強ジャンプ' },
      { optionId: '2', text: '究極ジャンプ' },
      { optionId: '3', text: '完璧ジャンプ' },
      { optionId: '4', text: '極限ジャンプ' },
    ],
  },
  {
    quizId: '610',
    question: '真城最高の母親の名前は？',
    options: [
      { optionId: '0', text: '加代子' },
      { optionId: '1', text: '明子' },
      { optionId: '2', text: '恵美子' },
      { optionId: '3', text: '由紀子' },
      { optionId: '4', text: '尚子' },
    ],
  },
  {
    quizId: '611',
    question:
      '真城最高が祖父から仕事場を買った時に権利書と一緒に渡された真城信弘の日記、最後に記されている93.4.15に何と大きく書かれている？',
    options: [
      { optionId: '0', text: '早く一流のマンガ家にならねば!!' },
      { optionId: '1', text: '夢は叶えるためにある!!' },
      { optionId: '2', text: 'ジャンプの看板作品になってみせる!!' },
      { optionId: '3', text: '俺には才能がある!!' },
      { optionId: '4', text: '絶対に結婚してやる!!' },
    ],
  },
  {
    quizId: '612',
    question:
      '『PCP -完全犯罪党-』の中学編が始まるのは、必勝ジャンプの何月号から？',
    options: [
      { optionId: '0', text: '8月号' },
      { optionId: '1', text: '6月号' },
      { optionId: '2', text: '10月号' },
      { optionId: '3', text: '12月号' },
      { optionId: '4', text: '2月号' },
    ],
  },
  {
    quizId: '613',
    question:
      '『PCP -完全犯罪党-』、『REVERSI』の締切に追われ、小河がヘルプとして連れてきたアシスタントは？',
    options: [
      { optionId: '0', text: '沖野、宮川' },
      { optionId: '1', text: '杉田、中村' },
      { optionId: '2', text: '島﨑、鈴木' },
      { optionId: '3', text: '内山、豊永' },
      { optionId: '4', text: '浅沼、鷲崎' },
    ],
  },
  {
    quizId: '614',
    question: '『ZOMBIE☆GUN』の主人公GUNの双子の兄は？',
    options: [
      { optionId: '0', text: 'JIN' },
      { optionId: '1', text: 'RIM' },
      { optionId: '2', text: 'BUN' },
      { optionId: '3', text: 'AZU' },
      { optionId: '4', text: 'AIZ' },
    ],
  },
  {
    quizId: '615',
    question: '『REVERSI』の「黒悪魔」の読みは？',
    options: [
      { optionId: '0', text: 'シュバルツ' },
      { optionId: '1', text: 'ヴァイス' },
      { optionId: '2', text: 'ブラウ' },
      { optionId: '3', text: 'アッシェファルベ' },
      { optionId: '4', text: 'ズィルバァ' },
    ],
  },
  {
    quizId: '616',
    question:
      '第2回『バクマン。』“マンガ”人気投票結果発表より問題です。\n10位以内に亜城木夢叶の作品は何作品あった？',
    options: [
      { optionId: '0', text: '4作品' },
      { optionId: '1', text: '2作品' },
      { optionId: '2', text: '3作品' },
      { optionId: '3', text: '5作品' },
      { optionId: '4', text: '6作品' },
    ],
  },
  {
    quizId: '617',
    question:
      '第2回『バクマン。』“マンガ”人気投票結果発表より問題です。\n次の内、順位が最も低かったのは？',
    options: [
      { optionId: '0', text: 'KIYOSHI騎士' },
      { optionId: '1', text: '聖ビジュアル女学院高等部' },
      { optionId: '2', text: '恋太&ピース' },
      { optionId: '3', text: '元素記号マンガ' },
      { optionId: '4', text: '超ヒーロー伝説' },
    ],
  },
  {
    quizId: '618',
    question:
      '第2回『バクマン。』“マンガ”人気投票結果発表、応募総数は何通だった？',
    options: [
      { optionId: '0', text: '7363通' },
      { optionId: '1', text: '8109通' },
      { optionId: '2', text: '9735通' },
      { optionId: '3', text: '10647通' },
      { optionId: '4', text: '11380通' },
    ],
  },
  {
    quizId: '619',
    question:
      '𠮷田から平丸に『僕には通じない』のアニメ化決定と同時に伝えられた情報は？',
    options: [
      { optionId: '0', text: '『神様がくれた…』連載終了決定' },
      { optionId: '1', text: '『ラッコ11号』OVA化決定' },
      { optionId: '2', text: '『神様がくれた…』ドラマCD化決定' },
      { optionId: '3', text: '『神様がくれた…』掲載雑誌変更決定' },
      { optionId: '4', text: '『僕には通じない』ゲーム化決定' },
    ],
  },
  {
    quizId: '620',
    question: '𠮷田幸司のプロポーズの台詞は？',
    options: [
      { optionId: '0', text: '一生キミの担当をしたい 夫という名の担当を' },
      {
        optionId: '1',
        text: 'あなたと出会えて本当に良かった 結婚してください',
      },
      { optionId: '2', text: '担当作品がアニメ化したら結婚しよう' },
      { optionId: '3', text: 'いつまでも一緒にいてくれませんか' },
      { optionId: '4', text: '二人で僕たちの未来を描いていきましょう' },
    ],
  },
  {
    quizId: '621',
    question: '平丸が蒼樹紅にプロポーズするために用意した指輪の値段は？',
    options: [
      { optionId: '0', text: '5000万円' },
      { optionId: '1', text: '300万円' },
      { optionId: '2', text: '500万円' },
      { optionId: '3', text: '1000万円' },
      { optionId: '4', text: '3000万円' },
    ],
  },
  {
    quizId: '622',
    question:
      '平丸一也、蒼樹紅が遊園地に行った際に訪れた描写がないアトラクションは？',
    options: [
      { optionId: '0', text: 'メリーゴーラウンド' },
      { optionId: '1', text: 'お化け屋敷' },
      { optionId: '2', text: 'ジェットコースター' },
      { optionId: '3', text: '観覧車' },
      { optionId: '4', text: 'コーヒーカップ' },
    ],
  },
  {
    quizId: '623',
    question: '平丸一也と蒼樹紅が遊園地で食べていたものは？',
    options: [
      { optionId: '0', text: 'ソフトクリーム' },
      { optionId: '1', text: 'アメリカンドッグ' },
      { optionId: '2', text: 'ポップコーン' },
      { optionId: '3', text: 'チェロス' },
      { optionId: '4', text: 'サンドイッチ' },
    ],
  },
  {
    quizId: '624',
    question: '平丸一也に当てはまるのは？',
    options: [
      { optionId: '0', text: '閉所恐怖症' },
      { optionId: '1', text: '高所恐怖症' },
      { optionId: '2', text: '先端恐怖症' },
      { optionId: '3', text: '暗所恐怖症' },
      { optionId: '4', text: '対人恐怖症' },
    ],
  },
  {
    quizId: '625',
    question: '平丸一也のプロポーズの台詞は？',
    options: [
      { optionId: '0', text: '僕を…幸せにしてください' },
      { optionId: '1', text: '蒼樹さん…今すぐ結婚しましょう' },
      { optionId: '2', text: '僕を…結婚させてください' },
      { optionId: '3', text: 'ずっとお味噌汁を作ってください' },
      { optionId: '4', text: 'いつまでも幸せでいてください' },
    ],
  },
  {
    quizId: '626',
    question:
      '平丸一也が遊園地で失くしていた、プロポーズに用意していた指輪はどこで落としていた？',
    options: [
      { optionId: '0', text: 'コーヒーカップ' },
      { optionId: '1', text: 'お化け屋敷' },
      { optionId: '2', text: '絶叫マシーン' },
      { optionId: '3', text: 'フードコート' },
      { optionId: '4', text: 'メリーゴーランド' },
    ],
  },
  {
    quizId: '627',
    question: '『REVERSI』、『ZOMBIE☆GUN』の1巻の初版は共に何万部発行された？',
    options: [
      { optionId: '0', text: '30万部' },
      { optionId: '1', text: '10万部' },
      { optionId: '2', text: '20万部' },
      { optionId: '3', text: '40万部' },
      { optionId: '4', text: '50万部' },
    ],
  },
  {
    quizId: '628',
    question:
      '小河は誰の付き添いとして手塚赤塚二大賞パーティーに参加したことがある？',
    options: [
      { optionId: '0', text: '林' },
      { optionId: '1', text: '亜城木' },
      { optionId: '2', text: '山本' },
      { optionId: '3', text: '梅原' },
      { optionId: '4', text: '遠藤' },
    ],
  },
  {
    quizId: '629',
    question: '亜城木夢叶の出席した手塚赤塚二大賞パーティーが行われた日は？',
    options: [
      { optionId: '0', text: '43080' },
      { optionId: '1', text: '43078' },
      { optionId: '2', text: '43079' },
      { optionId: '3', text: '43081' },
      { optionId: '4', text: '43082' },
    ],
  },
  {
    quizId: '630',
    question:
      '手塚赤塚二大賞パーティーの会場前での待ち合わせで最後に来たのは？',
    options: [
      { optionId: '0', text: '加藤奈津実、北見リリカ' },
      { optionId: '1', text: '高木秋人、香耶' },
      { optionId: '2', text: '折原一力' },
      { optionId: '3', text: '森屋秀一' },
      { optionId: '4', text: '真城最高' },
    ],
  },
  {
    quizId: '631',
    question:
      '手塚赤塚二大賞パーティー等に、出来る限り出席するように心がけているのは誰？',
    options: [
      { optionId: '0', text: '高浜翔陽' },
      { optionId: '1', text: '福田真太' },
      { optionId: '2', text: '平丸一也' },
      { optionId: '3', text: '新妻エイジ' },
      { optionId: '4', text: '亜城木夢叶' },
    ],
  },
  {
    quizId: '632',
    question:
      '亜城木夢叶の出席した手塚赤塚二大賞パーティーのクジ引きの特賞は？',
    options: [
      { optionId: '0', text: 'ブルーレイ内蔵60型3Dテレビ' },
      { optionId: '1', text: 'ディズニーリゾートのペア券' },
      { optionId: '2', text: 'ロンドン・パリ旅行券' },
      { optionId: '3', text: 'ポルシェ' },
      { optionId: '4', text: 'バカラ ローハンデカンタ&ワイングラスセット' },
    ],
  },
  {
    quizId: '633',
    question:
      '手塚赤塚二大賞パーティーで『REVERSI』のアニメ制作に関して、亜城木夢叶に名刺を渡していた制作会社は？',
    options: [
      { optionId: '0', text: 'ANNスタジオ' },
      { optionId: '1', text: 'マクドハウス' },
      { optionId: '2', text: 'A.C.STAFF' },
      { optionId: '3', text: 'GOMZO' },
      { optionId: '4', text: 'スタジオ92' },
    ],
  },
  {
    quizId: '634',
    question: '高木秋人の思う、人生、マンガに1番大切なのは？',
    options: [
      { optionId: '0', text: '努力' },
      { optionId: '1', text: 'うぬぼれ' },
      { optionId: '2', text: '運' },
      { optionId: '3', text: '根性' },
      { optionId: '4', text: '体力' },
    ],
  },
  {
    quizId: '635',
    question:
      '『REVERSI』にアニメの枠を取られるならと、新妻エイジがまず描いた『ZOMBIE☆GUN』のアニメ用のオリジナルネームは何話分？',
    options: [
      { optionId: '0', text: '20話分' },
      { optionId: '1', text: '10話分' },
      { optionId: '2', text: '15話分' },
      { optionId: '3', text: '25話分' },
      { optionId: '4', text: '30話分' },
    ],
  },
  {
    quizId: '636',
    question: '『REVERSI』、黒悪魔の憑いている主人公は？',
    options: [
      { optionId: '0', text: 'サトル' },
      { optionId: '1', text: 'ソラ' },
      { optionId: '2', text: 'イツキ' },
      { optionId: '3', text: 'クロエ' },
      { optionId: '4', text: 'ショウ' },
    ],
  },
  {
    quizId: '637',
    question:
      '『PCP -完全犯罪党-』、『REVERSI』を各巻2冊ずつ所持していたのは？',
    options: [
      { optionId: '0', text: '亜豆美保' },
      { optionId: '1', text: '高木香耶' },
      { optionId: '2', text: '七峰透' },
      { optionId: '3', text: '新妻エイジ' },
      { optionId: '4', text: '服部哲' },
    ],
  },
  {
    quizId: '638',
    question: '背表紙の巻数表記がローマ数字のマンガは？',
    options: [
      { optionId: '0', text: 'PCP -完全犯罪党-' },
      { optionId: '1', text: 'REVERSI' },
      { optionId: '2', text: '疑探偵TRAP' },
      { optionId: '3', text: 'hideout door' },
      { optionId: '4', text: '僕には通じない' },
    ],
  },
  {
    quizId: '639',
    question: '『CROW』、『REVERSI』のアニメ制作会社は？',
    options: [
      { optionId: '0', text: 'スタジオ92' },
      { optionId: '1', text: 'マクドハウス' },
      { optionId: '2', text: 'A.C.STAFF' },
      { optionId: '3', text: 'GOMZO' },
      { optionId: '4', text: 'ANNスタジオ' },
    ],
  },
  {
    quizId: '640',
    question: '『即席12』のミスキック10円貯金で新しく購入したものは？',
    options: [
      { optionId: '0', text: 'ボール' },
      { optionId: '1', text: 'ユニフォーム' },
      { optionId: '2', text: '救急箱' },
      { optionId: '3', text: 'レモン' },
      { optionId: '4', text: 'ボトル' },
    ],
  },
  {
    quizId: '641',
    question: '亜豆美保の交際を記事にしていたのは？',
    options: [
      { optionId: '0', text: '東西スポーツ' },
      { optionId: '1', text: '北信スポーツ' },
      { optionId: '2', text: '一奔スポーツ' },
      { optionId: '3', text: '玉川スポーツ' },
      { optionId: '4', text: '報識スポーツ' },
    ],
  },
  {
    quizId: '642',
    question: '『REVERSI』のアニメ監督は？',
    options: [
      { optionId: '0', text: '江原' },
      { optionId: '1', text: '田宮' },
      { optionId: '2', text: '大林' },
      { optionId: '3', text: '小中' },
      { optionId: '4', text: '後藤' },
    ],
  },
  {
    quizId: '643',
    question: '『ロードレーサーGIRI』のアニメで、淵ギリのCVは？',
    options: [
      { optionId: '0', text: '足立ラン' },
      { optionId: '1', text: '荒川翔一' },
      { optionId: '2', text: '志村亮平' },
      { optionId: '3', text: '立花裕美' },
      { optionId: '4', text: '金光怜' },
    ],
  },
  {
    quizId: '644',
    question: '『ロードレーサーGIRI』のアニメで、淵トバシのCVは？',
    options: [
      { optionId: '0', text: '荒川翔一' },
      { optionId: '1', text: '足立ラン' },
      { optionId: '2', text: '志村亮平' },
      { optionId: '3', text: '立花裕美' },
      { optionId: '4', text: '金光怜' },
    ],
  },
  {
    quizId: '645',
    question: '亜豆美保の所属事務所は？',
    options: [
      { optionId: '0', text: 'プリンスエイト' },
      { optionId: '1', text: 'ハイパー・エキセントリック・シアター' },
      { optionId: '2', text: 'アクセントワン' },
      { optionId: '3', text: '801プロデュース' },
      { optionId: '4', text: '大石事務所' },
    ],
  },
  {
    quizId: '646',
    question:
      'アズキューンナイトでの亜豆美保と聴取者との生電話で、最初に電話をつながれた人は？',
    options: [
      { optionId: '0', text: '匿名希望、22歳、会社員' },
      { optionId: '1', text: 'サラ、18歳、学生' },
      { optionId: '2', text: '真城最高、24歳、マンガ家' },
      { optionId: '3', text: 'カンチ、32歳、無職' },
      { optionId: '4', text: '金村翼、26歳、公務員' },
    ],
  },
  {
    quizId: '647',
    question:
      'アズキューンナイトでの亜豆美保と聴取者との生電話で、サラからされた質問に無かったのは？',
    options: [
      { optionId: '0', text: '寂しくないんですか？' },
      { optionId: '1', text: '今 ラジオで言った事本当ですか？' },
      {
        optionId: '2',
        text: '福田真太先生のメールだけで励まし合ってるっていうのは本当ですか？',
      },
      { optionId: '3', text: '処女ですか？' },
      { optionId: '4', text: 'キスはしてますよね？' },
    ],
  },
  {
    quizId: '648',
    question: '声優である亜豆美保の愛称は？',
    options: [
      { optionId: '0', text: 'アズキュン' },
      { optionId: '1', text: 'あまめん' },
      { optionId: '2', text: 'みぽりん' },
      { optionId: '3', text: 'アーミン' },
      { optionId: '4', text: 'アズっち' },
    ],
  },
  {
    quizId: '649',
    question:
      '真城との交際を発表したアズキューンナイトの放送を聴いていた描写がなかったのは？',
    options: [
      { optionId: '0', text: '服部雄二郎' },
      { optionId: '1', text: '港浦吾郎' },
      { optionId: '2', text: '服部哲' },
      { optionId: '3', text: '亜豆美奈' },
      { optionId: '4', text: '福田真太' },
    ],
  },
  {
    quizId: '650',
    question:
      '真城との交際を告白する前月の声優FANモアでの人気投票で、1位の何多良幹羅の獲得票数は？',
    options: [
      { optionId: '0', text: '1702票' },
      { optionId: '1', text: '1162票' },
      { optionId: '2', text: '781票' },
      { optionId: '3', text: '541票' },
      { optionId: '4', text: '1427票' },
    ],
  },
  {
    quizId: '651',
    question:
      '真城との交際を告白する前月の声優FANモアでの人気投票で4位だったのは？',
    options: [
      { optionId: '0', text: '真島佐黄' },
      { optionId: '1', text: '大月奈々観' },
      { optionId: '2', text: '亜豆美保' },
      { optionId: '3', text: '田中美菅' },
      { optionId: '4', text: '有島秋' },
    ],
  },
  {
    quizId: '652',
    question:
      '真城最高との交際をラジオで告白して後に、亜豆美保に訪れたビタミン水のCM。商品名は？',
    options: [
      { optionId: '0', text: 'サワスイ' },
      { optionId: '1', text: '森のせせらぎ' },
      { optionId: '2', text: 'ビタレモン' },
      { optionId: '3', text: '爽快ビタミン水' },
      { optionId: '4', text: 'クルウォッティ' },
    ],
  },
  {
    quizId: '653',
    question:
      'アニメ『REVERSI』のヒロイン役の公開オーディションをネット配信する際に協力した会社は？',
    options: [
      { optionId: '0', text: 'トゥギャザームービー' },
      { optionId: '1', text: 'ライブストリーム' },
      { optionId: '2', text: 'ガオガオ' },
      { optionId: '3', text: 'アースチャンネル' },
      { optionId: '4', text: 'アヤネット' },
    ],
  },
  {
    quizId: '654',
    question: '大月奈々観の所属事務所は？',
    options: [
      { optionId: '0', text: '大石事務所' },
      { optionId: '1', text: 'プリンスエイト' },
      { optionId: '2', text: 'ハイパー・エキセントリック・シアター' },
      { optionId: '3', text: 'アクセントワン' },
      { optionId: '4', text: '801プロデュース' },
    ],
  },
  {
    quizId: '655',
    question: '『REVERSI』のヒロインキャラの名前は？',
    options: [
      { optionId: '0', text: '水鳥菜保' },
      { optionId: '1', text: '水樹奈菜' },
      { optionId: '2', text: '水原香菜' },
      { optionId: '3', text: '速水菜美' },
      { optionId: '4', text: '来水菜津' },
    ],
  },
  {
    quizId: '656',
    question:
      '『REVERSI』のオーディションを受けた時点での、何多良幹羅の年齢は？',
    options: [
      { optionId: '0', text: '27歳' },
      { optionId: '1', text: '19歳' },
      { optionId: '2', text: '22歳' },
      { optionId: '3', text: '24歳' },
      { optionId: '4', text: '30歳' },
    ],
  },
  {
    quizId: '657',
    question:
      '高木がネットで見ていた『REVERSI』水鳥菜保役 声優模擬投票で1位だったのは？',
    options: [
      { optionId: '0', text: '何多良幹羅' },
      { optionId: '1', text: '大月奈々観' },
      { optionId: '2', text: '田中美菅' },
      { optionId: '3', text: '真島佐黄' },
      { optionId: '4', text: '有島秋' },
    ],
  },
  {
    quizId: '658',
    question:
      '高木がネットで見ていた『REVERSI』水鳥菜保役 声優模擬投票で亜豆美保の順位は？',
    options: [
      { optionId: '0', text: '5位' },
      { optionId: '1', text: '3位' },
      { optionId: '2', text: '7位' },
      { optionId: '3', text: '9位' },
      { optionId: '4', text: '圏外' },
    ],
  },
  {
    quizId: '659',
    question:
      '『REVERSI』の公開オーディション前日に、亜豆美保が妹の美奈から貰ったプレゼントは？',
    options: [
      { optionId: '0', text: '湯島天神の学業守' },
      { optionId: '1', text: '湯島天神の縁結びお守' },
      { optionId: '2', text: '湯島天神の就職お守' },
      { optionId: '3', text: '湯島天神のしあわせ守' },
      { optionId: '4', text: '手作りの合格お守' },
    ],
  },
  {
    quizId: '660',
    question:
      '『REVERSI』の公開オーディション前日の亜豆家の夕飯に無かったものは？',
    options: [
      { optionId: '0', text: 'カツカレー' },
      { optionId: '1', text: 'トンカツ' },
      { optionId: '2', text: 'カツサンド' },
      { optionId: '3', text: 'カツ丼' },
      { optionId: '4', text: 'パスタ' },
    ],
  },
  {
    quizId: '661',
    question: '『REVERSI』の公開オーディションの順番が1番目だったのは？',
    options: [
      { optionId: '0', text: '田中美菅' },
      { optionId: '1', text: '中佳子' },
      { optionId: '2', text: '八木ナキア' },
      { optionId: '3', text: '大月奈々観' },
      { optionId: '4', text: '真島佐黄' },
    ],
  },
  {
    quizId: '662',
    question: '『REVERSI』の公開オーディションの順番が6番目だったのは？',
    options: [
      { optionId: '0', text: '中佳子' },
      { optionId: '1', text: '田中美菅' },
      { optionId: '2', text: '八木ナキア' },
      { optionId: '3', text: '大月奈々観' },
      { optionId: '4', text: '真島佐黄' },
    ],
  },
  {
    quizId: '663',
    question:
      '『REVERSI』の公開オーディションで、亜豆の台本に跡がないことから不正があったのではと音響監督に告発したのは？',
    options: [
      { optionId: '0', text: '山崎' },
      { optionId: '1', text: '木原' },
      { optionId: '2', text: '花江' },
      { optionId: '3', text: '木村' },
      { optionId: '4', text: '神谷' },
    ],
  },
  {
    quizId: '664',
    question: '『REVERSI』の公開オーディションの結果発表日時は？',
    options: [
      { optionId: '0', text: '27日15時' },
      { optionId: '1', text: '27日17時' },
      { optionId: '2', text: '27日19時' },
      { optionId: '3', text: '28日15時' },
      { optionId: '4', text: '28日19時' },
    ],
  },
  {
    quizId: '665',
    question: 'ベテラン声優の郷田、フルネームは？',
    options: [
      { optionId: '0', text: '郷田多可実' },
      { optionId: '1', text: '郷田由紀子' },
      { optionId: '2', text: '郷田浩美' },
      { optionId: '3', text: '郷田久仁子' },
      { optionId: '4', text: '郷田深咲' },
    ],
  },
  {
    quizId: '666',
    question: '『REVERSI』の公開オーディション、応募総数は？',
    options: [
      { optionId: '0', text: '241728票' },
      { optionId: '1', text: '229450票' },
      { optionId: '2', text: '184565票' },
      { optionId: '3', text: '168413票' },
      { optionId: '4', text: '146516票' },
    ],
  },
  {
    quizId: '667',
    question: '『REVERSI』の公開オーディション、亜豆美保の得票数は？',
    options: [
      { optionId: '0', text: '102801票' },
      { optionId: '1', text: '143439票' },
      { optionId: '2', text: '88065票' },
      { optionId: '3', text: '65132票' },
      { optionId: '4', text: '34985票' },
    ],
  },
  {
    quizId: '668',
    question: '『REVERSI』は全何話？',
    options: [
      { optionId: '0', text: '全49話' },
      { optionId: '1', text: '全50話' },
      { optionId: '2', text: '全51話' },
      { optionId: '3', text: '全52話' },
      { optionId: '4', text: '全53話' },
    ],
  },
  {
    quizId: '669',
    question: '『REVERSI』の5,6巻の発売日は？',
    options: [
      { optionId: '0', text: '43315' },
      { optionId: '1', text: '43254' },
      { optionId: '2', text: '43284' },
      { optionId: '3', text: '42981' },
      { optionId: '4', text: '43011' },
    ],
  },
  {
    quizId: '670',
    question: '『REVERSI』の5,6巻、各巻の初版初刷の発行部数は？',
    options: [
      { optionId: '0', text: '92万部' },
      { optionId: '1', text: '63万部' },
      { optionId: '2', text: '74万部' },
      { optionId: '3', text: '105万部' },
      { optionId: '4', text: '250万部' },
    ],
  },
  {
    quizId: '671',
    question: 'アニメ『REVERSI』の後枠は？',
    options: [
      { optionId: '0', text: 'ZOMBIE☆GUN' },
      { optionId: '1', text: '僕には通じない' },
      { optionId: '2', text: '正義の三肩' },
      { optionId: '3', text: '推理屋明智五郎' },
      { optionId: '4', text: '未定' },
    ],
  },
  {
    quizId: '672',
    question: '『＋NATURAL』の担当編集、港浦吾郎の次は誰？',
    options: [
      { optionId: '0', text: '小杉' },
      { optionId: '1', text: '服部哲' },
      { optionId: '2', text: '山久' },
      { optionId: '3', text: 'キム' },
      { optionId: '4', text: '相田' },
    ],
  },
  {
    quizId: '673',
    question: '福田真太とアシスタントが合コンをした相手は？',
    options: [
      { optionId: '0', text: 'CA' },
      { optionId: '1', text: '看護師' },
      { optionId: '2', text: '保育士' },
      { optionId: '3', text: 'モデル' },
      { optionId: '4', text: '声優' },
    ],
  },
  {
    quizId: '674',
    question: '『バクマン。』は全何話？',
    options: [
      { optionId: '0', text: '全176話' },
      { optionId: '1', text: '全178話' },
      { optionId: '2', text: '全181話' },
      { optionId: '3', text: '全183話' },
      { optionId: '4', text: '全185話' },
    ],
  },
  {
    quizId: '675',
    question: '亜豆美保への告白のために真城最高が用意した車は？',
    options: [
      { optionId: '0', text: 'フェラーリ' },
      { optionId: '1', text: 'ポルシェ' },
      { optionId: '2', text: 'ランボルギーニ' },
      { optionId: '3', text: 'ベントレー' },
      { optionId: '4', text: 'ベンツ' },
    ],
  },
  {
    quizId: '676',
    question: '真城最高が亜豆美保にプロポーズした場所は？',
    options: [
      { optionId: '0', text: '谷草の亜豆家前' },
      { optionId: '1', text: '八王子の亜豆家前' },
      { optionId: '2', text: '真城家前' },
      { optionId: '3', text: '亜城木の仕事場前' },
      { optionId: '4', text: 'レストラン' },
    ],
  },
  {
    quizId: '677',
    question: '『ラッコ11号』より問題です。\n第75貝のタイトルは？',
    options: [
      { optionId: '0', text: '日本に𠮷田は多い' },
      { optionId: '1', text: '中国の貝もおいしい' },
      { optionId: '2', text: 'ラッコですがなにか？' },
      { optionId: '3', text: '働けラッコ！' },
      { optionId: '4', text: '就職難もラッコで解決の巻' },
    ],
  },
  {
    quizId: '678',
    question: '『ラッコ11号』より問題です。\nラッコ11号の働いている会社は？',
    options: [
      { optionId: '0', text: '平帆水産株式会社' },
      { optionId: '1', text: '帆立水産株式会社' },
      { optionId: '2', text: '南出水産株式会社' },
      { optionId: '3', text: '栗鴨水産株式会社' },
      { optionId: '4', text: '宝正水産株式会社' },
    ],
  },
  {
    quizId: '679',
    question:
      '『ラッコ11号』より問題です。\n平帆水産株式会社におけるラッコ11号の役職は？',
    options: [
      { optionId: '0', text: '第一宣伝部部長' },
      { optionId: '1', text: '第一企画部部長' },
      { optionId: '2', text: '第一冷凍食品部部長' },
      { optionId: '3', text: '第一販売促進部部長' },
      { optionId: '4', text: '第一加工食品部部長' },
    ],
  },
  {
    quizId: '680',
    question:
      '『ラッコ11号』より問題です。\nラッコ11号が平帆水産株式会社に就職する際の履歴書で使った偽名は？',
    options: [
      { optionId: '0', text: '鈴木太郎' },
      { optionId: '1', text: '山田次郎' },
      { optionId: '2', text: '青木一也' },
      { optionId: '3', text: '貝田海男' },
      { optionId: '4', text: '浜田グリコ' },
    ],
  },
  {
    quizId: '681',
    question:
      '『ラッコ11号』より問題です。\nラッコ11号が平帆水産株式会社に就職する際の履歴書に記載した学歴は？',
    options: [
      { optionId: '0', text: '東日本水産大学卒' },
      { optionId: '1', text: '東京大学卒' },
      { optionId: '2', text: '日本大海大学卒' },
      { optionId: '3', text: '帆澄野大学卒' },
      { optionId: '4', text: '青井海野大学卒' },
    ],
  },
  {
    quizId: '682',
    question:
      '『ラッコ11号』より問題です。\nラッコ11号が住みよい社会にしようと悪をこらしめてきた結果は？',
    options: [
      { optionId: '0', text: '懲役2年 執行猶予3年' },
      { optionId: '1', text: '懲役2年 執行猶予4年' },
      { optionId: '2', text: '懲役3年 執行猶予4年' },
      { optionId: '3', text: '懲役3年 執行猶予5年' },
      { optionId: '4', text: '人体実験' },
    ],
  },
  {
    quizId: '683',
    question:
      '『ラッコ11号』より問題です。\n平帆水産株式会社の売上の内、57%を占めているのは？',
    options: [
      { optionId: '0', text: 'ハマグリ' },
      { optionId: '1', text: 'マグロ' },
      { optionId: '2', text: 'イカ' },
      { optionId: '3', text: 'エビ' },
      { optionId: '4', text: 'チクワ' },
    ],
  },
  {
    quizId: '684',
    question: 'ラッコ11号が言う仕事に当てはまらないのは？',
    options: [
      {
        optionId: '0',
        text: '早く定時にならないかと何度も時計を見るのが仕事！',
      },
      {
        optionId: '1',
        text: '遊んで暮らせないから生活のためにイヤイヤやるのが仕事!!',
      },
      { optionId: '2', text: '休みたくても仕方ないのが仕事！' },
      { optionId: '3', text: '日曜に笑点が始まった時憂鬱になるのが仕事！' },
      { optionId: '4', text: '朝起きて行きたくねーって思うのが仕事！' },
    ],
  },
  {
    quizId: '685',
    question: 'ラッコ11号が肘から下を切り落としてもらうために訪れた病院は？',
    options: [
      { optionId: '0', text: 'SEK病院' },
      { optionId: '1', text: '帆立病院' },
      { optionId: '2', text: 'ラッコ専門動物病院' },
      { optionId: '3', text: '𠮷田病院' },
      { optionId: '4', text: '桑原外科医院' },
    ],
  },
  {
    quizId: '686',
    question:
      '次の内、『バクマン。』の表紙に真城最高、高木秋人の二人組で描かれていない巻は？',
    options: [
      { optionId: '0', text: '8巻' },
      { optionId: '1', text: '2巻' },
      { optionId: '2', text: '6巻' },
      { optionId: '3', text: '7巻' },
      { optionId: '4', text: '10巻' },
    ],
  },
  {
    quizId: '687',
    question: '『バクマン。』7巻の表紙に描かれている場所は？',
    options: [
      { optionId: '0', text: 'ファミレス' },
      { optionId: '1', text: '集英社前' },
      { optionId: '2', text: '福田真太 仕事場' },
      { optionId: '3', text: '亜城木夢叶 仕事場' },
      { optionId: '4', text: '書店' },
    ],
  },
  {
    quizId: '688',
    question: '唯一表紙から裏表紙まで絵が続いている巻は？',
    options: [
      { optionId: '0', text: '16巻' },
      { optionId: '1', text: '7巻' },
      { optionId: '2', text: '11巻' },
      { optionId: '3', text: '18巻' },
      { optionId: '4', text: '20巻' },
    ],
  },
  {
    quizId: '689',
    question: '『バクマン。』20巻の表紙に描かれていなかったのは？',
    options: [
      { optionId: '0', text: '港浦吾郎' },
      { optionId: '1', text: '服部哲' },
      { optionId: '2', text: '服部雄二郎' },
      { optionId: '3', text: '𠮷田幸司' },
      { optionId: '4', text: '佐々木尚' },
    ],
  },
  {
    quizId: '690',
    question: '『バクマン。』20巻の表紙に描かれていなかったのは？',
    options: [
      { optionId: '0', text: '静河流' },
      { optionId: '1', text: '岩瀬愛子' },
      { optionId: '2', text: '白鳥シュン' },
      { optionId: '3', text: '中井巧朗' },
      { optionId: '4', text: '七峰透' },
    ],
  },
  {
    quizId: '691',
    question: '次の内、背表紙に複数回描かれているのは？',
    options: [
      { optionId: '0', text: '亜豆美保' },
      { optionId: '1', text: '見吉香耶(高木香耶)' },
      { optionId: '2', text: '福田真太' },
      { optionId: '3', text: '平丸一也' },
      { optionId: '4', text: '蒼樹紅' },
    ],
  },
  {
    quizId: '692',
    question: '福田真太とアシスタントがよく食べているカップ麺は？',
    options: [
      { optionId: '0', text: 'がっつりとんこつ' },
      { optionId: '1', text: 'とんこつ王' },
      { optionId: '2', text: '煮干しとんこつ' },
      { optionId: '3', text: 'キムチとんこつラーメン' },
      { optionId: '4', text: '達人のとんこつ' },
    ],
  },
  {
    quizId: '693',
    question: '次の内、第1話の順位が最も低かったのは？',
    options: [
      { optionId: '0', text: '有意義な学園生活に必要なソレ' },
      { optionId: '1', text: '神様がくれた…' },
      { optionId: '2', text: 'ロードレーサーGIRI' },
      { optionId: '3', text: '青葉の頃' },
      { optionId: '4', text: 'ラッコ11号' },
    ],
  },
  {
    quizId: '694',
    question: '次の内、第1話の順位が最も低かったのは？',
    options: [
      { optionId: '0', text: '#NAME?' },
      { optionId: '1', text: '疑探偵TRAP' },
      { optionId: '2', text: '恋太&ピース' },
      { optionId: '3', text: 'NANDE!!' },
      { optionId: '4', text: '正義の三肩' },
    ],
  },
  {
    quizId: '695',
    question: '次の内、手塚賞の準入選となった作品は？',
    options: [
      { optionId: '0', text: 'カラフジカル' },
      { optionId: '1', text: 'ジャガライダー' },
      { optionId: '2', text: '虚人街放浪' },
      { optionId: '3', text: 'ドーピングマン' },
      { optionId: '4', text: 'ガレリアン' },
    ],
  },
  {
    quizId: '696',
    question: '次の内、手塚賞の佳作となった作品は？',
    options: [
      { optionId: '0', text: 'ガレリアン' },
      { optionId: '1', text: 'ジャガライダー' },
      { optionId: '2', text: '虚人街放浪' },
      { optionId: '3', text: 'ドーピングマン' },
      { optionId: '4', text: 'カラフジカル' },
    ],
  },
  {
    quizId: '697',
    question: '次の内、月例賞の準入選となった作品は？',
    options: [
      { optionId: '0', text: 'Business Boy ケンイチ' },
      { optionId: '1', text: 'ラッコ11号' },
      { optionId: '2', text: 'とどめの6発' },
      { optionId: '3', text: '血染めの卓球' },
      { optionId: '4', text: '斜本' },
    ],
  },
  {
    quizId: '698',
    question: '赤マルジャンプに読切掲載されていない作品は？',
    options: [
      { optionId: '0', text: '恋太&ピース' },
      { optionId: '1', text: 'やる気なヤンキー' },
      { optionId: '2', text: '青葉の頃' },
      { optionId: '3', text: '走れ！大発タント' },
      { optionId: '4', text: 'CROW' },
    ],
  },
  {
    quizId: '699',
    question: '次の内、本名なのはどれ？',
    options: [
      { optionId: '0', text: '八本木八郎' },
      { optionId: '1', text: '秋名愛子' },
      { optionId: '2', text: '蒼樹紅' },
      { optionId: '3', text: '川口たろう' },
      { optionId: '4', text: '響恭太郎' },
    ],
  },
  {
    quizId: '700',
    question:
      '次の内、作品と作者の組み合わせが間違っているものは？\n(作品名 、 作者名)',
    options: [
      { optionId: '0', text: '奇跡の瞬き 、 鈴木緑' },
      { optionId: '1', text: 'スペース・イエロー・ゲート 、 柳原哲也' },
      { optionId: '2', text: 'I am ジャンプキング 、 南明奈' },
      { optionId: '3', text: '黒帯ナイン!! 、 平井善之' },
      { optionId: '4', text: '美味しい餃子の作り方 、 日野肉味' },
    ],
  },
  {
    quizId: '701',
    question:
      '『バクマン。』のカバー表紙とカバー裏表紙で一番変化の大きな巻は？',
    options: [
      { optionId: '0', text: '19巻' },
      { optionId: '1', text: '2巻' },
      { optionId: '2', text: '8巻' },
      { optionId: '3', text: '13巻' },
      { optionId: '4', text: '16巻' },
    ],
  },
];
